export const enLangDashboard = {
  updatePrompt: {
    title: 'Update ready',
    message: 'Reload to use the latest version. Unsaved work on this screen may be lost.',
    action: 'Reload now',
  },
  headerSearch: {
    placeholder: 'Search products',
    cancel: 'Cancel',
    empty: 'No products found',
    noShop: 'No products to search yet',
  },
  adminUi: {
    podcastEnterShowTitle: 'Enter the show title',
    podcastMaximum: 'Maximum',
    podcastCharacters: 'characters',
    podcastShowTitleExists: 'A show with this title already exists',
    podcastEditShow: 'Edit show',
    podcastNewShow: 'New show',
    podcastCover: 'Cover',
    podcastTitle: 'Title',
    podcastShowTitlePlaceholder: 'Show title',
    podcastCategory: 'Category',
    podcastCategoryPlaceholder: 'e.g. True Crime',
    podcastDescription: 'Description',
    podcastDescriptionPlaceholder: 'What is this show about…',
    podcastSubscribeButtons: '“Subscribe” buttons',
    podcastAddPlatform: 'Add platform',
    podcastSave: 'Save',
    podcastCreate: 'Create',
    episodeOne: 'episode',
    episodeFew: 'episodes',
    episodeMany: 'episodes',
    edit: 'Edit',
    delete: 'delete',
    addShow: 'Add show',
    importFromRss: 'Import from RSS',
    importFromRssFeed: 'Import from RSS feed',
    importFromRssHint: 'Paste a podcast RSS link — episodes will be pulled in automatically into a new show.',
    import: 'Import',
    trackWordOne: 'track',
    trackWordFew: 'tracks',
    trackWordMany: 'tracks',
    albumLabel: 'Album',
    pause: 'Pause',
    play: 'Play',
    emptyTracks: 'No tracks in this album yet',
    untitled: 'Untitled',
    show: 'Show',
    audioFileNotAttached: 'Audio file not attached',
    paypalConnectionTitle: 'Choose PayPal connection method',
    paypalConnectionSubtitle: 'Select the most convenient connection method for you',
    paypalRecommendedBadge: 'Recommended',
    paypalPartnerTitle: 'Via PayPal Partner',
    paypalPartnerFeatureQuickConnect: 'Quick connection in 1 click',
    paypalPartnerFeatureAutoTokens: 'Automatic token refresh',
    paypalPartnerFeatureMostSecure: 'Most secure method',
    paypalPartnerFeatureNoApiKeys: 'No need to copy API keys',
    paypalPartnerButton: 'Connect via Partner',
    paypalDirectTitle: 'Directly (API Credentials)',
    paypalDirectFeatureClientIdSecret: 'Requires Client ID and Secret',
    paypalDirectFeatureManualSetup: 'Manual setup',
    paypalDirectFeatureFullControl: 'Full control over the API',
    paypalDirectFeatureAdvancedUsers: 'For advanced users',
    paypalDirectButton: 'Connect directly',
    clientIdRequired: 'Client ID is a required field',
    clientSecretRequired: 'Client Secret is a required field',
    invalidPaypalCredentials: 'Invalid PayPal credentials',
    connectPaypalDirectly: 'Connect PayPal directly',
    paypalConnectedSuccessfully: 'PayPal connected successfully!',
    yourPaypalClientId: 'Your PayPal Client ID from Dashboard',
    yourPaypalClientSecret: 'Your PayPal Client Secret from Dashboard',
    chooseOperatingMode: 'Choose operating mode',
    sandboxTest: 'Sandbox (Test)',
    liveProduction: 'Live (Production)',
    whereToFindCredentials: '💡 Where to find credentials?',
    goTo: 'Go to',
    createOrSelectApp: 'Create a new App or select an existing one',
    copyClientIdAndSecret: 'Copy the Client ID and Secret',
    cancel: 'Cancel',
    connected: 'Connected!',
    connect: 'Connect',
    monobankTokenTooltip: 'Token from Monobank Business Acquiring',
    monobankTokenPlaceholder: 'Enter Monobank token',
    whereToGetToken: 'Where to get the token?',
    statusChangedTo: 'Status changed to',
    all: 'All',
    loading: 'Loading...',
    noBookingsYet: 'No bookings yet',
    noBookingsWithStatus: 'No bookings with this status',
    nightsAbbr: 'nights',
    uah: 'UAH',
    oneNightDeposit: 'One night deposit',
    fullPrepayment: 'Full prepayment',
    online: 'Online',
    confirm: 'Confirm',
    complete: 'Complete',
    restore: 'Restore',
    bookingCalendarBooked: 'Booked',
    bookingCalendarBlockedManually: 'Blocked manually',
    bookingCalendarAvailable: 'Available',
    bookingCalendarNoSettings: 'No settings',
    bookingCalendarSaveItemFirst: 'Save item first',
    bookingCalendarLoading: 'Loading...',
    bookingCalendarBlocked: 'Blocked',
    bookingCalendarSelected: 'Selected',
    bookingCalendarSelectedDates: 'Selected dates',
    bookingCalendarPricePerDay: 'Price/day',
    bookingCalendarOpen: 'Open',
    bookingCalendarBlock: 'Block',
    bookingCalendarCancel: 'Cancel',
    responseDeleted: 'Response deleted',
    deleteAllConfirm: 'Delete all responses? This action cannot be undone.',
    allResponsesDeleted: 'All responses deleted',
    responseOne: 'response',
    responseFew: 'responses',
    responseMany: 'responses',
    deleteAll: 'Delete all',
    allForms: 'All forms',
    noResponsesYet: 'No responses yet',
    fieldName: 'Name',
    fieldPhone: 'Phone',
    fieldAddress: 'Address',
    fieldComment: 'Comment',
    customFields: 'Additional fields',
    more: 'More',
    view: 'View',
    track: 'Track',
    showing: 'Showing',
    of: 'of',
    ordersLower: 'orders',
    ordersEmpty: 'No records yet',
    ordersCountLabel: 'records',
    ordersName: 'Name',
    ordersPhone: 'Phone',
    ordersLoading: 'Loading...',
    ordersComment: 'Comment',
    ordersPayment: 'Payment',
    ordersPrev: 'Previous',
    ordersNext: 'Next',
    revokeAccessConfirm: 'Revoke access?',
    accessRevoked: 'Access revoked',
    activeGrants: 'active grants',
    noActiveGrants: 'No active grants',
    type: 'Type',
    grantedBy: 'Granted by',
    started: 'Started',
    until: 'Until',
    revoke: 'Revoke',
    deleted: 'Deleted',
    subscribers: 'subscribers',
    noSubscribersYet: 'No subscribers yet',
    phone: 'Phone',
    name: 'Name',
    step: 'Step',
    done: 'done',
    stepFailedSingular: 'step failed',
    stepFailedPlural: 'steps failed',
    done2: 'Done.',
    actionFailed: 'Failed to perform the action.',
    starterCoffeeSite: 'Make a website for a coffee shop',
    starterFaq: 'Add a FAQ block with 5 questions',
    starterTranslate: 'Translate the whole site into English',
    starterBrandColors: 'Pick colors matching my brand',
    stopped: 'Stopped.',
    scopeSite: 'Site',
    scopePage: 'Page',
    followUpAddPhoto: 'Add one more photo',
    followUpAddQuestion: 'Add another question',
    followUpAddPlan: 'Add another pricing plan',
    followUpAddService: 'Add another service',
    followUpAddBlock: 'Add one more block',
    followUpMakeBetter: 'Make it even better',
    followUpTweakColors: 'Tweak the colors to match my brand',
    followUpChangeColors: 'Change colors',
    followUpTranslateEnglish: 'Translate into English',
    undoneDeletedPrefix: 'Undone — removed',
    undoneOf: 'of',
    undoneCreatedBlocks: 'created blocks',
    planAnalyzing: 'Analyzing the request',
    planCheckingSite: 'Checking the site state',
    planChoosingBlocks: 'Choosing blocks',
    planPreparing: 'Preparing the plan',
    hideDetails: 'Hide details',
    details: 'Details',
    emptyStateTitle: 'How can I help?',
    emptyStateSubtitle: 'Describe what to do — or pick an example below',
    undoing: 'Undoing…',
    undo: 'Undo',
    blockSingular: 'block',
    blockPlural: 'blocks',
    usageCostTitle: 'Cost of this request',
    tokens: 'tokens',
    stop: 'Stop',
    scopeSiteTitle: 'Changes across the whole site',
    scopePageTitle: 'Changes only on the current page',
    customDesign: 'Custom design',
    appointmentEmbedTitle: 'Embed URL',
    appointmentEmbedSubtitle: 'Embed Calendly as inline iframe',
    appointmentEmbedCaption: 'Calendly URL',
    appointmentEmbedTooltip: 'Paste your Calendly event URL (e.g. https://calendly.com/you/30min)',
    appointmentEmbedInvalid: 'Enter a valid Calendly URL (e.g. https://calendly.com/you/30min)',
  },
  ama: {
    questions: 'questions',
    all: 'All',
    unanswered: 'Unanswered',
    answered: 'Answered',
    loading: 'Loading...',
    noQuestions: 'No questions yet',
    anonymous: 'Anonymous',
    noName: 'No name',
    yourAnswer: 'Your answer',
    edit: 'Edit',
    delete: 'Delete',
    cancel: 'Cancel',
    enterAnswer: 'Enter your answer...',
    saveAnswer: 'Save answer',
    confirmDelete: 'Delete this question?',
    answerSaved: 'Answer saved',
    deleted: 'Deleted',
    templateFields: 'Template fields',
    category: 'Category',
    categoryPlaceholder: 'e.g. Paper',
    categoryHint: 'The chip this answer sits under in the Categories template.',
    askCount: 'People who asked this',
    askCountHint: 'What the Popular questions template ranks by. Leave empty to show no number.',
    photo: 'Photo',
    photoHint: 'Shown by the "Question with photo" template.',
    replies: 'Replies',
    repliesHint: 'The conversation under your answer, in the Thread template. Leave the name empty to post as yourself.',
    replyPlaceholder: 'Add a reply',
    replyAuthorPlaceholder: 'Name (optional)',
    you: 'You',
    post: 'Post',
  },
  adsManager: {
    estimatedAudience: 'Estimated audience size',
    audienceTooLarge: 'Your audience is very broad — consider narrowing it.',
    audienceTooNarrow: 'Your audience is very small — consider broadening it.',
    audience: 'Audience',
    suggestedAudience: 'Use suggested audience',
    suggestedAudienceHint: 'Broad targeting, best for reach',
    buildYourOwn: 'Build your own',
    buildYourOwnHint: 'Set age, gender and countries',
    expectedViewers: 'Expected ad viewers',
    totalBudget: 'Total campaign budget',
    duration: 'Duration',
    days: 'days',
    advancedSchedule: 'Advanced schedule',
    hideAdvanced: 'Hide advanced schedule',
    adPreview: 'Ad preview',
    sponsored: 'Sponsored',
    seeMore: 'See more',
    learnMore: 'Learn More',
    yourPage: 'Your Page',
  },
  pinnedDock: {
    title: 'Pinned blocks',
    label: 'PINNED',
    expand: 'Expand pinned blocks',
    collapse: 'Collapse pinned blocks',
  },
  reviewButton: {
    title: 'Leave a review button',
    desc: 'Show a button under the reviews that links visitors to where they can leave a review.',
    buttonText: 'Button text',
    link: 'Link',
    leaveReview: 'Leave a review',
    googleHint: 'Leave empty to use your Google reviews page.',
    design: 'Button design',
    background: 'Background',
    textColor: 'Text',
  },
  common: {
    elements: 'Elements',
    of: 'of',
    itemsLower: 'items',
    extraContent: 'Extra content',
    you: 'You',
    post: 'Post',
    article: 'Article',
    create: 'Create',
    message: 'Message',
    popular: 'Popular',
    emptyIntegrations: 'You need to add integrations first',
    categories: 'Categories',
    edit: 'Edit',
    share: 'Share',
    plan: 'Plan',
    sort: 'Sort',
    addArticle: 'Add article',
    articles: 'Articles',
    users: 'users',
    scans: 'scans',
    clicks: 'clicks',
    copy: 'Copy',
    customize: 'Customize',
    link: 'link',
    save: 'Save',
    uploadFile: 'Upload File',
    customImage: 'Custom Image',
    customImageTooltip: 'Upload custom image',
    size: 'Size',
    sizeTooltip: 'Drag slider to set size',
    auto: 'Auto',
    rectangle: 'Rectangle',
    custom: 'Custom',
    clean: 'Clean',
    cleaning: 'Cleaning',
    download: 'Download',
    downloading: 'Downloading',
    preview: 'PREVIEW',
    cover: 'Cover',
    coverTooltip: 'Upload a cover photo',
    title: 'Title',
    new: 'New',
    pro: 'Pro',
    free: 'Free',
    limit: 'Limit',
    websites: 'websites',
    site: 'Site',
    apiKey: 'API Key',
    name: 'Name',
    passwordChange: 'Password change',
    draft: 'Draft',
    page: 'Page',
    areYouSure: 'Are you sure?',
    drop: 'Drop',
    video: 'video',
    image: 'image',
    chooseFile: 'Choose file',
    nothingFound: 'Nothing Found',
    enterCorrectLink: 'Enter correct link',
    off: 'Off',
    disconnect: 'DISCONNECT',
    connect: 'CONNECT',
    copied: 'Copied',
    saved: 'Saved',
    lostConnection: 'Lost connection',
    addedCategory: 'Added category',
    none: 'None',
    left: 'Left',
    right: 'Right',
    thin: 'Thin',
    solid: 'Solid',
    double: 'Double',
    welcome: 'Welcome',
    category: 'Category',
    product: 'Product',
    website: 'Website',
    items: 'Items',
    square: 'Square',
    round: 'Round',
    border: 'Border',
    shadow: 'Shadow',
    subtle: 'Subtle',
    soft: 'Soft',
    hard: 'Hard',
    block: 'Block',
    primary: 'Primary',
    additional: 'Additional',
    normal: 'Normal',
    bold: 'Bold',
    uploadVideo: 'Upload video',
    compact: 'Compact',
    card: 'Card',
    top: 'Top',
    center: 'Center',
    bottom: 'Bottom',
    button: 'Button',
    addNewItem: 'Add new item',
    blockEmptyTitle: 'Nothing here yet',
    blockEmptyText: 'This block has no items yet. Add one to see it on your page.',
    noItemsTitle: `You don't have any items yet`,
    noItemsText: 'Add your first item to fill this block.',
    price: 'Price',
    priceCaption: 'Add price of your product',
    oldPrice: 'Old price',
    oldPriceCaption: 'Old price will be strikethrough',
    areYouSureDeleteItem: 'Are you sure you want to remove this item?',
    add: 'Add',
    active: 'Active',
    isActive: 'is active',
    isDisabled: 'is disabled',
    uploadImage: 'Upload image',
    design: 'Design',
    addAccount: 'Add account',
    hey: 'Hey',
    activeBackground: 'Active background',
    activeText: 'Active text',
    connectDomain: 'Connect Domain',
    shortLink: 'Short Link',
    appearanceSaved: 'Appearance saved!',
    blockAdded: 'Block added!',
    comingSoon: 'Coming soon',
    easyMoney: 'Easy money',
    content: 'Content',
    audience: 'Audience',
    view: 'View',
    delete: 'Delete',
    file: 'File',
    type: 'Type',
    from: 'From',
    to: 'To',
    fullName: 'Full name',
    lastTimeUsed: 'Last time used',
    noMediaFiles: 'No media files yet...',
    withdraw: 'Withdraw',
    congrats: 'Congrats!',
    makeMoneyOnline: 'Make money online!',
  },
  sort: {
    title: 'Sort',
    search: 'Search',
    default: 'Default sorting',
    dateNew: 'Date: Newest to Oldest',
    dateOld: 'Date: Oldest to Newest',
    priceLow: 'Price: Low to High',
    priceHigh: 'Price: High to Low',
    nameA: 'Name: A to Z',
    nameZ: 'Name: Z to A',
    popular: 'Most popular',
  },
  emailMenu: {
    broadcasts: 'Broadcasts',
    automations: 'Automations',
    templates: 'Templates',
    log: 'Logs',
    settings: 'Settings',
    noEmails: 'No broadcasts yet',
    newBroadcast: 'New Broadcast',
  },
  automations: {
    newAutomation: 'New Automation',
    chooseTemplate: 'Choose a template or start from scratch',
    startFromScratch: 'Start from scratch',
    startFromScratchDesc: 'Build your own automation with full freedom over every step.',
    forAdvanced: 'For advanced users',
    create: 'Create',
    useTemplate: 'Use Template',
    creating: 'Creating…',
    steps: 'steps',
    noAutomations: 'No automations yet',
    noAutomationsDesc: 'Create your first automation or start from a template',
    createAutomation: 'Create Automation',
    newAutomationBtn: '+ New Automation',
    templates: {
      welcome: {
        name: 'Welcome Series',
        badge: 'Most popular',
        description: 'New subscribers receive 2 emails: one immediately and one the next day.',
        triggerName: 'New subscriber',
        step_email1: 'Email #1 — Welcome',
        step_subject1: "Welcome! Here's what we prepared for you",
        step_delay1: 'Wait 1 day',
        step_email2: 'Email #2 — Helpful content',
        step_subject2: "Here's where to start",
      },
      abandonedCart: {
        name: 'Abandoned Cart',
        badge: null,
        description: 'Sends a cart reminder after 1 hour and a follow-up email the next day.',
        triggerName: 'Cart abandoned',
        step_delay1: 'Wait 1 hour',
        step_email1: 'Email #1 — Cart reminder',
        step_subject1: 'You left something in your cart 🛒',
        step_delay2: 'Wait 1 day',
        step_email2: 'Email #2 — Last chance',
        step_subject2: "Your cart is waiting — here's 10% off",
      },
      postPurchase: {
        name: 'Post-Purchase',
        badge: null,
        description: 'Sends a thank-you right after purchase, checks in after 3 days, and recommends products after a week.',
        triggerName: 'New order',
        step_email1: 'Email #1 — Thank you',
        step_subject1: 'Thank you! Your order has been received',
        step_delay1: 'Wait 3 days',
        step_email2: "Email #2 — How's everything?",
        step_subject2: 'How are you enjoying our product?',
        step_delay2: 'Wait 4 days',
        step_email3: 'Email #3 — You might also like',
        step_subject3: 'You might also like…',
      },
      reengagement: {
        name: 'Win Back Inactive',
        badge: null,
        description: 'Sends two win-back emails to inactive subscribers, then ends the flow if there is no response.',
        triggerName: 'Subscriber inactive',
        step_email1: 'Email #1 — We miss you',
        step_subject1: "Long time no see — here's something new for you",
        step_delay1: 'Wait 3 days',
        step_email2: 'Email #2 — Still here?',
        step_subject2: 'Last email — no pressure',
        step_exit: 'End automation',
      },
      onboarding: {
        name: 'Product Onboarding',
        badge: null,
        description: 'Guides new subscribers through a 5-day onboarding sequence with a final offer.',
        triggerName: 'New subscriber',
        step_email1: 'Email #1 — Who we are',
        step_subject1: "Hi! Let's get to know each other",
        step_delay1: 'Wait 2 days',
        step_email2: 'Email #2 — How it works',
        step_subject2: "Here's how our product solves your problem",
        step_delay2: 'Wait 3 days',
        step_email3: 'Email #3 — Special offer',
        step_subject3: 'New members only — 15% off your first month',
      },
      trialEnding: {
        name: 'Trial Ending',
        badge: null,
        description: 'Sends a trial reminder 3 days before expiry and a final bonus email on the last day.',
        triggerName: 'Trial ending',
        step_email1: 'Email #1 — Reminder',
        step_subject1: 'Your trial ends in 3 days',
        step_delay1: 'Wait 3 days',
        step_email2: 'Email #2 — Last day + bonus',
        step_subject2: "Today's your last day — here's a gift",
      },
    },
  },
  automations: {
    newAutomation: 'New Automation',
    chooseTemplate: 'Choose a template or start from scratch',
    startFromScratch: 'Start from scratch',
    startFromScratchDesc: 'Build your own automation with full freedom over every step.',
    forAdvanced: 'For advanced users',
    create: 'Create',
    useTemplate: 'Use Template',
    creating: 'Creating…',
    steps: 'steps',
    noAutomations: 'No automations yet',
    noAutomationsDesc: 'Create your first automation or start from a template',
    createAutomation: 'Create Automation',
    newAutomationBtn: '+ New Automation',
    templates: {
      welcome: {
        name: 'Welcome Series',
        badge: 'Most popular',
        description: 'New subscribers receive 2 emails: one immediately and one the next day.',
        triggerName: 'New subscriber',
        step_email1: 'Email #1 — Welcome',
        step_subject1: "Welcome! Here's what we prepared for you",
        step_delay1: 'Wait 1 day',
        step_email2: 'Email #2 — Helpful content',
        step_subject2: "Here's where to start",
      },
      abandonedCart: {
        name: 'Abandoned Cart',
        badge: null,
        description: 'Sends a cart reminder after 1 hour and a follow-up email the next day.',
        triggerName: 'Cart abandoned',
        step_delay1: 'Wait 1 hour',
        step_email1: 'Email #1 — Cart reminder',
        step_subject1: 'You left something in your cart 🛒',
        step_delay2: 'Wait 1 day',
        step_email2: 'Email #2 — Last chance',
        step_subject2: "Your cart is waiting — here's 10% off",
      },
      postPurchase: {
        name: 'Post-Purchase',
        badge: null,
        description: 'Sends a thank-you right after purchase, checks in after 3 days, and recommends products after a week.',
        triggerName: 'New order',
        step_email1: 'Email #1 — Thank you',
        step_subject1: 'Thank you! Your order has been received',
        step_delay1: 'Wait 3 days',
        step_email2: "Email #2 — How's everything?",
        step_subject2: 'How are you enjoying our product?',
        step_delay2: 'Wait 4 days',
        step_email3: 'Email #3 — You might also like',
        step_subject3: 'You might also like…',
      },
      reengagement: {
        name: 'Win Back Inactive',
        badge: null,
        description: 'Sends two win-back emails to inactive subscribers, then ends the flow if there is no response.',
        triggerName: 'Subscriber inactive',
        step_email1: 'Email #1 — We miss you',
        step_subject1: "Long time no see — here's something new for you",
        step_delay1: 'Wait 3 days',
        step_email2: 'Email #2 — Still here?',
        step_subject2: 'Last email — no pressure',
        step_exit: 'End automation',
      },
      onboarding: {
        name: 'Product Onboarding',
        badge: null,
        description: 'Guides new subscribers through a 5-day onboarding sequence with a final offer.',
        triggerName: 'New subscriber',
        step_email1: 'Email #1 — Who we are',
        step_subject1: "Hi! Let's get to know each other",
        step_delay1: 'Wait 2 days',
        step_email2: 'Email #2 — How it works',
        step_subject2: "Here's how our product solves your problem",
        step_delay2: 'Wait 3 days',
        step_email3: 'Email #3 — Special offer',
        step_subject3: 'New members only — 15% off your first month',
      },
      trialEnding: {
        name: 'Trial Ending',
        badge: null,
        description: 'Sends a trial reminder 3 days before expiry and a final bonus email on the last day.',
        triggerName: 'Trial ending',
        step_email1: 'Email #1 — Reminder',
        step_subject1: 'Your trial ends in 3 days',
        step_delay1: 'Wait 3 days',
        step_email2: 'Email #2 — Last day + bonus',
        step_subject2: "Today's your last day — here's a gift",
      },
    },
  },
  aiContent: {
    title: 'Create your first content AI!',
    text: 'Plan and publish content to all social media at once!',
    create: 'Create content AI',
  },
  pageDesign: {
    page: 'Page design',
    image: 'Image',
  },
  toolsMenu: {
    title: 'Tools',
    account: 'Account',
    instantPages: 'Instant Pages',
    instantPagesText: 'Fast-loading standalone pages',
    agents: 'Agents',
    developer: 'Developer',
    agentsText: 'AI assistants that manage your profile',
    socialPlanner: 'Social Planner',
    socialPlannerText: 'Content scheduling and inspiration',
    emailMarketing: 'Email Marketing',
    emailMarketingText: 'Grow your list of contacts',
    smartReply: 'Instagram Reply',
    smartReplyText: 'Send automated comments & messages',
    linkShortener: 'Short Links',
    linkShortenerText: 'Make long URLs shorter',
    posts: 'Posts',
    postsText: 'Create and manage posts',
    blog: 'Blog',
    blogText: 'Create and manage blog articles',
  },
  insideMenu: {
    planner: 'Planner',
    aiContent: 'AI Content',
    aiPosts: 'AI Posts',
    postIdeas: 'Post Ideas',
    contentPlanner: 'Content Planner',
    aiImages: 'AI Images',
    adBuilder: 'Ad Builder',
    brandProjects: 'Brand Identity',
    aiVideo: 'AI Video',
    integrations: 'Integrations',
    products: 'Products',
    orders: 'Orders',
    payments: 'Payments',
    links: 'Links',
    qrCodes: 'QR Codes',
  },
  orders: {
    title: 'Orders',
    empty: `You don't have any orders yet`,
    all: 'All orders',
    shop: 'Shop',
    digital: 'Digital products',
    appointments: 'Appointments',
    services: 'Services',
    donations: 'Donations',
  },
  discounts: {
    title: 'Discounts',
    newDiscount: '+ New Discount',
    code: 'Code',
    titleCol: 'Title',
    type: 'Type',
    value: 'Value',
    status: 'Status',
    used: 'Used',
    actions: 'Actions',
    statusAll: 'All statuses',
    statusActive: 'Active',
    statusExpired: 'Expired',
    statusScheduled: 'Scheduled',
    statusInactive: 'Inactive',
    searchPlaceholder: 'Search by code or title...',
    clearFilters: 'Clear filters',
    emptyTitle: 'No discounts yet',
    emptySubtitle: 'Create your first promo code to offer discounts on your products',
    createDiscount: 'Create Discount',
    createTitle: 'Create Discount',
    editTitle: 'Edit Discount',
    fieldTitle: 'Title',
    fieldTitlePlaceholder: 'e.g. Spring Sale',
    fieldCode: 'Code',
    fieldCodePlaceholder: 'e.g. SAVE20',
    generate: 'Generate',
    sectionDiscount: 'Discount',
    fieldTrigger: 'How it applies',
    triggerCode: 'Discount code',
    triggerAutomatic: 'Automatic (no code)',
    triggerAutomaticHint: 'Applied automatically at checkout when conditions are met — no code needed. Set a minimum order amount below for an order-value discount.',
    automaticBadge: 'Automatic',
    fieldType: 'Type',
    typePercentage: 'Percentage',
    typeFixed: 'Fixed amount',
    typeFreeShipping: 'Free shipping',
    fieldValue: 'Value',
    sectionConditions: 'Conditions (optional)',
    appliesTo: 'Applies to',
    appliesToAll: 'All products',
    appliesToShop: 'Shop',
    appliesToDigital: 'Digital',
    appliesToCourses: 'Courses',
    appliesToServices: 'Services',
    appliesToEvents: 'Events',
    minOrderAmount: 'Min order amount ($)',
    maxDiscountAmount: 'Max discount amount ($) — 0 = no limit',
    minItemCount: 'Min items in order — 0 = no requirement',
    specificProducts: 'Specific products — empty = all eligible',
    specificProductsPlaceholder: 'Search products...',
    noProductsFound: 'No products found',
    sectionLimits: 'Limits',
    usageLimit: 'Total usage limit — 0 = unlimited',
    usageLimitPerUser: 'Per customer limit — 0 = unlimited',
    sectionSchedule: 'Schedule',
    startDate: 'Start date — empty = starts now',
    endDate: 'End date — empty = no expiry',
    active: 'Active',
    cancel: 'Cancel',
    save: 'Save Discount',
    createdSuccess: 'Discount created',
    updatedSuccess: 'Discount updated',
    deletedSuccess: 'Discount deleted',
    loadError: 'Failed to load discounts',
    saveError: 'Failed to save discount',
    deleteError: 'Failed to delete discount',
  },
  donation: {
    chooseSmiles: 'Choose smiles',
    item: 'Item',
    itemTitle: 'Title of donation item',
    price: 'Price',
    thanksMessagePlaceholder: 'Thank you very much',
    thanksMessage: 'Thanks message',
    thanksMessageCaption: 'Thanks message will show to your fans after donation',
    addDonation: 'Add donation',
    addAmount: '+ Add amount',
    buttonTitle: 'Button title',
    buttonTitleCaption: 'Title of donation button',
    acceptDonations: 'Accept donations',
    donationsType: 'Donations',
    tips: 'Tips',
    type: 'Type',
    addAnotherAmount: '+ Add another amount',
  },
  blog: {
    empty: `You don't have blog yet`,
  },
  apps: {
    empty: `You don't have apps yet`,
  },
  payments: {
    title: 'Payments',
    text: 'You don`t have any transaction yet',
    single: 'Single payments',
    subscriptions: 'Subscriptions',
    wallet: 'Wallet',
    connectPromo: 'Connect Stripe or PayPal account to your UniLink page and receive all payments to your wallet.',
    connectSystem: 'Connect payment system',
    manageCards: 'Manage your cards',
    addNewCard: 'Add new card',
    editCard: 'Edit card info',
    addCard: 'Add card info',
    cardHolder: 'Card Holder Name',
    cardHolderNecessary: 'It is nececessary',
    withdrawalSuccess: 'Your withdraw was successfully submitted!',
    withdrawalError: 'Something went wrong, try again later.',
    change: 'Change',
  },
  store: {
    emptyTitle: 'You don’t have any products yet',
    emptyText: 'Start by adding your first product',
    emptyButton: 'Add product',
    createFirstProduct: 'Create your first product',
    startAdding: 'Start by adding your favorite products, digital goods, or services. A space where you can sell and promote everything you offer.',
    activate: 'Activate Store',
    empty: `You don't have products yet`,
    products: 'Products',
    addProducts: 'Add products',
    whatDoYouWant: 'What do you want to sell?',
    externalProduct: 'External product URL',
    createOwnProduct: 'Create your own product',
    shop: 'Shop',
    shopText: 'Sell physical and digital products',
    digital: 'Digital products',
    digitalText: 'Sell a Digital Download',
    course: 'Course or Tutorial',
    courseText: 'Add course or tutorial to the website',
    service: 'Services',
    serviceText: 'Add services from your customers',
    appointment: 'Appointments',
    appointmentText: 'Let visitors book time on your calendar',
    event: 'Events or Tickets',
    eventText: 'Create event and invite audience',
    tips: 'Tips',
    tipsText: 'Leave a tip for your favorite creators',
    donation: 'Donations',
    donationText: 'Make a donation',
    membership: 'Membership',
    membershipText: 'Add membership to the website',
    links: 'External link',
    linksText: 'Add external link to any websites',
    coupon: 'Coupon',
    couponText: 'Add coupon for your website',
    singleProduct: 'Single Product',
    singleProductText: 'Sell a single product with a simple checkout',
    booking: 'Booking',
    bookingText: 'Let visitors book your spaces or properties',
    rental: 'Rental',
    rentalText: 'List rental items with availability and pricing',
    add: 'Add',
    manageStore: 'Manage Store',
    displayLast: 'Display last product',
  },
  products: {
    showAsPopup: 'Show as popup',
    showAsPopupOff: "Don't show as popup",
    info: 'Info',
    uploadCover: 'Upload a cover photo, then provide a title and description',
    thumbnail: 'Thumbnail',
    thumbnailTab: {
      intro:
        'The card people see in your shop, before they open the product. It has no price or stock of its own — those live in Details, and here you only choose which of them the card shows.',
      cardImage: 'Card image',
      crop: 'Crop',
      cropSquare: 'Square',
      cropPortrait: 'Portrait',
      cropWide: 'Wide',
      imageHint: 'Leave empty and the card falls back to the first image from Details. 1200×1200 or larger looks best.',
      cardCopy: 'Card copy',
      cardTitle: 'Card title',
      sameAsTitle: 'Same as product title',
      shortDescription: 'Short description',
      shortDescriptionHint: 'One line that makes someone tap. The long description lives in Details.',
      buttonLabel: 'Button label',
      showOnCard: 'Show on the card',
      showOnCardNote: 'the values come from Details — this only decides what’s visible',
      editInDetails: 'Edit in Details ↗',
      rowPrice: 'Price',
      rowOldPrice: 'Old price & discount',
      rowAvailability: 'Availability',
      rowLabel: 'Label',
      inStock: 'In stock',
      notShown: 'Not shown',
    },
    thumbnailError: 'Please add a thumbnail',
    title: 'Title',
    titleTooltip: 'Enter name of your product',
    shortDescription: 'Short description',
    shortDescriptionTooltip: 'Enter short description of your product',
    description: 'Description',
    descriptionTooltip: 'Enter description of your product',
    descriptionTooltipExtra: 'Optional description of product features, types, color, sizes, etc.',
    price: 'Price',
    priceTooltip: 'Enter price of your product',
    oldPrice: 'Old price',
    oldPriceTooltip: 'Old price will be strikethrough',
    category: 'Category',
    categoryTooltip: 'Choose category of your product',
    image: 'Image',
    imageTooltip: 'Upload image for your product',
    groups: 'Groups',
    rate: 'Rate',
    rateTooltip: 'Enter rate of your product',
    buttonTitle: 'Button title',
    buttonTitleTooltip: 'Enter title of your product button',
    features: 'Features',
    featuresTooltip: 'Benefits checklist shown in the Showcase card layout',
    featurePlaceholder: 'Benefit',
    addFeature: 'Add feature',
    limitQuantity: 'Limit Quantity',
    itemsLeft: 'Items left',
    itemsLeftTooltip: 'Items of your product',
    trackStock: 'Track quantity',
    stockQuantity: 'Stock quantity',
    stockQuantityTooltip: 'Current units in stock. Decreases automatically with each paid order; when it reaches 0 the product can no longer be purchased.',
    lowStockThreshold: 'Low stock alert',
    lowStockThresholdTooltip: 'Get notified when stock drops to this number or below.',
    maxOrderQuantity: 'Maximum order quantity',
    maxOrderQuantityTooltip: 'Maximum number of units a customer can buy in a single order. Leave empty for no limit.',
    minOrderQuantity: 'Minimum order quantity',
    minOrderQuantityTooltip: 'Minimum number of units a customer must buy in a single order. Leave empty for no limit.',
    pendingReviews: {
      title: 'Pending reviews',
      subtitle: 'Approve or hide buyer reviews before they appear publicly',
      empty: 'No reviews awaiting moderation.',
      approve: 'Approve',
      hide: 'Hide',
    },
    attachments: 'Attachments',
    addAttachments: 'Add attachments to your products',
    addNewAttachment: 'Add new item',
    file: 'File',
    uploadFile: 'Upload file',
    uploadCoverTitle: 'Upload cover',
    optionalDescription: 'Optional description of product features, types, color, sizes, etc.',
    customReviews: 'Custom reviews',
    reviewsAndRating: 'Reviews & rating',
    addCustomReviews: 'Add reviews to your products',
    name: 'Name',
    nameTooltip: 'Enter name of your customer',
    comment: 'Comment',
    commentTooltip: 'Enter comment of your customer',
    rateTooltipCustomer: 'Rate of customer',
    imageTooltipCustomer: 'Upload image of your customer',
    displayPriceOnPreview: 'Display price on preview',
    displayDetailsOnPreview: 'Display details on preview',
    postOnSocials: 'Post on Socials',
    sendAnEmail: 'Send an Email',
    highlights: 'Highlights',
    listProductSetup: 'List product and set up your store block',
    whereToSell: 'Where would you like to sell this product?',
    youHaveProducts: 'You have {count} products',
    shareThisProduct: 'Share this product',
    shareAProduct: 'Share a product',
    monetizeWays: 'Different ways you can monetize on Unilink',
    addProductToProfile: 'Add a {title} to your profile',
    productPage: 'Product page',
    setUpPayments: 'Set up your payments',
    connectPaymentMethods: 'Connect your payment methods to start earning money on Unilink',
    addPaymentMethod: 'Add a {type} payment method to receive followers payments',
    withdrawAttempt: 'This is an attempt to collect a debt and any information will be used for that purpose.',
    withdrawSuccess: 'Your withdraw was successfully submitted!',
    yourVisitorsPay: 'Your visitors will pay first, and then will be directed to your {method}',
    emailAddress: 'email address',
    calendlyLink: 'Calendly link',
  },
  posts: {
    posts: 'Posts',
    title: 'Create your first post',
    description: 'Posts are where you create chat automations in an easy and visual format. Try some automations we recommend based on your goals',
    activate: 'Activate Posts',
    managePosts: 'Manage Posts',
    postsTab: 'Posts Tab',
    displayLast: 'Display last posts',
    tabNavigation: 'Tab navigation settings',
    createFirstPost: 'Create your first social post!',
    autoPostsText: 'Plan and publish content to all social media at once!',
    createPost: 'Create post',
  },
  messages: {
    title: 'Messages',
    empty: 'No Messages',
    addText: 'Add a message button to the Header block, allowing users to easily send you a message.',
    addButton: 'Add Message button',
  },
  smartReply: {
    title: 'Instagram Reply',
    clicks: 'clicks',
    createTitle: 'Create your first Instagram Reply!',
    text: 'Use Instagram Auto-DMs to automatically share links with your audience!',
    createButton: 'Create Auto DM',
    subtitleComment: 'Automatic DM with a link in reply to a comment',
    subtitleDm: 'Automatic DM in reply to a message or Story',
    ready: 'ready',
    edit: 'Edit',
    stepContentTitle: 'IG content',
    stepContentSub: 'Choose a post or Reel',
    storiesAndDmsSub: 'Auto-DM when someone replies to a Story or messages your inbox',
    stepTriggerTitle: 'Trigger',
    stepTriggerSub: 'Keywords in comments',
    stepTriggerSubDm: 'Keywords in messages',
    stepDmTitle: 'DM',
    stepDmSub: 'The message sent automatically',
    dmSummary: 'Message set',
    activatesNow: 'The auto-reply activates right away',
    saveAutomation: 'Save auto-reply',
    savedToast: 'Auto-reply created',
    linkLabel: 'Choose the link destination',
    selectDestination: 'Pick a link, product or article',
    change: 'Change',
    choose: 'Choose',
    remove: 'Remove',
    optional: 'optional',
    buttonText: 'Button text',
    addLink: 'Add link',
    attachLink: 'Attach link',
    noLinks: 'No links yet — add a link in your Link in Bio first.',
    tabLinks: 'Links',
    tabProducts: 'Products',
    noProducts: 'No products yet — create a product in your shop first.',
    tabArticles: 'Articles',
    noArticles: 'No articles yet — create an article first.',
    choosePost: 'Choose a post or Reel',
    searchPosts: 'Search your posts',
    loadingPosts: 'Loading your posts…',
    done: 'Done',
    oneSelected: '1 post selected',
    postSelected: 'Post selected',
    noPosts: 'No posts yet — publish a post or Reel on Instagram.',
    postsError: `Couldn't load posts. Please try again.`,
    reauthTitle: 'Some DMs may not be delivered.',
    reauthText: 'Instagram requires you to re-authorize the account.',
    reconnect: 'Reconnect',
    statActive: 'Active automations',
    statDmSent: 'DMs sent · 30d',
    statClicks: 'Link clicks',
    activeReplies: 'Active auto-replies',
    filterAll: 'All',
    filterActive: 'Active',
    filterOff: 'Off',
    tabOverview: 'Overview',
    tabInbox: 'Inbox',
    tabAssistantSetup: 'Setup',
    aiStartTitle: 'Create your Instagram AI assistant',
    aiStartText: 'An AI that replies to your Instagram DMs automatically — answering questions, recommending products and capturing leads, 24/7 in your own tone.',
    aiStartButton: 'Create AI assistant',
    aiStartButtonShort: 'Set up',
    aiStartPick: 'Choose an account to set up',
    tabAutomations: 'Automations',
    tabAiAutoreply: 'AI Assistant',
    tabMonitoring: 'Monitoring',
    accountConnected: 'Account connected',
    newAutomation: 'New automation',
    automationsSubtitle: 'Rules that run automatically before the AI takes over. Trigger on the left — action on the right. A disabled rule never runs.',
    nextPost: 'Next post',
    ruleTrigger: 'Trigger',
    ruleAction: 'Action',
    ruleKeyword: 'Keyword',
    ruleActionAi: 'reply with AI',
    ruleActionDm: 'send a DM',
    ruleActionComment: 'reply to comment',
    overviewSoonTitle: 'Overview is coming soon',
    inboxSoonTitle: 'Inbox is coming soon',
    tabSoonText: 'We’re building this. For now, use Automations and the AI Assistant.',
    aiEmptyTitle: 'You don’t have an AI chat yet',
    aiEmptyText: 'Add an AI assistant that replies to your Instagram DMs automatically — with your own persona, knowledge and tone.',
    aiAddChat: 'Add AI chat',
    aiYourChats: 'Your AI chats',
    aiBackToChats: 'Back to chats',
    aiCardRole: 'Instagram DM assistant',
    aiCardDefaultPersona: 'Default persona — set its instructions, knowledge and tone.',
    aiStatusReady: 'Ready',
    aiStatusDraft: 'Draft',
    aiPickTitle: 'Add AI chat',
    aiPickSub: 'Choose which Instagram account this chat replies for.',
    savedAuto: '✓ All changes saved',
    saveFailed: 'Save failed — retry',
    aiPreview: 'Preview',
    aiPreviewBrand: 'Your brand',
    aiPreviewActive: 'AI assistant active',
    aiPreviewUserMsg: 'Hi! How much is the hoodie?',
    aiPreviewAiLabel: 'AI ASSISTANT',
    aiPreviewSample: 'The oversize hoodie is $39 — beige, black and khaki 🖤 Which size are you after?',
    aiPreviewTip: 'The more specific the persona & knowledge, the fewer chats need a human.',
    inboxSearch: 'Search by name or @handle',
    inboxFilterAll: 'All',
    inboxFilterAwaiting: 'Awaiting',
    inboxFilterNeedsHuman: 'Needs human',
    inboxFilterUnread: 'Unread',
    inboxEmpty: 'No conversations yet.',
    inboxNoAccount: 'Connect an Instagram account first.',
    inboxPickConversation: 'Pick a conversation to start.',
    inboxContactHint: 'Contact details appear here.',
    inboxAiOn: 'AI on',
    inboxAiOff: 'AI off',
    inboxTakeOver: 'Take over',
    inboxReplyPlaceholder: 'Write a reply…',
    inboxTags: 'Tags',
    inboxAddTag: 'Tag',
    inboxTag: 'Tag',
    inboxNote: 'Note',
    inboxNotePlaceholder: 'Private note about this contact…',
    inboxFirstContact: 'First contact',
    inboxOrders: 'Order history',
    inboxOrdersUnit: 'pcs',
    inboxNoOrders: 'No orders yet',
    inboxStatusAwaiting: 'Awaiting',
    inboxStatusAiAnswered: 'AI answered',
    inboxStatusNeedsHuman: 'Needs human',
    inboxQuickReplies: 'Quick replies',
    inboxNow: 'now',
    inboxMin: 'min',
    inboxHour: 'h',
    inboxDay: 'd',
    inboxYesterday: 'yesterday',
    ovNewToday: 'New dialogs today',
    ovVsYesterday: '+8 vs yesterday',
    ovVsYesterdayShort: 'vs yesterday',
    ovSec: 's',
    ovAiAnswered: 'Answered by AI',
    ovAiAnsweredSub: '21 of 24 dialogs',
    ovNow: 'now',
    ovAwaiting: 'Awaiting reply',
    ovNeedAttention: 'need attention',
    ov12s: '12 s',
    ovAvgTime: 'Avg response time',
    ovInstant: 'AI replies instantly',
    ovChartTitle: 'Dialogs over 7 days',
    ovTotal: 'Total',
    ovStatusTitle: 'By status',
    ovRecent: 'Recent dialogs',
    ovOpenInbox: 'Open inbox',
  },
  virtualBackgrounds: {
    title: 'Virtual Backgrounds',
    canvasSize: 'Canvas size',
    fmtCall: 'Zoom · Teams · Meet',
    fmtStories: 'Stories · Reels',
    fmtSquare: 'Square',
    fmtClassic: 'Classic',
    background: 'Background',
    bg_color: 'Colour',
    bg_gradient: 'Gradient',
    bg_photo: 'Photo',
    bg_pattern: 'Pattern',
    from: 'From',
    to: 'To',
    angle: 'Angle',
    ink: 'Ink',
    paper: 'Paper',
    blur: 'Blur',
    darken: 'Darken',
    presets: 'Presets',
    uploadImage: 'Upload image',
    removeImage: 'Remove image',
    replace: 'Replace',
    remove: 'Remove',
    photoPlaceholder: 'Upload an image from the panel',
    overlay: 'Overlay',
    showName: 'Show name',
    namePlaceholder: 'Your name',
    subtitlePlaceholder: 'Subtitle / handle',
    typeface: 'Typeface',
    textColour: 'Text colour',
    nameSizeLabel: 'Name size',
    position: 'Position',
    showQr: 'Show QR code',
    qrPlaceholder: 'https://link',
    style: 'Style',
    qrCard: 'Card',
    qrBrand: 'Brand',
    qrLight: 'Light',
    qrSolid: 'Solid',
    qrSizeLabel: 'QR size',
    logo: 'Logo / avatar',
    uploadLogo: 'Upload logo (PNG)',
    logoSizeLabel: 'Logo size',
    finishing: 'Finishing',
    vignette: 'Vignette',
    vignetteHint: 'Soft dark edges for depth',
    shuffle: 'Shuffle',
    reset: 'Reset',
    dragHint: 'Drag the name, QR or logo on the canvas to reposition',
    preparing: 'Preparing…',
    download: 'Download',
    sizeHint: 'Saved as a 1920 × 1080 JPG',
  },
  emailSignatures: {
    signatures: 'Signatures',
    signature: 'Signature',
    signatureName: 'Label',
    signatureNamePlaceholder: 'Work, Personal…',
    newSignature: 'New signature',
    createSignature: 'Create signature',
    emptyText: 'Create a signature and every email you send links back to your page.',
    default: 'Default',
    isDefault: 'Default signature',
    makeDefault: 'Make default',
    duplicate: 'Duplicate',
    delete: 'Delete',
    save: 'Save',
    saving: 'Saving…',
    saved: 'Signature saved',
    fillFromCard: 'Fill from business card',
    noCard: 'No business card yet — fill the fields in manually',
    extras: 'Extras',
    socialLinks: 'Social links',
    logo: 'Company logo',
    upload: 'Upload',
    uploading: 'Uploading…',
    uploadFailed: 'Upload failed',
    imageTooLarge: 'Image must be under {size} MB',
    remove: 'Remove',
    ctaText: 'Button text',
    ctaTextPlaceholder: 'Book a call',
    ctaUrl: 'Button link',
    banner: 'Banner',
    disclaimer: 'Disclaimer',
    disclaimerPlaceholder: 'Confidentiality notice, company details…',
    tracking: 'Tracking',
    copyLink: 'Copy link',
    linkCopied: 'Link copied',
    renewLink: 'Renew link',
    renewing: 'Renewing…',
    linkRenewed: 'Link renewed',
    renewHint: 'Renewing issues a new link. Signatures already sitting in inboxes stop working — the counters below are kept.',
    statClicks: 'Link clicks',
    statQrScans: 'QR scans',
    statCtaClicks: 'Button clicks',
    title: 'Email Signatures',
    details: 'Details',
    name: 'Name',
    jobTitle: 'Job title',
    company: 'Company',
    email: 'Email',
    phone: 'Phone',
    website: 'Website',
    style: 'Style',
    styleModern: 'Modern',
    styleClassic: 'Classic',
    styleMinimal: 'Minimal',
    styleBold: 'Bold',
    styleCard: 'Card',
    accent: 'Accent color',
    showAvatar: 'Show photo',
    showQr: 'Show QR code',
    preview: 'Preview',
    copySignature: 'Copy signature',
    copyHtml: 'Copy HTML',
    copied: 'Signature copied',
    copiedHtml: 'HTML copied',
    instructions: {
      gmail: 'Gmail: Settings → See all settings → General → Signature → Create new, then paste (Ctrl/Cmd+V) and save changes.',
      outlook: 'Outlook: File → Options → Mail → Signatures → New, then paste. New Outlook / web: Settings → Mail → Compose and reply → paste into the signature box.',
      apple: 'Apple Mail: Mail → Settings → Signatures → add a signature, then paste it. Uncheck “Always match my default message font”.',
    },
  },
  businessCards: {
    title: 'Business cards',
    emptyTitle: 'Create your digital business card',
    emptySubtitle: 'Add your contact details so anyone can save them to their phone in one tap — then share it with a QR code or a .vcf file.',
    createButton: 'Create business card',
    sectionButton: 'Save contact button',
    sectionButtonSubtitle: 'How the "Save contact" button looks and where it appears on your profile.',
    showButton: 'Show on my profile',
    showButtonSubtitle: 'Display the "Save contact" button on your public page.',
    placement: 'Button placement',
    placementSubtitle: 'Choose where the button appears.',
    showInHeader: 'Show in header',
    placementHeader: 'Profile header',
    placementHeaderHint: 'Shows right below your name and avatar.',
    placementContact: 'Contacts section',
    placementContactHint: 'Appears inside your Contacts popup.',
    placementBottom: 'Floating button',
    placementBottomHint: 'Sticks to the bottom of the page while visitors scroll.',
    none: 'None',
    buttonLabel: 'Button label',
    buttonLabelSubtitle: 'Text shown on the button.',
    saveContact: 'Save contact',
    sectionDetails: 'Contact details',
    sectionDetailsSubtitle: 'These details are saved to the contact card.',
    leadCapture: 'Collect contacts',
    leadCaptureSubtitle: 'Let people who receive your card share their details back — straight into your Audience.',
    leadCaptureToggle: 'Enable “Share your details”',
    leadCaptureToggleHint: 'Shows a contact form on your public card.',
    leadTag: 'Tag new leads',
    leadTagSubtitle: 'Every captured contact is tagged with this (e.g. an event or campaign name).',
    leadTagPlaceholder: 'e.g. Conference 2026',
    delete: 'Delete business card',
    previewHint: 'This is how your card looks to visitors.',
    share: 'Share & QR',
    shareSubtitle: 'Scan the code or share the link to open your profile.',
    download: 'Download .vcf',
    copyLink: 'Copy link',
    copied: 'Link copied!',
    renewLink: 'Renew link',
    renewing: 'Renewing…',
    renewConfirm: 'Renew the card link? Your current QR code and shared links will stop working.',
    linkRenewed: 'Card link renewed',
    scans: '{count} scans',
    digitalCard: 'Digital card',
    physicalCard: 'Physical card',
    cardStyle: 'Card style',
    cardStyleSubtitle: 'Set your display name, pick a background colour and add your card to a wallet.',
    displayName: 'Display name',
    backgroundColour: 'Background colour',
    addAppleWallet: 'Add to Apple Wallet',
    addGoogleWallet: 'Add to Google Wallet',
    nameLabel: 'Name',
    urlLabel: 'URL',
    walletScanTitle: 'Scan QR code to save to your wallet',
    walletScanSubtitle: `It will be saved to your phone's digital wallet.`,
    walletUseLink: 'Or use this link instead',
    walletComingSoonTitle: 'Almost there',
    walletComingSoon: 'Wallet passes are coming soon.',
    done: 'Done',
    physicalTitle: 'Order a physical card',
    physicalSubtitle: 'NFC business cards are coming soon.',
  },
  shortLinks: {
    title: 'Short Links',
    addLink: 'Add link',
    name: 'Name',
    slug: 'Slug',
    slugTooltip: 'You can change the Slug by clicking on the edit button',
    destinationUrl: 'Destination URL',
    metadata: 'Metadata',
    utmTags: 'UTM Tags',
    customizeMetadata: `Customize the link's metadata`,
    metaTitle: 'Title',
    metaDescription: 'Description',
    favicon: 'Favicon',
    imagePreview: 'Image preview',
    addUtm: 'Add UTM tags to the link (optional)',
    utmCampaign: 'UTM Campaign',
    utmMedium: 'UTM Medium',
    utmSource: 'UTM Source',
    utmTerm: 'UTM Term',
    utmContent: 'UTM Content',
    utmId: 'UTM Id',
    utmPlacement: 'UTM Placement',
    utmCreative: 'UTM Creative',
    pasteLink: 'Paste your long link here',
    shorten: 'Shorten link',
    shortenGreeting: 'What are we shortening',
    shortenGreetingPlain: 'What are we shortening?',
    pasteLinkMulti: 'Paste a long link — or several, one per line',
    customSlug: 'Custom slug',
    customSlugPlaceholder: 'my-link',
    qrCode: 'QR code',
    qrDesign: {
      title: 'QR code for',
      close: 'Close',
      subtitle: 'Customize the look and download it — the link stays the same',
      codeColor: 'Code color',
      background: 'Background',
      transparent: 'Transparent',
      logo: 'Logo in the middle',
      logoSize: 'Logo size',
      none: 'None',
      avatar: 'Avatar',
      upload: 'Upload',
      quietZone: 'Quiet zone',
      quietZoneHint: 'the frame a scanner looks for',
      small: 'Small',
      normal: 'Normal',
      format: 'Format',
      size: 'Size',
      reset: 'Reset',
      copyImage: 'Copy image',
      copied: 'Copied',
      download: 'Download',
      preparing: 'Preparing…',
      contrastOk: 'Contrast is good enough to scan',
      contrastLow: 'Contrast is too low — phones may fail to scan',
      avatarFailed: 'Could not load your profile picture — upload an image instead',
      fileFailed: 'Could not read that image',
      downloadFailed: 'Could not prepare the file',
      copyFailed: 'Your browser did not allow copying the image',
    },
    edit: 'Edit item details',
    status: 'Status',
    expires: 'Expiration',
    noExpiry: 'no limit',
    tags: 'Tags',
    noSocialPreview: 'No social preview set',
    addImage: 'Add image',
    regenerate: 'Generate another',
    all: 'All',
    addTag: 'tag',
    newTagPlaceholder: 'New tag, then Enter',
    frequent: 'Frequent',
    duplicateTitle: 'You already have a short link for this URL',
    duplicateCreate: 'Create another one',
  },
  audience: {
    title: 'Audience',
    total: 'Total',
    totalMembers: 'Total Audience Members',
    totalContacts: 'Total Contacts',
    forms: 'Forms',
    subscribers: 'Subscribers',
    customers: 'Customers',
    noAudienceMembers: 'No Contacts',
    emptyAudienceMembers: 'Add new contacts by clicking button',
    addAudienceMember: 'Add Contact',
    noSubscribers: 'No Subscribers',
    emptySubscribers: 'Add new subscribers by adding blocks to your Link in Bio',
    addDataCollect: 'Add Data Collect block',
    noResponses: 'No Responses',
    emptyResponses: 'Add new responses by adding blocks to your Link in Bio',
    addFormBlock: 'Add Form block',
    noCustomers: 'No Customers',
    emptyCustomers: 'Add new customers by adding product to your Link in Bio',
    addProduct: 'Add Product',
    addContactModal: {
      title: 'Add new contact',
      name: 'Name',
      nameTooltip: 'Enter the name for your contact',
      email: 'Email',
      emailTooltip: 'Enter the email address for your contact',
      phone: 'Phone',
      phoneTooltip: 'Enter the phone number for your contact',
      telegram: 'Telegram',
      telegramTooltip: 'Enter the Telegram username or URL for your contact',
      whatsapp: 'WhatsApp',
      whatsappTooltip: 'Enter the WhatsApp number for your contact',
      instagram: 'Instagram',
      instagramTooltip: 'Enter the Instagram username or URL for your contact',
      messenger: 'Messenger',
      messengerTooltip: 'Enter the Messenger username or URL for your contact',
      viber: 'Viber',
      viberTooltip: 'Enter the Viber number for your contact',
      address: 'Address',
      addressTooltip: 'Enter the address for your contact',
      add: 'Add',
    },
    search: {
      search: 'Search',
      error: 'Invalid character entered in the search field',
      notFound: 'No results found',
    },
  },
  auth: {
    logIn: 'Log in',
    logInWith: 'Log in with',
    signIn: 'Sign in',
    signInWith: 'Sign up with',
    email: 'Email',
    password: 'Password',
    notHaveAccount: `Don't have an account?`,
    createAccount: 'Create a new Account',
    createYourAccount: 'Create your Account',
    signUp: 'Sign up',
    haveAccount: 'If you already have an account',
    or: 'or',
    reset: 'Reset',
    resetPassword: 'Reset password',
    resetTitle: 'The recovery link has been sent to your email',
    goToHome: 'Go to Home page',
    byClicking: 'By clicking',
    youAreAgree: `you agree to UniLink's`,
    terms: 'Terms of Service',
    andConfirm: 'and our',
    usagePolicy: 'Usage Policy',
    signInGoogle: 'Sign in with Google',
    forgotPassword: 'Forgot a password?',
    mfa: {
      title: 'Two-factor authentication',
      text: 'Enter the 6-digit code from your authenticator app.',
      recoveryText: 'Enter one of your recovery codes.',
      trustDevice: 'Trust this device for 90 days',
      verify: 'Verify',
      useRecovery: 'Use a recovery code',
      useApp: 'Use the authenticator app',
      back: 'Back to login',
    },
    consent: {
      title: 'Connect {client}',
      subtitle: '{client} wants to access your UniLink account.',
      returnTo: "You'll be returned to {host}",
      returnToLocalApp: "You'll be returned to an app on this computer.",
      canTitle: 'It will be able to',
      canRead: 'Read your profile, blocks, orders, audience and analytics',
      canEdit: 'Create and edit blocks',
      cannotTitle: 'It cannot',
      cannotDelete: 'Delete anything',
      cannotEmail: 'Send emails',
      cannotMoney: 'Change orders or money',
      alreadyConnected: '{client} is already connected to your account. Allowing again adds a second connection.',
      allow: 'Allow',
      deny: 'Deny',
      onlyContinue: 'Only continue if you just started connecting from Claude or ChatGPT.',
      onlyContinueLocalApp: 'Only continue if you just started this yourself in Claude Code or another app on this computer.',
      forbiddenText: 'This account cannot connect apps.',
      expiredTitle: 'This link expired',
      invalidTitle: 'This link is not valid',
      expiredText: 'Start the connection again from Claude or ChatGPT.',
      errorTitle: 'Something went wrong',
      errorText: 'Please try again in a moment.',
      retry: 'Try again',
      framedTitle: 'Open this page directly',
      framedText: 'For your security, this page cannot be shown inside another site.',
    },
  },
  menu: {
    moreApps: 'More apps',
    account: 'Account',
    more: 'More',
    storyWidget: 'Embed Stories',
    integrations: 'Integrations',
    socialAccounts: 'Social accounts',
    aiContent: 'AI Content',
    aiPosts: 'AI Posts',
    postIdeas: 'Post Ideas',
    contentPlanner: 'Content Planner',
    aiImages: 'AI Images',
    adBuilder: 'Ad Builder',
    aiVideo: 'AI Video',
    planner: 'Planner',
    customers: 'Customers',
    subscribers: 'Subscribers',
    forms: 'Forms',
    allAudience: 'All audience',
    payments: 'Payments',
    orders: 'Orders',
    products: 'Products',
    allProducts: 'All Products',
    events: 'Events',
    appointments: 'Appointments',
    discounts: 'Discounts',
    affiliates: 'Affiliates',
    instantPages: 'Instant Pages',
    openInNewTab: 'Open in new tab',
    linkInBio: 'Link in Bio',
    linkInBioApps: 'Link in Bio',
    website: 'Website',
    store: 'Store',
    audience: 'Audience',
    emailMarketing: 'Email Marketing',
    postPlaner: 'Post Planner',
    posts: 'Posts',
    agents: 'Agents',
    developer: 'Developer',
    community: 'Community',
    profileHealth: 'Profile Health',
    socialPlanner: 'Social Planner',
    shortLinks: 'Short Links',
    businessCards: 'Business cards',
    emailSignatures: 'Email Signatures',
    virtualBackgrounds: 'Virtual Backgrounds',
    adsCampaigns: 'Ads Manager',
    telegramBots: 'Telegram Bot',
    views: 'Views',
    clicks: 'Clicks',
    allWebsites: 'All Websites',
    createNewAccount: 'Create new account',
    createNewWebsite: 'Create a new profile',
    tools: 'Tools',
    borderGenerator: 'Border Generator',
    yourPlan: 'Your plan:',
    upgrade: 'Upgrade',
    accountSettings: 'Account settings',
    manageWebsites: 'Manage profiles',
    updates: 'Updates',
    autoUpdate: 'Auto update',
    logOut: 'Log out',
    myPages: 'My Pages',
    design: 'Design',
    heading: 'Heading',
    analytics: 'Analytics',
    settings: 'Settings',
    open: 'Open',
    language: 'Language',
    siteLanguage: 'Public site language',
    dashboardLanguage: 'Dashboard language',
    movePage: 'Move Page',
    editBlock: 'Edit Block',
    renameBlock: 'Rename Block',
    rename: 'Rename',
    deleteBlock: 'Delete Block',
    archiveBlock: 'Archive Block',
    archive: 'Archive',
    scheduleBlock: 'Schedule Block',
    copyBlock: 'Copy Block',
    dublicateBlock: 'Duplicate Block',
    content: 'Content',
    preview: 'Preview',
    thumbnail: 'Thumbnail',
    copy: 'Copy',
    moveBlock: 'Move Block',
    move: 'Move',
    edit: 'Edit',
    delete: 'Delete',
    schedule: 'Schedule',
    dublicate: 'Duplicate',
    smartReply: 'Instagram Reply',
    marketing: 'Marketing',
    selectBlocks: 'Select blocks',
    selectAll: 'Select all',
    cancelSelection: 'Cancel',
    blocksSelected: 'selected',
    moveToPage: 'Move to page',
    newPage: 'New Page',
    openPage: 'Open Page',
    pageSettings: 'Page Settings',
    deletePage: 'Delete Page',
    appInBio: 'App in Bio',
    blog: 'Blog',
    buildFromReference: 'Build from Reference',
    publish: 'Publish',
    creatorHub: 'Creator Hub',
    qrCodes: 'QR Codes',
    apps: 'Apps',
    automations: 'Automations',
    messages: 'Inbox',
    form: 'Embed Forms',
    embedTools: 'Embed Tools',
  },
  modal: {
    addInstagram: 'Add Instagram',
    addYourInstagram: 'Add your Instagram account',
    cropYourAvatar: 'Crop your avatar',
    removeSite: 'Are you sure you want to remove site?',
    areYouSure: 'Are you sure you want to',
    areYouSureDelete: 'Are you sure you want to delete this section?',
    areYouSureArchive: 'Are you sure you want to archive this block?',
    areYouSurePermanentDelete: 'Are you sure you want to permanently delete this block? This action cannot be undone.',
    remove: 'remove',
    site: 'site',
    removeAccountText: 'remove your account',
    moveBlock: 'Move block to another page',
    moveBlockText: 'This will move the block to the bottom of another page. You can then rearrange the block an the new page',
    profileTitle: 'Change profile picture',
    profileText: 'Choose an image, GIF from your device.',
    profileAvatar: 'Profile Avatar',
    addProfilePicture: 'Add Profile Picture',
    storiesTitle: 'Stories',
    storiesText: 'Share your everyday moments.',
    thoughtsTitle: 'Thoughts',
    thoughtsText: 'Share your thoughts.',
    accountPageDescription: 'This is your account page, where you can customize how your page looks, add different feature blocks, and more.',
    profileAudio: {
      title: 'Profile Audio',
      tabTrack: 'Track',
      tabDesign: 'Design',
      nowInProfile: 'Now in profile',
      myTracks: 'My tracks',
      upload: 'Upload file',
      dropTitle: 'Drop an audio file here',
      dropText: 'or pick one from your device',
      dropFormats: 'MP3, M4A or WAV',
      loading: 'Loading tracks...',
      empty: 'No audio tracks yet — add them in your Music block first',
      untitled: 'Untitled track',
      appearance: 'Appearance in profile',
      styleMinimal: 'Minimal',
      styleFancy: 'Fancy',
      styleCard: 'Card',
      styleChip: 'Chip in statuses',
      volume: 'Volume',
      autoplay: 'Autoplay',
      autoplayText: 'Shows a splash screen — the track starts on the visitor’s first tap',
    },
  },
  modalSubscribe: {
    plan: 'Plan',
    usdMonth: 'USD/month',
    sites: 'Sites',
    sitesMuch: 'Sites',
    notification: 'Notifications',
    noNotification: 'No notifications yet',
    inCategory: 'There are no items in the',
    categoryYet: 'category yet.',
    externalPixels: 'External Pixels',
    parameters: 'parameters',
    analyticsReports: 'Analytics & Reports',
    noUniLinkLogo: 'No UniLink Logo',
    inProfile: 'in profile',
    verifiedBadge: 'Verified badge',
    your: 'Your',
    customDomain: 'custom Domain',
    emailMarketing: 'Email Marketing',
    liveSupport: 'Live Support',
    dataSecured: 'The data is secured in compliance with the PCI DSS standard',
    thankYou: 'Thank you for your interested. We will contact you soon.',
    socialMediaScheduler: 'Social Media Scheduler',
    featureRequest: 'Feature request',
    markAllRead: 'Mark all read',
    currentPlan: 'Current Plan',
    features: 'Features',
  },
  buttons: {
    upgrade: 'Upgrade Plan',
    buyProPlan: 'Buy Pro Plan',
    continue: 'Continue',
    skip: 'Skip',
    cancel: 'Cancel',
    confirm: 'Confirm',
    back: 'Back',
    save: 'Save',
    add: 'Add',
    added: 'Added',
    done: 'Done',
    ok: 'OK',
    edit: 'Edit',
    delete: 'Delete',
    remove: 'Remove',
    setAsDefault: 'Set as default',
    subscribeNow: 'Subscribe Now',
    yes: 'Yes',
    preview: 'Preview',
    generate: 'Generate',
    changePassword: 'Change password',
    deleteAccount: 'Delete account',
    removeAccount: 'Remove account',
    deleteProfile: 'Delete profile',
    addBlock: 'Add block',
    copyLink: 'Copy link',
    active: 'Active',
    update: 'Update',
    updatePro: 'Upgrade Plan',
    prev: 'Prev',
    next: 'Next',
    uploadImage: 'Upload image',
    uploadVideo: 'Upload video',
    loadMore: 'Load more',
    uploadProductImage: 'Upload product image',
    claim: 'Claim',
    removeSite: 'Remove site',
    move: 'Move',
    addButton: 'Add button',
    actionButton: 'Action button',
    directMessage: 'Direct message',
    subscribe: 'Subscribe',
    button: 'Button',
    generateWithAI: 'Generate with AI',
    cta: 'CTA',
    cart: 'Cart',
    direct: 'Direct',
    follow: 'Follow',
    addNewItem: 'Add new item',
  },
  support: {
    liveSupport: 'Live Support',
    response: 'We usually response in 1 minute during the working hours (8AM - 10PM) GMT+3',
    founder: 'Denys Bilozor',
    ceo: 'Founder and CEO at UniLink',
  },
  wizard: {
    createNewProfile: 'Create a new profile',
    createProfile: 'Create Profile',
    continue: 'Continue',
    tellUs: 'Tell us about yourself',
    addSocialLinks: 'Add all social networks, and we will show them in your database',
    addMoreLinks: 'Add More Links',
    addLink: 'Add Link',
    selectCategory: 'Select one category that best describes you:',
    chooseTemplate: 'Choose a template',
    skip: 'Skip',
    step: 'Step',
    of: 'of',
    yourName: 'Your Name',
    search: 'Search',
    blog: 'Blog',
    creator: 'Creator',
    music: 'Music',
    events: 'Events',
    esoteric: 'Esoteric',
    fashion: 'Fashion',
    influencer: 'Influencer',
    food: 'Food',
    smallBusiness: 'Small Business',
    marketing: 'Marketing',
    education: 'Education',
    socialMedia: 'Social Media',
    coaching: 'Coaching',
    ecommerce: 'Ecommerce',
    healthAndFitness: 'Health and Fitness',
    beautyWellness: 'Beauty & Wellness',
  },
  billing: {
    back: 'Back',
    findPlan: 'Find the plan for you',
    changeAnytime: 'You can change at anytime.',
    subtitle: 'Upgrade, downgrade or cancel anytime.',
    currentPlan: 'Current plan',
    mostPopular: 'Most popular',
    upgradeTo: 'Upgrade to {plan}',
    includes: 'Includes:',
    everythingIn: 'Everything in {plan}, plus:',
    secure: 'Payments are secured in compliance with the PCI DSS standard.',
  },
  field: {
    fullName: 'Full Name',
    username: 'username',
    addValue: 'Add value',
    newValue: 'New value',
    placeholderDefault: 'Text, numbers, symbols etc.',
    addInstagramUsername: 'Add Instagram username',
    nameDefault: 'Jhon',
    enterYourLink: 'Enter your link',
    searchImage: 'Search image',
    pasteLink: 'Paste link',
    pasteLinkTip: 'Add a link to any web page',
    searchGIFs: 'Search GIFs',
    searchIcons: 'Search icons',
    searchVideo: 'Search video',
    search: 'Search',
    insertURL: 'Insert URL',
    writeYourDescription: 'Write your description',
    headerCTAbutton: 'Header, CTA button',
    enterTitle: 'Enter title',
    enterDescription: 'Enter description',
    enterURL: 'Enter canonical URL',
  },
  tooltip: {
    addImage: 'Add image',
    labelModalTitle: 'Label settings',
    addLabel: '+ Add label',
    label: 'Label',
    labelCaption: 'Enter label',
    labelText: 'Label text',
    labelTextCaption: 'Enter label text',
    labelTextPlaceholder: 'Label',
    labelUrl: 'Label URL',
    labelUrlCaption: 'Enter label URL',
    labelUrlPlaceholder: 'https://example.com',
    noLabel: 'No label',
    colorFrom: 'Color from',
    colorTo: 'Color to',
    highlight: 'Highlight',
    firstName: 'First name',
    firstNameCaption: 'Enter your first name',
    lastName: 'Last name',
    lastNameCaption: 'Enter your last name',
    jobTitle: 'Job title',
    jobTitleCaption: 'Enter your job title',
    organization: 'Organization',
    organizationCaption: 'Enter your organization',
    email: 'Email',
    emailCaption: 'Enter your email',
    workPhone: 'Work phone',
    workPhoneCaption: 'Enter your work phone',
    mobilePhone: 'Mobile phone',
    mobilePhoneCaption: 'Enter your mobile phone',
    website: 'Website',
    websiteCaption: 'Enter your website',
    information: 'Information',
    informationCaption: 'Enter your information',
    streetAddress: 'Street address',
    streetAddressCaption: 'Enter your street address',
    city: 'City',
    cityCaption: 'Enter your city',
    state: 'State',
    stateCaption: 'Enter your state',
    postalCode: 'Postal code',
    postalCodeCaption: 'Enter your postal code',
    country: 'Country',
    countryCaption: 'Enter your country',
    titleColor: 'Title color',
    titleColorCaption: 'You can change title color',
    fontFamily: 'Font family',
    fontFamilyCaption: 'You can change font family',
    fontSize: 'Font size',
    fontSizeLabel: 'Label font size',
    fontSizeCaption: 'You can change font size',
    fontSelect: 'Font',
    fontSelectCaption: 'Choose a font',
    imageMargin: 'Image margin',
    profilePicture: 'Profile picture',
    profilePictureCaption: 'Change your profile picture',
    pictureSize: 'Picture size',
    pictureSizeCaption: 'You can change picture size',
    title: 'Title',
    titleCaption: 'Enter a title',
    blockCaption: 'Enter a title of your block',
    titlePageCaption: 'Enter a title of your page',
    templates: 'Templates',
    templatesCaption: 'Choose a template for your page',
    myTemplates: 'My templates',
    myTemplatesEmpty: 'No templates yet. Save your current page design to reuse it later.',
    saveAsTemplate: 'Save as Template',
    saveCurrentAsTemplate: 'Save current as template',
    templateSaved: 'Template saved',
    templateApplied: 'Template applied',
    buildFromReference: 'Build from Reference',
    templateAppliedCount: 'Template applied — {n} blocks added',
    searchTemplates: 'Search templates…',
    favorites: 'Favorites',
    previewLive: 'Preview live',
    previewingTemplate: 'Previewing',
    exitPreview: 'Exit',
    templateKind: 'What to include',
    publish: 'Publish',
    unpublish: 'Unpublish',
    templatePublished: 'Template published',
    templateUnpublished: 'Template unpublished',
    discoverTemplates: 'Discover community',
    discoverSubtitle: 'Free templates published by other creators on UniLink.',
    discoverEmpty: 'No public templates yet — be the first to publish one.',
    pricing: 'Pricing',
    background: 'Background',
    backgroundColor: 'Background color',
    textBackground: 'Text Background',
    textBackgroundCaption: 'Choose text background color',
    textColor: 'Text Color',
    textColorCaption: 'Choose text color',
    gradientBackground: 'Gradient Background',
    gradientColor: 'Gradient Color',
    BackgroundType: 'Type',
    backgroundSource: 'Background source',
    backgroundSourceCaption: 'Choose background source',
    backgroundStyle: 'Background style',
    backgroundStyleCaption: 'Choose background style',
    backgroundStylesNormal: 'Normal',
    backgroundStylesGlass: 'Glass',
    backgroundStylesOutline: 'Outline',
    backgroundTypeCaption: 'Choose type background',
    color: 'Color',
    colorTooltip: 'You can change color',
    backgroundOpacityTooltip: 'Drag slider to set background opacity',
    backgroundBlur: 'Background blur',
    backgroundBlurCaption: 'Drag slider to blur a background blur',
    backgroundBrightness: 'Background brightness',
    backgroundBrightnessCaption: 'Drag the slider to change the background brightness',
    backgroundContrast: 'Background contrast',
    backgroundContrastCaption: 'Drag the slider to change the background contrast',
    color1: 'Color 1',
    color2: 'Color 2',
    colorCaption: 'Enter color of your page',
    gradient: 'Gradient',
    image: 'Image',
    photo: 'Photo',
    gif: 'GIF',
    animation: 'Animation',
    video: 'Video',
    hexColor: 'Hex color',
    direction: 'Direction',
    gradientDirection: 'Gradient direction',
    directionCaption: 'Drag slider to set direction of a gradient',
    offset: 'Offset',
    gradientOffset: 'Gradient offset',
    offsetCaption: 'Drag slider to set offset of a gradient',
    backgroundDarkness: 'Background darkness',
    backgroundDarknessCaption: 'Drag slider to darken a background image',
    uploadVideo: 'Upload video',
    uploadFile: 'Upload file',
    uploadVideoCaption: 'Video of your page background',
    linkToVideo: 'Link to video',
    linkToVideoCaption: 'Add link to video',
    videoWithSound: 'Video with sound',
    videoWithSoundCaption: 'Play video with sound',
    fonts: 'Fonts',
    fontRoles: {
      heading: 'Heading',
      subtitle: 'Subtitle',
      body: 'Global',
    },
    fontWeight: 'Font weight',
    fontWeightCaption: 'Click to choose your destiny',
    preloader: 'Preloader',
    preview: 'Preview',
    hideLogo: 'Hide UniLink logo',
    cover: 'Cover',
    coverCaption: 'Change cover',
    coverCaptionHeader: 'Add image or video to header cover',
    pageNavigation: 'Page navigation',
    websiteNavigation: 'Tab navigation',
    backgroundOpacity: 'Background opacity',
    backgroundOpacityCaption: 'Drag slider to opacity button background',
    borderRadius: 'Border radius',
    borderRadiusCaption: 'Drag slider to set border radius',
    heightTabs: 'Height tabs',
    heightTabsCaption: 'Drag slider to set height of tabs',
    backgroundShadow: 'Background shadow',
    backgroundShape: 'Background shape',
    backgroundBorder: 'Background border',
    opacity: 'Opacity',
    opacityCaption: 'Drag slider to set opacity',
    shape: 'Shape',
    shapeCaption: 'Set shape',
    text: 'Text',
    textCaption: 'Enter text',
    textSize: 'Text size',
    textSizeCaption: 'Drag slider to set text size',
    additionalText: 'Additional text',
    username: 'Username',
    currency: 'Currency',
    language: 'Language',
    timeZone: 'Time zone',
    websiteNiche: 'Website niche',
    websiteNicheCaption: 'Enter your website niche',
    renameCaption: 'Rename block title',
    description: 'Description',
    descriptionCaption: 'Enter a description',
    actionButton: 'Action button',
    actionButtonCaption: 'Call To Action button motivates visitors to take action',
    animationDirection: 'Animation direction',
    animationDirectionCaption: 'Choose animation direction',
    animationSpeed: 'Animation speed',
    animationSpeedCaption: 'Set how fast the text scrolls',
    fadeEdges: 'Fade text at edges',
    fadeEdgesCaption: 'Softly blur the running text where it meets the edges',
    buttonTitle: 'Button title',
    buttonTitleCaption: 'Enter button title',
    buttonUrl: 'Button URL',
    buttonUrlCaption: 'URL will open in a new window',
    imageSize: 'Image size',
    imageSizeCaption: 'Drag slider to set image size',
    view: 'View',
    viewCaption: 'Choose a view',
    margin: 'Margin',
    marginCaption: 'Drag slider to add margin to both top and bottom of the item',
    separateTopBottom: 'Top / Bottom',
    padding: 'Padding',
    paddingCaption: 'Drag slider to add padding to top and bottom of the item',
    fullWidth: 'Full width',
    lineHeight: 'Line height',
    lineHeightCaption: 'You can change line height',
    button: 'Button',
    titleSize: 'Title size',
    titleSizeCaption: 'You can change title size',
    titleLineHeight: 'Title line height',
    titleLineHeightCaption: 'Customize your title line height to bring more design solutions to the text',
    layout: 'Layout',
    layoutCaption: 'Create the header layout you want',
    layoutAlign: 'Layout align',
    alignText: 'Align text',
    align: 'Align',
    alignCaption: 'Choose alignment',
    position: 'Position',
    positionCaption: 'Choose position',
    width: 'Width',
    widthCaption: 'Choose width of your banner',
    nameHeader: 'Name',
    nameCaption: 'Enter name of your account',
    shortBio: 'Short bio',
    shortBioCaption: 'Enter short bio of your account',
    externalLink: 'External link',
    externalLinkCaption: 'Enter external link to your account',
    location: 'Location',
    locationCaption: 'Enter your location',
    locationMap: 'Location map',
    locationMapCaption: 'Enter URL of your location',
    rightIcon: 'Right icon',
    rightIconCaption: 'This icon will appear on right side of button',
    buttons: 'Buttons',
    buttonsCaption: 'Add action buttons',
    nameLogo: 'Name logo',
    nameLogoCaption: 'Upload logo for your name',
    buttonText: 'Button text',
    buttonTextCaption: 'Enter name of your button',
    buttonColor: 'Button color',
    buttonColorCaption: 'Choose colors for button',
    buttonColorCTACaption: 'Choose background color for CTA button',
    cartColor: 'Cart color',
    cartColorCaption: 'Choose background color for cart',
    ctaButton: 'CTA button',
    ctaButtonCaption: 'This icon will appear on right side of button',
    style: 'Style',
    socialIconsStyleCaption: 'You can choose style of your social icons',
    socialIconsShape: 'Social icons shape',
    socialIconsShapeCaption: 'You can choose social icons shape',
    headerTextColorCaption: 'You can choose header text color',
    pictureShape: 'Picture shape',
    pictureShapeCaption: 'You can choose profile picture shape',
    socialLinks: 'Social links',
    socialLinksCaption: 'Add social links buttons for fast connection between you and your clients in one click',
    URL: 'URL',
    URLCaption: 'Enter URL address',
    heading: 'Heading',
    headingTitle: 'Heading title',
    headingTitleCaption: 'Enter heading title',
    headingDescription: 'Heading description',
    headingDescriptionCaption: 'Enter heading description',
    headingImage: 'Heading image',
    headingImageCaption: 'Upload image for your heading',
    headingPosition: 'Heading position',
    headingInsideBlock: 'Inside block',
    headingOutsideBlock: 'Outside block',
    headingDivider: 'Heading divider',
    canonicalURL: 'Canonical URL',
    seo: 'SEO',
    seoCaption: 'Customize your product with meta SEO tags',
    themes: 'Themes',
    brandColors: 'Brand Kit',
    analyzeFromImage: 'Extract colors & fonts from image',
    globalStyleHint: 'Changes apply to every block at once and overwrite their individual design.',
    applyBrandColors: 'Apply to Profile',
    syncBlocks: 'Sync All Blocks',
    brandColorsApplied: 'Brand colors applied',
    generatedPalette: 'Generated Palette',
    applying: 'Applying...',
    syncing: 'Syncing...',
    backgroundType: 'Background type',
    palettes: 'Palettes',
    previewTitle: 'Title',
    previewTitleCaption: 'Enter preview title',
    previewDescription: 'Description',
    previewDescriptionCaption: 'Enter preview description',
    previewButton: 'Button text',
    previewButtonCaption: 'Enter preview button text',
    previewLabel: 'Label text',
    previewLabelCaption: 'Enter preview label text',
    previewThumbnail: 'Thumbnail',
    previewThumbnailCaption: 'Upload preview thumbnail',
  },
  table: {
    clicks: 'Clicks',
    signups: 'Sign-Ups',
    views: 'Impressions',
    orderNumber: 'Order number',
    amount: 'Amount',
    credits: 'Credits',
    invoice: 'Invoice',
    email: 'Email',
    card: 'Card',
    currency: 'Currency',
    name: 'Name',
    contact: 'Contact',
    optIn: 'Opt-in',
    notes: 'Notes',
    address: 'Address',
    date: 'Date',
    action: 'Action',
    custom: 'Custom',
    status: 'Status',
    tags: 'Tags',
    view: 'View',
    remove: 'Remove',
    sendEmail: 'Send Email',
    details: 'Details',
    purchases: 'Purchases',
    order: 'Order',
    money: 'Money',
    type: 'Type',
    orderCode: 'Order code',
  },
  settings: {
    title: 'Settings',
    settings: 'settings',
    accountSettings: 'Account settings',
    email: 'Email',
    subscription: 'Subscription',
    billingHistory: 'Billing history',
    dueTo: 'Due to',
    subscriptionDueTo: 'Subscription due to',
    accountLabel: 'Account',
    profileLabel: 'Profile',
    switchProfile: 'Switch profile',
    createNewProfile: 'Create new profile',
    active: 'Active',
    currentPlan: 'Current plan',
    freePlanHint: 'Upgrade to unlock Pro features & remove limits.',
    to: 'to',
    renews: 'Renews',
    passwordChangeDesc: 'Change your account password',
    apiKeyDesc: 'Use this key to authenticate API requests',
    apiDocumentation: 'API documentation',
    dashboardLanguageDesc: 'Interface language for your account',
    mfa: {
      title: 'Multi-factor authentication (MFA)',
      desc: 'Protect your account with a second step at sign-in: a code from an authenticator app.',
      authenticatorApp: 'Authenticator app',
      authenticatorAppDesc: 'Google Authenticator, 1Password, Authy or any TOTP app',
      enable: 'Enable',
      enabled: 'Enabled',
      enabledSince: 'Enabled since',
      recoveryCodesLeft: 'Recovery codes left',
      disable: 'Disable',
      regenerate: 'Regenerate recovery codes',
      scanQr: 'Scan this QR code with your authenticator app, then enter the 6-digit code it shows.',
      manualEntry: "Can't scan? Enter this key manually:",
      codePlaceholder: '6-digit code',
      codeOrRecoveryPlaceholder: 'Authenticator or recovery code',
      verifyEnable: 'Verify and enable',
      confirm: 'Confirm',
      cancel: 'Cancel',
      confirmDisable: 'Enter a code from your authenticator app or a recovery code to disable MFA.',
      confirmRegenerate: 'Enter a code from your authenticator app to generate new recovery codes. The old ones will stop working.',
      recoveryTitle: 'Save your recovery codes',
      recoveryDesc: 'Each code works once. Use one to sign in if you lose access to your authenticator app. They will not be shown again.',
      copy: 'Copy',
      copied: 'Copied',
      download: 'Download .txt',
      saved: 'I saved them',
      disabledSuccess: 'MFA has been disabled.',
      error: 'Something went wrong. Please try again.',
      trustedTitle: 'Trusted devices',
      trustedDesc: 'Browsers where you chose to skip the code for 90 days.',
      trustedEmpty: 'No trusted devices yet.',
      unknownDevice: 'Unknown device',
      added: 'Added',
      lastUsed: 'Last used',
      expires: 'Expires',
      remove: 'Remove',
      removeError: 'Failed to remove the device.',
    },
    connectedApps: {
      title: 'Connected apps',
      desc: 'AI assistants you allowed to work with your account.',
      howTo:
        'Paste this URL where Claude or ChatGPT lets you add a custom connector (in Claude: Connectors → Add custom connector). If asked how to sign in, keep the default option.',
      connected: 'Connected',
      lastUsed: 'Last used',
      neverUsed: 'Not used yet',
      disconnect: 'Disconnect',
      disconnectConfirm: 'Disconnect {client}? It will stop working until you connect it again.',
      empty: 'No apps connected yet.',
      loadError: 'Could not load connected apps.',
      disconnectError: 'Failed to disconnect the app.',
    },
    cancelSubscription: 'Cancel subscription',
    cancelSubscriptionConfirm: 'Are you sure you want to cancel your subscription?',
    subscriptionCancelled: 'Your subscription has been cancelled. Your plan remains active until the end of the billing period.',
    subscriptionCancelError: 'Failed to cancel subscription. Please contact support.',
    deleteFirst: 'Permanently delete your',
    deleteSecond: 'and all its data. This action cannot be undone.',
    account: {
      title: 'Account',
      usernameNotAvailable: 'Username is not available',
      setupCustomDomain: 'Setup custom domain',
      subtitle: 'Account email, billing, password and api key',
    },
    profile: {
      title: 'Profile',
      usernameNotAvailable: 'Username is not available',
      setupCustomDomain: 'Setup custom domain',
      subtitle: 'Manage username, language, currency, timezone',
      category: 'Category',
      categoryCaption: 'Enter category of your profile',
      usernameDesc: 'Your public handle',
      currencyDesc: 'Used for earnings & payouts',
      languageDesc: 'Language shown to your visitors',
      timeZoneDesc: 'For scheduling & analytics',
      categoryDesc: 'Best describes your profile',
      privateProfile: 'Private profile',
      privateProfileDesc: 'Only approved followers can view your profile',
    },
    aiassistant: {
      title: 'AI Assistant',
      subtitle: 'Customize your AI assistant for better, more personalized responses',
      titleText: 'Help the AI understand who you are for more relevant responses',
      customAiTitle: 'Custom instructions',
      customAiPlaceholder: 'Add any specific instructions for the AI...',
      customAiDescription: 'These instructions will be applied to every conversation with the AI',
      nicknameTitle: 'What should AI call you?',
      nicknamePlaceholder: 'Nickname',
      titleBio: 'Bio/ Description',
      bioPlaceholder: 'Tell us a bit about yourself...',
      occupation: 'What do you do?',
      occupationPlaceholder: 'e.g. Engeneering student at University of Waterloo',
      aboutYouTitle: 'About You',
      aboutYouTooltip: 'Tell your AI assistant a little about yourself',
      locationTitle: 'Location',
      locationPlaceholder: 'e.g. Kyiv, Ukraine',
      categoryTitle: 'Category',
    },
    notifications: {
      title: 'Notifications',
      subtitle: 'Set up notifications about new visitors emails and orders',
      text: `Connect messengers to get notifications about new client's email and order`,
      setUpWebhooks: 'Set up webhooks in Webhooks section',
      save: 'Save',
      connect: 'CONNECT',
      disconnect: 'DISCONNECT',
      webhook: 'Webhook',
      emailSubmit: 'Data collect submit',
      formSubmit: 'Form submit',
      showSubmit: 'Shop submit',
      digitalSubmit: 'Digital submit',
      appointmentSubmit: 'Appointment submit',
      requestSubmit: 'Service submit',
      donationSubmit: 'Donation submit',
      email: 'Email',
      settings: 'settings',
      cartSubmit: 'Cart submit',
      linkClick: 'Link click',
      contactClick: 'Contact click',
      all: 'All',
      updates: 'Updates',
      messages: 'Messages',
      opportunities: 'Opportunities',
      insights: 'Insights',
      activity: 'Activity',
      system: 'System',
      news: 'News',
      more: 'Show more',
      less: 'Show less',
      connectedAccounts: 'Connected accounts',
      addEmailAccount: 'Add email account',
    },
    paymentSystem: {
      title: 'Payment system',
      subtitle: 'Set up payouts through Stripe or PayPal',
      text: 'View processing fees',
      connected: 'Connected',
      active: 'Accept payments on website',
      pending: 'Pending',
      disconnect: 'Disconnect',
      connect: 'Connect',
      add: 'Add',
      ofYourAccount: 'of your account',
      save: 'Save',
    },
    manualPayments: {
      title: 'Manual / Offline payments',
      hint: 'Customers pay offline (bank transfer, cash, QR). You confirm the order manually.',
      save: 'Save',
      iban: 'IBAN',
      accountHolder: 'Account holder name',
      bankName: 'Bank name',
      phone: 'Phone',
      payeeName: 'Payee name',
      cardNumber: 'Card number',
      cardInvalid: 'Please check the card number',
      messengerUrl: 'Messenger for proof',
      messengerUrlHint: 'Optional. Buyers can send the payment screenshot here (Telegram / WhatsApp / Viber).',
      instruction: 'Instruction',
      instructionHint: 'Decorate with **bold** ~strike~ _italic_',
      requireProof: 'Require payment proof',
      requireProofHint: 'To finalize the checkout, customers must upload a screenshot (receipt, bank transfer confirmation, or any proof of payment).',
      markPaidOnConfirm: 'Mark as paid upon customer confirmation',
      markPaidOnConfirmHint: `Automatically updates the payment status to 'Paid' once the customer confirms their payment.`,
      contactBeforePay: 'Enable contact seller before payment',
      contactBeforePayHint: 'Lets customers skip payment to message the seller, increasing inquiries but building trust and reducing cancellations.',
    },
    shop: {
      title: 'Shop',
      subtitle: 'Setting category and property',
      label: {
        title: 'Labels',
        subtitle: 'Add labels to product cards',
        addValue: 'Add value',
        save: 'Save',
        value: 'Value',
        enterTitle: 'Enter title',
        maximum: 'Maximum number of values can be 5',
        add: 'Add',
        edit: 'Edit',
        labels: 'Labels',
      },
      category: {
        title: 'Categories',
        subtitle: 'Add category to your products',
        addCategory: 'Add category',
        save: 'Save',
        maximum: 'Maximum number can be',
        editTitle: 'Category',
        name: 'Name',
        namePlaceholder: 'Enter the category',
        visibility: 'Visibility',
        visible: 'Visible',
        hidden: 'Hidden',
        description: 'Description',
        descriptionHint: 'Description must be less than 100 characters',
        descriptionPlaceholder: 'Add a short description',
        cover: 'Cover',
        view: 'View',
        share: 'Share',
        linkCopied: 'Link copied',
        saveFirst: 'Save the category first',
        moveOut: 'Move out',
      },
      property: {
        title: 'Property',
        subtitle: 'Add property to your products',
        addProperties: 'Add properties',
        properties: 'Properties',
        type: 'Type',
        typeTooltip: 'Type of your properties',
        titleModal: 'Title',
        titleModalTooltip: 'Name of your properties',
        enterTitle: 'Enter the title',
        value: 'Value',
        addValue: 'Add value',
        maximum: 'Maximum number of values can be',
        save: 'Save',
        cancel: 'Cancel',
        remove: 'Remove',
        addPropertyToItem: 'Add property to item',
        add: 'Add',
        edit: 'Edit',
        propertiesSmall: 'properties',
        required: 'Required',
        requiredTooltip: 'Set required properties for buying',
        selectAll: 'Select all',
      },
      actionButtons: {
        contentTab: 'Content',
        designTab: 'Design',
        buttonTitle: 'Button title',
        buttonColor: 'Button colour',
        cancel: 'Cancel',
        save: 'Save',
        maxChars: 'Maximum {count} characters',
        minChars: 'Minimum {count} characters',
        enterTitle: 'Enter a button title',
        contactTooltip: 'One way for customers to reach you: email, message or a form',
        contactNotConfigured: 'Set up how customers reach you',
        methodEmail: 'Email letter',
        methodMessenger: 'Messenger',
        methodForm: 'Request form',
        enterAddress: 'Enter an address',
        invalidAddress: 'Invalid address',
        enterContact: 'Enter a number or username',
        summaryFields: '{count} fields',
        dragToReorder: 'Drag to reorder',
        fieldName: 'Field name',
        fieldRequired: 'Required',
        deleteField: 'Delete field',
        enterFieldName: 'Enter a field name',
        addAtLeastOneField: 'Add at least one field',
        maxFields: 'Maximum {count} fields',
        typeText: 'Text',
        typeEmail: 'Email',
        typePhone: 'Phone',
        preorderTooltip: 'Preorder form for this product',
        preorderRowHint: 'Fields the buyer fills in — open to edit',
        saveFailed: 'Could not save. Try again.',
        preorderNotConfigured: 'Set up the preorder form',
        enableAtLeastOneField: 'Enable at least one field',
        enterSubmitTitle: 'Enter a submit button title',
        invalidUrl: 'Invalid link',
        redirectHelper: 'Leave it empty and the customer stays on the page and sees the text below.',
        discardTitle: 'Close without saving?',
        discardText: 'Changes to the button settings will be lost.',
        discardContinue: 'Keep editing',
        discardClose: 'Close',
        contactModalTitle: 'Contact button',
        preorderModalTitle: 'Preorder button',
        contactModalSubtitle: 'One action per button. Where the result lands is set on the next screen',
        actionTab: 'Action',
        methodFormDesc: 'The customer fills in fields',
        methodChat: 'Live chat',
        methodChatDesc: 'A real-time conversation right here',
        methodMessengerDesc: 'WhatsApp, Telegram, Viber…',
        methodEmailDesc: "Opens the customer's mail app",
        inboxDefaultNote: 'By default everything is kept in your Unilink Inbox — you can change that later.',
        readyToSave: 'Ready to save',
        apply: 'Apply',
        back: 'Back',
        pickAction: 'Choose what the button does',
        buttonText: 'Button text',
        buttonBackground: 'Button background',
        buttonTextColor: 'Text colour',
        lowContrastWarning: 'The text blends into the background — the customer will not be able to read the label.',
        colorsSharedNote: 'The colours apply to the button as it appears on the product page.',
        chatNoSetup: 'Nothing to set up: the chat opens on the page and the conversation goes to your Inbox.',
        yourEmail: 'Your email',
        yourEmailHelper: "The customer's mail app opens with a letter to this address.",
        channelAndContact: 'Channel and contact',
        singleChannelNote: 'The button opens a chat in the chosen app right away.',
        addContact: 'Add a contact',
        deleteContact: 'Delete contact',
        contactsCount: '{count} contacts',
        maxContacts: 'Maximum {count} contacts',
        duplicateContact: 'This app is already in the list',
        multiChannelNote: 'The button opens a list and the customer picks the app.',
        recapMessengers: 'The customer picks: {apps}',
        whatToAsk: 'What to ask',
        fieldsOfMax: '{count} of {max} fields',
        fieldOptional: 'Optional',
        typeLongText: 'Long text',
        duplicateField: 'A field with this name is already above',
        addReplyableField: 'Add an email or a phone — otherwise there is no way to reply',
        presetName: 'Name',
        presetEmail: 'Email',
        presetPhone: 'Phone',
        presetComment: 'Comment',
        presetOwnField: 'own field',
        thanksText: 'Text after sending',
        thanksPlaceholder: 'Thank you! We will reply within the day.',
        recapForm: 'The request arrives {targets}',
        recapChat: 'The conversation goes to your Unilink Inbox',
        recapMessenger: 'The customer goes to {app}',
        recapEmail: "The customer's mail opens with a letter to {address}",
        recapEmailFallback: 'your address',
        recapTargetInbox: 'in your Unilink Inbox',
        actionsLabel: 'Ways to reach you',
        actionsOfMax: '{count} of {max}',
        actionsCount: '{count} actions',
        addAction: 'Add an action',
        addFirstAction: 'Add the first way for customers to reach you',
        deleteAction: 'Delete action',
        actionNeedsAttention: 'Needs finishing',
        severalActionsNote: 'Each action is its own button on the product page, in this order.',
        methodAlreadyAdded: 'Already in the list',
        duplicateChannel: 'This channel with this contact is already in the list',
        duplicateTitle: 'Another button already uses this text',
        defaultTitleForm: 'Contact us',
        defaultTitleChat: 'Chat with us',
        defaultTitleEmail: 'Email us',
        buyModalTitle: 'Buy button',
        buyModalSubtitle: 'Takes the buyer straight to payment',
        buyTooltip: 'The button takes the buyer straight to payment',
        buyNoPrice: 'Label only, no price',
        priceOnButton: 'Price on the button',
        priceOnButtonHelper: 'Leave it empty and the button shows the label alone',
        invalidPrice: 'The price is a number only, e.g. 990',
        redirectModalTitle: 'Redirect button',
        redirectModalSubtitle: 'Sends the visitor to any page by link',
        redirectTooltip: 'The button opens any page by link',
        linkLabel: 'Link',
        linkPlaceholder: 'https://example.com/page',
        opensHost: 'Opens: {host}',
        openInNewTab: 'Open in a new tab',
        enterLink: 'Enter the link this button opens',
        noLinkSet: 'No link set',
        preorderModalSubtitle: 'Collects preorders before sales start — no payment',
        shipEta: 'When you ship',
        shipEtaPlaceholder: 'e.g. by 15 September',
        shipEtaHelper: 'Shown in the form — the buyer sees the wait and asks "when?" less often',
        fieldsInForm: 'Fields in the form: {count}',
        enableFieldFirst: 'Switch the field on first',
        submitInForm: "The form's button text",
        afterSubmit: 'After sending',
        afterSubmitText: 'Show a text',
        afterSubmitUrl: 'Send to a page',
        afterSubmitTextHelper: 'The buyer stays on the page and reads this text',
        preorderThanksPlaceholder: "Thank you! We'll write when the product is ready.",
        enterRedirectUrl: 'Enter the page URL, or go back to showing a text',
        downloadModalTitle: 'Download button',
        downloadModalSubtitle: 'Hands the visitor a file — a guide, a price list, a sample',
        downloadTooltip: 'The button gives the visitor a file to save',
        fileLabel: 'File',
        filePlaceholder: 'https://cdn.unilink.us/file.pdf',
        uploadFile: 'Upload',
        uploading: 'Uploading…',
        sendsFile: 'Sends: {file}',
        noFileSet: 'No file set',
        enterFile: 'Upload a file or paste its link',
        calendarModalTitle: 'Add to calendar',
        calendarModalSubtitle: "Puts the event in the visitor's own calendar",
        calendarTooltip: 'The button adds the event to the calendar',
        eventName: 'Event name',
        eventNamePlaceholder: 'e.g. Pottery class',
        eventStart: 'Starts',
        eventEnd: 'Ends',
        eventTimeHelper: 'The time the visitor sees, in their own calendar',
        eventEndHelper: 'Leave it empty and the entry lasts an hour',
        eventLocation: 'Location',
        eventLocationPlaceholder: 'Address or a link to the meeting',
        eventDetails: 'Details',
        eventDetailsPlaceholder: 'What to bring, how to find you…',
        noEventSet: 'No event set',
        enterEventName: 'Enter the event name',
        enterEventStart: 'Choose when the event starts',
        invalidEventStart: 'Invalid start date',
        endBeforeStart: 'The end is before the start',
        shareModalTitle: 'Share button',
        shareModalSubtitle: 'Opens the share sheet so the visitor can pass the product on',
        shareTooltip: 'The button opens the share sheet',
        shareLinkLabel: 'Link to share (optional)',
        sharesThisPage: 'Shares the page the button is on',
        sharesHost: 'Shares: {host}',
      },
      preorderForm: {
        title: 'Preorder form',
        subtitle: 'Setup preorder form fields',
        fields: 'Fields',
        fieldsTooltip: 'Add fields to the form',
        required: 'Required',
        submitButton: 'Submit button title',
        redirectUrl: 'Redirect url (optional)',
        resultText: 'Result text',
        save: 'Save',
        name: 'Name',
        emailAddress: 'Email address',
        phone: 'Phone',
        address: 'Address',
        comment: 'Comment',
      },
      shipping: {
        title: 'Checkout form',
        subtitle: 'Fields the buyer fills in when ordering',
        fields: 'Fields',
        fieldsTooltip: 'Add fields to the checkout form',
        required: 'Required',
        save: 'Save',
        name: 'Name',
        emailAddress: 'Email address',
        phone: 'Phone',
        address: 'Address',
        comment: 'Comment',
        askDetails: 'Ask the buyer for details',
        askDetailsHint: 'Off — the checkout takes the order without a form',
        askDetailsPaymentWarning:
          'Checkout takes payment online. With no email there is nowhere to send the receipt — leave at least Email on, or switch checkout to «Take the order, no payment».',
        askDetailsRedirectNote: 'Checkout happens on another site — these fields are never shown to buyers.',
        askDetailsNoContactNote: 'The order will arrive with no contact details. Leave Phone on if you plan to call the buyer back.',
        promoCode: 'Promo code',
        shared: 'Use this form for all products',
        sharedHint: 'Products without a checkout of their own follow it',
        sharedNote: 'Digital products, courses, events and appointments now ask for exactly these fields. A product that has its own form keeps it.',
        addCustomField: 'Add custom field',
        addFormInfo: 'Add form info',
        editFormInfo: 'Edit form info',
        type: 'Type',
        typeTooltip: 'Custom field type',
        fieldName: 'Field name',
        fieldNameTooltip: 'Name for custom field',
        placeholder: 'Placeholder',
        placeholderTooltip: 'Placeholder for custom field',
        delete: 'Delete',
        update: 'Update',
        add: 'Add',
      },
      delivery: {
        title: 'Delivery methods',
        subtitle: 'Shipping, delivery and pickup',
        loading: 'Loading…',
        inactive: 'inactive',
        confirmDelete: 'Delete this delivery method?',
        category: {
          shipping: 'Shipping',
          localDelivery: 'Local delivery',
          selfPickup: 'Self pickup',
        },
        rateType: {
          free: 'Free',
          conditionalFree: 'Conditional free',
          flatRate: 'Flat rate',
          customRates: 'Custom rates',
          carrierApi: 'Carrier API',
        },
        carrier: {
          custom: 'Custom carrier',
        },
        add: {
          shipping: 'Add Shipping',
          localDelivery: 'Add Local delivery',
          selfPickup: 'Add Self pickup',
        },
        actions: {
          edit: 'Edit',
          delete: 'Delete',
          save: 'Save',
          cancel: 'Cancel',
        },
        fields: {
          name: 'Name',
          namePh: 'e.g. Standard shipping',
          description: 'Description',
          isActive: 'Active',
          estimatedDays: 'Estimated days',
          currency: 'Currency',
          countryCodes: 'Country codes (CSV)',
          carrier: 'Carrier',
          rateType: 'Rate type',
          flatPrice: 'Flat price',
          freeThreshold: 'Free over (subtotal)',
          fallbackPrice: 'Fallback price',
          customRates: 'Custom rate rows',
          senderCity: 'Sender city name',
          senderCityRef: 'Sender city ref',
          pickupInstructions: 'Pickup instructions',
          pickupCharge: 'Pickup charge',
          askPickupDateTime: 'Ask pickup date/time at checkout',
        },
        rateRow: {
          subtotal: 'By subtotal',
          weight: 'By weight (g)',
          min: 'Min',
          max: 'Max',
          price: 'Price',
          add: 'Add row',
        },
      },
      legal: {
        title: 'Legal documents',
        subtitle: 'Terms, Privacy, Return policy',
        loading: 'Loading…',
        empty: 'No legal documents yet.',
        inactive: 'inactive',
        required: 'required',
        confirmDelete: 'Delete this document?',
        addNew: '+ Add document',
        types: {
          terms: 'Terms of Service',
          privacy: 'Privacy Policy',
          returns: 'Return / Refund Policy',
          shipping: 'Shipping Policy',
          cookies: 'Cookie Policy',
          custom: 'Custom',
        },
        fields: {
          title: 'Title',
          titlePh: 'e.g. Terms of Service',
          type: 'Document type',
          content: 'Content',
          contentPh: 'Write your legal text here…',
          isActive: 'Active',
          requireAcceptance: 'Require acceptance at checkout',
        },
        actions: {
          edit: 'Edit',
          delete: 'Delete',
          save: 'Save',
          cancel: 'Cancel',
        },
      },
      checkoutGroup: 'Checkout',
      serviceCharge: {
        title: 'Service charge',
        subtitle: 'Add a service fee or tip to every order.',
        label: 'Description',
        labelPh: 'e.g. Service fee 5% and delivery tip $3',
        rate: 'Rate',
        rateHint: 'Percent of the order subtotal.',
        amount: 'Amount',
        amountHint: 'Fixed amount added on top.',
      },
      tip: {
        title: 'Tips',
        subtitle: 'Let customers add a tip to their order at checkout.',
        enable: 'Enable tips',
        presets: 'Tip presets (%)',
        noPresets: 'No presets yet — add one below.',
        presetPh: 'e.g. 10',
        addPreset: '+ Add preset',
        presetsHint: 'Shown as quick-pick buttons on checkout. Up to 6.',
        remove: 'Remove',
        allowCustom: 'Allow custom amount',
        label: 'Prompt label',
        labelPh: 'e.g. Add a tip for great service',
        save: 'Save',
        saving: 'Saving…',
      },
      orderNumber: {
        title: 'Order number',
        subtitle: 'Customize how order numbers look.',
        next: 'Next order number',
        prefix: 'Prefix',
        suffix: 'Suffix',
        showInMessage: 'Show in invoice and order message',
        reset: 'Reset order number',
      },
      orderMessage: {
        title: 'Order message',
        subtitle: 'Customize the order confirmation sent to customers.',
        footer: 'Message footer',
        footerPh: 'e.g. Thanks for your order! Follow us @yourbrand',
        footerHint: 'Appended to every order confirmation message.',
        plain: 'Plain message',
        plainHint: 'Remove all formatting from the order message.',
      },
      invoice: {
        title: 'Invoice',
        subtitle: 'Branded invoice attached to paid orders.',
        upgrade: 'Upgrade',
        showLogo: 'Show logo',
        header: 'Header',
        footer: 'Footer',
        companyName: 'Company name',
        companyEmail: 'Company email',
        companyPhone: 'Company phone',
        companyAddress: 'Company address',
        companyAddressPh: 'Enter address',
      },
    },
    seo: {
      title: 'SEO',
      subtitle: 'Customize your page with meta SEO tags',
      titleText: 'Title',
      titlePlaceholder: 'Enter page title',
      description: 'Description',
      descriptionPlaceholder: 'Enter page description',
      favicon: 'Favicon',
      uploadFavicon: 'Upload favicon',
      imagePreview: 'Image preview',
      useCustom: 'Use custom image',
      save: 'Save',
      visualise: 'Visualise how your website preview will look like in Google',
      inMessengers: 'In messengers',
      inSocial: 'In social media',
      searchEngine: 'Search engine',
      googleIndexable: 'Google indexable',
      sitemap: {
        title: 'Sitemap',
        entryHint: 'Manage which pages and products search engines can index.',
        setupLink: 'customize',
        mainEntry: 'Index Website',
        subtitle: 'Choose which pages search engines should index. Disabled pages get a noindex tag and are removed from your sitemap.',
        mainPage: 'Main profile page',
        pagesSection: 'Pages',
        pagesHint: 'Toggle indexing for each additional page of your site.',
        noPages: 'No additional pages yet.',
        productsSection: 'Products',
        productsHint: 'Toggle indexing for individual product pages.',
        noProducts: 'No products yet.',
        postsSection: 'Posts',
        postsHint: 'Toggle indexing for individual posts.',
        noPosts: 'No posts yet.',
        blogSection: 'Blog articles',
        blogHint: 'Toggle indexing for individual blog articles.',
        noArticles: 'No blog articles yet.',
        loadMore: 'Load more',
        loading: 'Loading…',
      },
    },
    analytics: {
      title: 'Analytics',
      subtitle: 'Integrate Facebook Pixel, Google Analytics, and an UTM parameters',
      facebookTooltip: 'Connect Facebook to display analytics',
      googleAnalyticsTooltip: 'Google Analytics lets you measure your advertising ROI as well as track all your links.',
      googleTagManagerTooltip: 'Google tag manager lets you configure and instantly deploy tags on your website',
      tikTokPixelTooltip: 'The TikTok Pixel is a powerful measurement tool that tracks your TikTok ads impact on your website',
      pinterestTag: 'Pinterest tag',
      pinterestTagTooltip:
        'The Pinterest tag is a piece of code that you add to your website which lets Pinterest track visitors to your site as well as the actions they take on your site after seeing your Pinterest ad.',
      tag: 'tag',
      headerTagTooltip: 'Paste tag that appears in the head of your website',
      bodyTagTooltip: 'Paste tag that appears in the body of your website',
      utmParameters: 'UTM parameters',
      utmParametersTooltip: 'Collect campaign data with custom URLs. Add parameters to URLs to identify the campaigns that refer traffic.',
      makeAnalytics: 'Make Google Analytics show UniLink traffic as Social',
      the: 'The',
      campaign: 'campaign',
      parameter: 'parameter is set dynamically from the title of each post or link',
      save: 'Save',
    },
    customDomain: {
      title: 'Custom domain',
      subtitle: 'Customize your page with custom domain',
      titleTooltip: 'Add custom domain',
      save: 'Save',
      connect: 'Connect',
      connecting: 'Connecting',
      instructions: 'Instructions',
      submit: 'Submit',
      submitting: 'Submitting...',
      enterDomain: 'Enter your domain',
      domainPlaceholder: 'your-domain.com',
      steps: {
        submitting: 'Submitting request',
        validation: 'Domain validation',
        certificate: 'Certificate provisioning',
        complete: 'Complete',
      },
      txtRecord: {
        title: 'TXT Record',
        description: 'Add the following TXT record to your DNS settings:',
        verifyButton: 'Verify TXT Record',
        verifying: 'Verifying...',
        verified: 'TXT record verified',
      },
      cnameRecord: {
        title: 'CNAME Record',
        description: 'Add the following CNAME record to your DNS settings:',
        verifyButton: 'Verify CNAME Record',
        verifying: 'Verifying...',
        verified: 'CNAME record verified',
      },
      dnsTable: {
        type: 'Type',
        host: 'Host',
        value: 'Value',
        ttl: 'TTL',
        copy: 'Copy',
        copied: 'Copied!',
      },
      provisioning: {
        title: 'SSL certificate is being provisioned...',
        description: 'This may take a few minutes. Please wait.',
        timeout: 'Certificate provisioning is taking longer than expected. Please check back later.',
      },
      complete: {
        title: 'HTTPS has been successfully enabled on your domain.',
        connected: 'Connected',
      },
      failed: {
        title: 'Domain connection failed',
        tryAgain: 'Try Again',
      },
      rootDomainWarning: 'Root domains require your DNS provider to support CNAME flattening (e.g., Cloudflare, Route53).',
      deleteConfirm: {
        title: 'Disconnect domain',
        message: 'Are you sure you want to disconnect this domain? Your website will no longer be accessible via this domain.',
        confirm: 'Disconnect',
        cancel: 'Cancel',
      },
    },
    developerApi: {
      title: 'Developer API',
      subtitle: 'Create API keys to access your orders, products and customers via the /api/v2 endpoints.',
      keyName: 'Key name',
      keyNamePh: 'e.g. Warehouse sync',
      scopes: 'Permissions',
      scopeLabels: {
        'orders:read': 'Read orders',
        'products:read': 'Read products',
        'products:write': 'Update product stock',
        'customers:read': 'Read customers',
      },
      create: 'Create key',
      creating: 'Creating…',
      created: 'API key created',
      copyWarning: 'Copy this key now — it will not be shown again.',
      done: 'Done',
      revoke: 'Revoke',
      revoked: 'Revoked',
      confirmRevoke: 'Revoke this API key? Apps using it will stop working.',
      empty: 'No API keys yet.',
    },
    whatsapp: {
      title: 'WhatsApp Business',
      subtitle: 'Connect your WhatsApp Business number to receive and reply to customer messages.',
      phoneNumberId: 'Phone number ID',
      accessToken: 'Access token',
      displayPhone: 'Display phone (optional)',
      connect: 'Connect',
      connecting: 'Connecting…',
      connected: 'Connected',
      disconnect: 'Disconnect',
      confirmDisconnect: 'Disconnect WhatsApp?',
      webhookHelp: 'Set this Callback URL and Verify token in your Meta App → WhatsApp → Configuration:',
      webhookUrl: 'Callback URL',
      verifyToken: 'Verify token',
      inbox: 'Inbox',
      noMessages: 'No messages yet.',
      selectThread: 'Select a conversation.',
      replyPlaceholder: 'Type a message…',
      send: 'Send',
      broadcast: {
        title: 'Broadcast',
        audienceInbox: 'Inbox contacts',
        audienceCrm: 'CRM audience (template)',
        message: 'Message',
        inboxHint: 'Free-form text — only delivered to contacts within the 24h customer-service window.',
        templateName: 'Template name',
        templateLang: 'Template language',
        crmHint: 'Use an approved WhatsApp template — required to reach contacts outside the 24h window.',
        send: 'Send broadcast',
        sending: 'Sending…',
        empty: 'No broadcasts yet.',
        sent: 'sent',
        failed: 'failed',
      },
      autoReply: {
        title: 'Auto-replies',
        type: 'Type',
        typeKeyword: 'Keyword',
        typeGreeting: 'Greeting (first message)',
        typeAway: 'Away (outside hours)',
        keyword: 'Keyword',
        from: 'Hours from',
        to: 'Hours to',
        reply: 'Reply text',
        add: 'Add rule',
        empty: 'No auto-reply rules yet.',
        delete: 'Delete',
      },
    },
    webhooks: {
      title: 'Webhooks',
      subtitle: 'Send real-time event notifications to external services',
      webhook: 'Webhook',
      webhookTooltip: 'Add webhook',
      send: 'Send events to 3d party website',
      webhookUrl: 'Webhook URL (POST request)',
      error: 'Enter correct link',
      save: 'Save changes',
      enableWebhooks: 'Enable Webhooks',
      enableDescription: 'POST requests on selected events',
      endpointUrl: 'Endpoint URL',
      endpointTooltip: 'The URL that will receive POST requests when selected events occur',
      automationHint: 'Works with automation tools — connect one to send these events anywhere:',
      automationDocs: 'Open setup guide',
      endpointPlaceholder: 'https://example.com/api/webhook',
      events: 'Events',
      selectAll: 'Select all',
      deselectAll: 'Deselect all',
      filterPlaceholder: 'Filter events...',
      all: 'All',
      none: 'None',
      active: 'Active',
      inactive: 'Inactive',
      categories: {
        submissions: 'Submissions',
        engagement: 'Engagement',
      },
      eventLabels: {
        SubmitHeaderSubscribe: 'Header Subscribe',
        SubmitHeaderMessage: 'Header Message',
        SubmitDataCollect: 'Data Collect',
        SubmitForm: 'Form Submit',
        SubmitShop: 'Shop Order',
        SubmitShopPreorder: 'Shop Preorder',
        SubmitDigital: 'Digital Product',
        SubmitAppointment: 'Appointment',
        SubmitService: 'Service Order',
        SubmitEvent: 'Event Registration',
        SubmitCourse: 'Course Enrollment',
        SubmitDonation: 'Donation',
        SubmitMembership: 'Membership',
        SubmitBlog: 'Blog Purchase',
        SubmitCoupon: 'Coupon Used',
        SubmitTip: 'Tip',
        SubmitLink: 'Link Purchase',
        SubmitProductMessage: 'Product Question',
        SubmitPodcast: 'Podcast Purchase',
        SubmitBooking: 'Booking',
        SubmitRental: 'Rental',
        SubmitSingleProduct: 'Single Product',
        SubmitDiscount: 'Discount Order',
        SubmitListing: 'Listing Request',
        SubmitUnlock: 'Content Unlock',
        SubmitChatAi: 'AI Chat Message',
        ClickLink: 'Link Click',
        ClickContact: 'Contact Click',
        AddToCart: 'Add to Cart',
        AddToCartSingleProduct: 'Single Product to Cart',
        AddToWishlist: 'Add to Wishlist',
        InitiateCheckout: 'Initiate Checkout',
        DownloadFile: 'File Download',
        DownloadMusic: 'Music Download',
        CopyCoupon: 'Copy Coupon',
        CopyDiscount: 'Copy Discount',
        QR_ScanQrCode: 'QR Code Scan',
        VisitPage: 'Page Visit',
      },
    },
    sensitive: {
      title: 'Sensitive material',
      subtitle: 'Show a sensitive content warning before displaying your website',
    },
    socialIntegration: {
      title: 'Social integrations',
      subtitle: 'Manage your Instagram, TikTok integrations',
      connectInstagram: 'Connect instagram',
    },
    emailIntegration: {
      title: 'Audience integrations',
      subtitle: 'Pass your visitors email addresses to MailChimp, Reply',
      emailCaption: 'Add an integration to pass your followers email addresses to MailChimp',
      mailChimp: 'MailChimp integrations',
      selzy: 'Selzy integrations',
      selzyCaption: 'Add an API key to pass your followers email addresses to Selzy',
      sendPulse: 'SendPulse integrations',
      sendPulseCaption: 'Add an API key to pass your followers email addresses to SendPulse',
      reply: 'Reply integrations',
      replyCaption: 'Add an API key to pass your followers email addresses to',
      integrations: 'integrations',
    },
    calendarIntegration: {
      title: 'Calendar integrations',
      subtitle: 'Connect your calendar services',
      calendly: 'Calendly',
      calendlyDescription: 'Connect Calendly to sync your event types and availability',
      googleCalendar: 'Google Calendar',
      googleCalendarDescription: 'Connect Google Calendar to sync events and create Google Meet links',
      zoom: 'Zoom',
      zoomDescription: 'Connect Zoom to create meeting links automatically',
      googleMeet: 'Google Meet',
      googleMeetDescription: 'Create Google Meet links automatically (requires Google Calendar)',
    },
    storage: {
      title: 'Storage',
      subtitle: 'Save visitors order to Google Spreadsheet',
      storageCaption: `Add an integration to save all client's order to Google Spreadsheet`,
      emailSignup: 'Email signup',
      emailSignupsCaption: 'Choose table for saving email signup',
      formSignups: 'Form Signup',
      forSignupsCaption: 'Choose table for saving form signup',
      shopOrders: 'Shop orders',
      shopOrderCaption: 'Choose table for saving shop orders',
      disconnect: 'Disconnect spreadsheet',
      storageUsage: 'Storage usage',
      of: 'of',
      uses: 'This app uses',
      space: 'of your free disk space',
      view: 'view details',
      noItems: 'There is no items',
      files: 'Files',
      images: 'Images',
      videos: 'Videos',
      audio: 'Audio',
      settings: 'settings',
      free: 'free',
      needMoreSpace: 'Need more space?',
      unlockStorage: 'Unlock unlimited storage, 4K video',
      upgradePlan: 'Upgrade Plan',
      addFile: 'Add file',
      uploading: 'Uploading...',
      dragDrop: 'or drag and drop here',
      noFilesYet: 'No files yet',
      noImagesYet: 'No images yet',
      noVideosYet: 'No videos yet',
      noAudioYet: 'No audio yet',
      filesHint: 'Upload PDFs, docs and other downloads to attach them to your bio page links.',
      imagesHint: 'Upload images to use across your bio page.',
      videosHint: 'Upload videos to embed on your bio page.',
      audioHint: 'Upload audio tracks to share on your bio page.',
    },
  },
  productStore: {
    title: 'Show Store tab on your link-in-bio',
    subtitle: 'Your Store is currently hidden.',
  },
  sections: {
    elements: {
      editTitle: 'Edit section',
      sectionTitle: 'Section title',
      sectionTitleCaption: 'Shown above the section. Leave empty, or hide it with the toggle below.',
      sectionTitlePlaceholder: 'For example, Delivery terms',
      hideHeader: 'Hide header',
      textBody: 'Text',
      textBodyCaption: 'A paragraph that supports the block: terms, a disclaimer, an explanation.',
      textBodyPlaceholder: 'Write the text of this section',
      itemsLayout: 'Layout',
      itemsLayoutCaption: 'How the rows are arranged inside this section.',
      layoutList: 'List',
      layoutGrid: 'Grid',
      layoutRow: 'Row',
      image: 'Image',
      imageCaption: 'Uploaded or picked from your media library.',
      imageAlt: 'Alt text',
      imageAltCaption: 'Read by screen readers and shown if the image fails to load.',
      imageAltPlaceholder: 'What is in the picture',
      ratio: 'Proportions',
      ratioCaption: 'Auto keeps the original shape. The others crop to fit.',
      ratioAuto: 'Auto',
      caption: 'Caption',
      captionCaption: 'A short line under the media. Optional.',
      captionPlaceholder: 'Caption',
      linkUrl: 'Link',
      linkUrlCaption: 'Where a click leads. Leave empty for no link.',
      videoUrl: 'Video link',
      videoUrlCaption: 'YouTube, Vimeo, or a direct mp4 link.',
      videoDetected: 'Detected',
      videoNotDetected: 'This link cannot be played here. Use YouTube, Vimeo or a direct mp4 link.',
      videoPoster: 'Cover image',
      videoPosterCaption: 'Shown before playback. YouTube covers are picked up automatically.',
      embedHtml: 'HTML',
      embedHtmlCaption: 'Scripts are removed. Iframes work for YouTube, Vimeo and Spotify only.',
      embedStripped: 'Will be removed on save',
      countdownEnds: 'Ends on',
      countdownEndsCaption: 'The date and time the countdown runs to.',
      countdownNoDate: 'Pick a date and time, otherwise nothing is shown.',
      timezone: 'Time zone',
      timezoneCaption: 'The zone the time above is in. Visitors see the countdown in their own.',
      countdownStyle: 'Style',
      countdownStyleCaption: 'Strip shows days, hours and minutes. Compact is one line.',
      countdownStyleStrip: 'Strip',
      countdownStyleCompact: 'Compact',
      countdownHideWhenEnded: 'Hide timer when countdown ends',
      couponCode: 'Promo code',
      couponCodeCaption: 'Visitors copy it with one tap.',
      couponDescription: 'Description',
      couponDescriptionCaption: 'What the code gives. Optional.',
      couponDescriptionPlaceholder: '20% off your first order',
      couponExpires: 'Valid until',
      couponExpiresCaption: 'After this date the coupon is hidden.',
      couponButtonText: 'Link text',
      couponButtonTextCaption: 'Shown instead of the bare address.',
      couponButtonTextPlaceholder: 'Shop now',
      address: 'Address',
      addressCaption: 'Start typing and pick a suggestion so the pin is exact.',
      addressPlaceholder: 'Street, city',
      addressNotPicked: 'Pick one of the suggestions — without a pin the map is not shown.',
      showDirections: 'Show "Get directions" link',
      galleryItems: 'Images',
      galleryItemsCaption: 'Up to 12. Each can carry a caption.',
      addImage: 'Add image',
      itemTitlePlaceholder: 'Name',
      reviewsItems: 'Reviews',
      reviewsItemsCaption: 'Up to 10 quotes you write yourself.',
      reviewsShowRating: 'Show star ratings',
      addReview: 'Add review',
      reviewName: 'Name',
      reviewRole: 'Role',
      reviewRating: 'Rating 1-5',
      reviewText: 'Review',
      contactItems: 'Contacts',
      contactItemsCaption: 'Up to 6 channels.',
      addContact: 'Add contact',
      contactValuePlaceholder: 'Number, address or username',
      contactLabelPlaceholder: 'Label (optional)',
      channels: {
        phone: 'Phone',
        email: 'Email',
        whatsapp: 'WhatsApp',
        telegram: 'Telegram',
        instagram: 'Instagram',
        website: 'Website',
        address: 'Address',
      },
      summary: {
        oneImage: '1 image',
        manyImages: '{n} images',
        oneReview: '1 review',
        manyReviews: '{n} reviews',
        oneContact: '1 contact',
        manyContacts: '{n} contacts',
      },
    },
    splashScreen: {
      title: 'Splash Screen',
      subtitle: 'Shows up while the page is loading',
      templates: {
        brand: 'Brand splash',
        brandCaption: 'Logo, name and one button in. The plainest greeting there is',
        photo: 'Photo splash',
        photoCaption: 'A photo the full screen, with the heading and button over it',
        video: 'Video splash',
        videoCaption: 'A clip the full screen — sound only if the visitor asks for it',
        email: 'Email capture',
        emailCaption: 'One email field. Whoever fills it lands in your Audience',
        code: 'Discount code',
        codeCaption: 'A code copied in one tap, and the button to the shop',
        exit: 'Before you go',
        exitCaption: 'A bottom sheet with a product. Pairs with the exit-intent trigger',
        cookie: 'Cookie consent',
        cookieCaption: 'The consent banner. The choice is kept and never asked twice',
        install: 'Add to home screen',
        installCaption: 'Offers to install the site as an app (PWA)',
        language: 'Choose language',
        languageCaption: 'Asks for a language and switches the site through ?lang=',
        notify: 'Notifications ask',
        notifyCaption: 'Asks for permission to send browser notifications',
      },
      // Editor copy for the block's three tabs, read by SplashScreen/utils/labels.js.
      editor: {
        displayTab: 'Display',

        buttonText: 'Button text',
        caption: 'Caption',
        dismissText: 'Decline text',
        footnote: 'Note under the button',
        smallText: 'Small print',

        logo: 'Logo',
        monogramLogo: 'Monogram (when there is no logo)',
        skipText: 'Skip link',

        badge: 'Badge on top',

        videoUrl: 'Video link (mp4)',
        posterUrl: 'Cover (poster)',
        autoplay: 'Autoplay',
        autoplayHint: 'Starts muted — browsers require it',
        loop: 'Loop',
        loopHint: 'Repeat the clip',
        muted: 'Start muted',
        mutedHint: 'Turn off only when the clip is meant to be heard — autoplay will then be blocked until the visitor taps',

        emailHint: 'Subscribers land in Audience — the block keeps no separate list.',
        emailPlaceholder: 'Field placeholder',
        successText: 'Text after subscribing',
        errorText: 'Text when it fails',

        promoCode: 'Code',
        copyText: 'Copy button',
        copiedText: 'Copied confirmation',

        exitHint: 'Works best with the exit-intent trigger on the Display tab.',
        productImage: 'Product image',

        cookieHint:
          'The choice is stored and published as window.ulCookieConsent plus a ulcookieconsent event. The block records consent — it does not itself enable or block third-party scripts; hook them to that event.',
        acceptAllButton: '“Accept all” button',
        necessaryButton: '“Only necessary” button',
        policyText: 'Policy link text',
        policyUrl: 'Policy link',

        installHint: 'Android/Chrome opens the real install dialog. iPhone has no such API — there the Share-menu instruction is shown instead.',
        icon: 'Icon',
        monogramIcon: 'Monogram (when there is no icon)',
        installCaption: 'Caption',
        addButton: '“Add” button',
        notNowButton: '“Not now” button',
        iphoneHint: 'iPhone instruction',

        languageHint: 'The choice is appended to the address as ?lang=code and remembered for later visits.',
        languageEmpty: 'Add at least one language — with an empty list the popup has nothing to answer, so it is not shown at all.',
        addLanguage: '+ Add language',
        languageNote: 'second line',
        remove: 'Remove',

        styleSection: 'Popup style',
        styleHint: 'Left empty, the popup follows the site’s brand colours.',
        accentColor: 'Accent',
        cardColor: 'Card',
        titleColor: 'Title',
        textColor: 'Text',
        radius: 'Corner radius',
        padding: 'Padding',
        resetStyle: 'Reset to brand colours',

        whenToShow: 'When to show',
        triggerImmediate: 'Immediately on open',
        triggerDelay: 'After a delay',
        triggerScroll: 'After scrolling',
        triggerExit: 'Exit intent',
        seconds: 'sec',
        frequency: 'Frequency',
        frequencySession: 'Once per session',
        frequencyDays: 'Once every N days',
        frequencyOnce: 'Only once',
        frequencyAlways: 'Every time',
        everyNDays: 'Every N days',
        newVisitorsOnly: 'New visitors only',
        newVisitorsHint: 'Do not show to returning visitors',
        selfClosingHint: 'This template closes through its own buttons and the answer is remembered for good — size, dimming and the close lock do not apply to it.',
        size: 'Size',
        sizeCompact: 'Compact',
        sizeMedium: 'Medium',
        sizeFullscreen: 'Fullscreen',
        dimming: 'Backdrop dimming',
        dismissable: 'Can be closed',
        dismissableHint: 'Close button and backdrop click',
        closeDelay: 'Show the close button after (sec), 0 — never',
        closeDelayWarning: 'Visitors will not be able to close the popup and reach the page. Use only for an age gate or a mandatory confirmation.',
      },
    },
    welcome: {
      templates: {
        videoBubble: 'Video bubble',
        videoBubbleCaption: 'A small clip in the corner with a greeting beside it',
        videoExpanded: 'Video expanded',
        videoExpandedCaption: 'The clip takes the screen, with one button over it',
        roundBubble: 'Round bubble',
        roundBubbleCaption: 'A round looping clip — the least of the page it can take',
        textBubble: 'Text bubble',
        textBubbleCaption: 'Who is writing, what they say, and what to ask next',
        bottomBar: 'Bottom bar',
        bottomBarCaption: 'A strip along the bottom: two lines and one button',
        bottomSheet: 'Bottom sheet',
        bottomSheetCaption: 'Rises over a dimmed page — asks for one thing',
        videoCaption: 'Video with caption',
        videoCaptionCaption: 'Says what the clip is before it is watched',
        offerBubble: 'Offer bubble',
        offerBubbleCaption: 'A picture, a badge, the offer, and the button that takes it',
        slimToast: 'Slim toast',
        slimToastCaption: 'One line and one button. The quietest of them',
        twoStories: 'Two stories',
        twoStoriesCaption: 'Two labelled clips, for a greeting with two answers',
      },

      teaser: 'Greeting',
      teaserCaption: 'The line in the pill beside the clip. Keep it to a few words — it never wraps.',
      teaserPlaceholder: 'Hello there',
      author: 'Who is writing',
      authorName: 'Name',
      authorNote: 'Note beside the name',
      authorNoteCaption: 'Sets what to expect, e.g. "replies in an hour"',
      authorAvatar: 'Photo',
      title: 'Heading',
      titleCaption: 'Plain text, one line. Shown instead of the formatted greeting.',
      subtitle: 'Second line',
      replies: 'Quick replies',
      repliesCaption: 'The phrasings a visitor can tap instead of writing their own.',
      replyText: 'Text',
      replyUrl: 'Link',
      addReply: 'Add reply',
      action: 'Button',
      actionText: 'Button text',
      actionUrl: 'Button link',
      dismissText: 'Dismiss button',
      dismissTextCaption: 'The second button. It only closes the greeting.',
      offer: 'Offer',
      offerBadge: 'Badge',
      offerBadgeCaption: 'The small label above the line, e.g. "First order"',
      offerNote: 'Condition',
      offerNoteCaption: 'The small print, e.g. "applied at checkout, no code"',
      offerImage: 'Picture',
      stories: 'Clips',
      storiesCaption: 'Two clips, each with its own label.',
      storyTitle: 'Label',
      storyVideo: 'Clip',
      storyPoster: 'Cover',
      storyUrl: 'Link',

      defaults: {
        teaser: 'Hello there',
        replyTime: 'replies in an hour',
        dismiss: 'Not now',
        offerBadge: 'First order',
        title: 'Welcome 👋',
        action: 'Learn more',
        storiesTitle: 'Pick a clip',
      },
    },
    promo: {
      title: 'Promo bar',
      subtitle: 'Highlight that lets you appear promotions',
      masterPromoMessage: 'The Master Promobar is currently enabled. If you wish to create a custom promobar for this page, you will need to disable the Master Promobar first.',
      titlePlaceholder: 'Welcome to my website!',
      subMessage: 'Subtitle',
      subMessageCaption: 'Optional secondary text shown next to the title.',
      subMessagePlaceholder: 'Ends this Sunday at midnight',
      addSubMessage: 'Add subtitle',
      icon: 'Icon',
      iconCaption: 'Optional small icon or logo shown to the left of the text.',
      addIcon: 'Add icon',
      timer: 'Countdown timer',
      addTimer: 'Add timer',
      timerDate: 'Ends at',
      timerColor: 'Timer color',
      textBackgroundSwitch: 'Text background',
      switcherDismissible: 'Dismissible — let visitors close the bar',
      switcherIsMasterPromobar: 'Show on all pages',
      boldTitle: 'Bold title',
      layout: 'Buttons layout',
      layoutCaption: 'Choose how the buttons look. A countdown timer, when on, sits inline in compact mode or above the buttons otherwise.',
      layoutAuto: 'Auto',
      layoutFull: 'Full width',
      layoutCompact: 'Compact',
      layoutBeside: 'Beside text',
      alignment: 'Alignment',
      alignLeft: 'Left',
      alignCenter: 'Center',
      buttonHeight: 'Button height',
      buttonHeightRegular: 'Large',
      buttonHeightSmall: 'Small',
      iconHeight: 'Icon height',
      iconHeight36: 'Small',
      iconHeight44: 'Large',
      reel: 'Reel',
      reelMotion: 'Reel motion',
      reelMotionCaption: 'Spin & stop settles the barrels on your text; Endless keeps them spinning.',
      reelSettle: 'Spin & stop',
      reelLoop: 'Endless',
      reelHeight: 'Reel height',
      reelPause: 'Pause between spins',
      reelPauseCaption: 'How long the word stays readable before spinning again. 0 = no pause.',
      reelFill: 'Fill strip (giant letters)',
      separatorSymbol: 'Separator symbol',
      separatorSymbolCaption: 'A glyph woven into the running text between repeats (e.g. SPACES ✦ POSTERS ✦).',
      motifSymbol: 'Background symbols',
      motifSymbolCaption: 'A glyph scattered behind the text for decoration.',

      templates: {
        line: 'One line',
        lineCaption: 'A single centred sentence — the plainest announcement there is',
        textButton: 'Text and button',
        textButtonCaption: 'A sentence with the button on the same row',
        iconTextButton: 'Icon, text, button',
        iconTextButtonCaption: 'An icon leads the row, the button closes it',
        stacked: 'Stacked',
        stackedCaption: 'Icon with two lines of text over a full-width button',
        countdown: 'Countdown',
        countdownCaption: 'The clock beside the title, the button below it',
        ticker: 'Ticker',
        tickerCaption: 'Several messages running past, one after another',
        code: 'Promo code',
        codeCaption: 'The code beside a button that copies it',
        tappable: 'Tappable row',
        tappableCaption: 'The whole strip is one tap — two lines and a chevron',
        rotating: 'Rotating messages',
        rotatingCaption: 'Several messages taking turns in the same strip',
      },

      messages: 'Messages',
      messagesCaption: 'Each one takes its turn in the strip. The title is used while this list is empty.',
      messagePlaceholder: 'Free shipping over $50',
      addMessage: 'Add message',
      code: 'Promo code',
      addCode: 'Add promo code',
      codeValue: 'Code',
      existingDiscounts: 'Your promo codes',
      createDiscount: 'Create promo code',
      codeCaption: 'The code visitors copy. The title above it says what it is for.',
      codePlaceholder: 'PODIL10',
      codeButton: 'Copy button text',
      codeButtonPlaceholder: 'Copy',
      codeCopied: 'Text after copying',
      codeCopiedPlaceholder: 'Copied',
      tapUrl: 'Link',
      tapUrlCaption: 'Where the strip goes when tapped. Without it the row is not clickable.',
      tapUrlPlaceholder: 'https://',
    },
    contact: {
      title: 'Contacts',
      subtitle: 'Provide the way to communicate with you',
      caption: 'Add messenger buttons for fast connection between you and your clients in one click',
      tooltip: 'Contacts allows users to communicate with you directly. Add your phone, email, messenger, or location',
      addNewContact: 'Add new contact',
      addContact: 'Add contact',
      chooseContact: 'Choose contact',
      enterLink: 'Enter your contact link',
      showDetails: 'Show details',
      enterAnyContact: 'Please enter any contact',
      enterAnyContactCaption: '(WhatsApp, Telegram, Viber, Messenger)',
    },
    membership: {
      title: 'Membership',
      subtitle: 'Create a free or paid subscription to your content',
      addNewTier: 'Add new tier',
      editTier: 'Edit tier',
      name: 'Name',
      nameCaption: 'Enter name of your tier',
      price: 'Price per month',
      priceCaption: 'Enter price of your tier',
      month: 'month',
      image: 'Image',
      imageCaption: 'Upload image for your tier',
    },
    pricing: {
      title: 'Pricing',
      subtitle: 'Create a menu with prices',
      add: 'Add new item',
      edit: 'Edit item',
      name: 'Name',
      nameCaption: 'Enter name of your item',
      duration: 'Attribute',
      durationCaption: 'Enter time, quantity or duration of your item',
      category: 'Category',
      categoryCaption: 'Enter category of your item',
      price: 'Price',
      priceCaption: 'Enter price of your item',
      month: 'month',
      image: 'Image',
      imageCaption: 'Upload image for your item',
    },
    subscribe: {
      dataCollectTitle: 'Data Collect',
      title: 'Subscribe',
      subtitle: 'Collect emails or phone numbers from your visitors',
      instructionsMessage: 'Add an Email signup field to your page so your visitors can easily signup!',
      instructionsLink: 'Pass emails to MailChimp to run marketing campaigns.',
      sectionHeaderCaption: 'Subscribe to our newsletter',
      collecting: 'Collecting',
      collectingCaption: 'Choose your type of input',
      addDataToCollect: 'Add data to collect',
      email: 'Email',
      enterEmail: 'Enter email',
      thanksForEmail: 'Thank you for your email',
      phone: 'Phone',
      telegram: 'Telegram',
      facebook: 'Facebook',
      instagram: 'Instagram',
      twitter: 'X (Twitter)',
      youtube: 'Youtube',
      whatsapp: 'Whatsapp',
      viber: 'Viber',
      messenger: 'Messenger',
      modalTitle: 'Add updated links',
      placeholder: 'Placeholder',
      placeholderCaption: 'Enter placeholder text',
      button: 'Button',
      buttonCaption: 'Text that will motivate visitor to enter email (10% off discount, subscribe now, download file etc.)',
      submitButton: 'Submit button',
      enterButton: 'Enter button',
      thanksMessage: 'Thanks message',
      thanksMessageCaption: 'Thanks message of your subscribes',
      resultAction: 'Action (after submitting)',
      resultActionCaption: 'Action after filling out the form',
      sendAnEmail: 'Send an email',
      downloadFile: 'Download file',
      redirect: 'Redirect',
      messageBody: 'Message body',
      messageBodyCaption: 'This data will be sent to user email as present for his email (coupon, link to file download, etc.)',
      integration: 'Integration',
      integrationCaption: 'Pass your visitors email addresses to MailChimp, Reply',
      storage: 'Storage',
      storageCaption: 'Save visitors order to Google Spreadsheet',
      maxSize: 'You can add maximum 3 channels',
    },
    text: {
      title: 'Text',
      subtitle: 'Write anything about yourself/company',
      trimBio: 'Truncate text',
    },
    header: {
      title: 'Header',
      subtitle: 'Enlarged featured image or video on your page',
      verifiedBadge: 'Verified badge',
      showProfilePic: 'Display profile picture',
      profilePicRatio: 'Ratio',
      profilePicRatioSquare: 'Square',
      profilePicRatioLandscape: 'Landscape',
      profilePicRatioPortrait: 'Portrait',
      verticalCropStep: 'vertical photo',
      squareCropStep: 'square avatar',
      namePlaceholder: 'Your name',
      shortBioPlaceholder: 'My short information',
      externalLinkPlaceholder: 'URL',
      locationPlaceholder: 'City',
      addSocial: '+ Add social',
      addCover: '+ Add cover',
      addButton: '+ Add button',
      topButtons: 'Top buttons',
      bottomButtons: 'Bottom buttons',
      buttonSubtitleLanguage: 'Language switcher',
      buttonSubtitleContact: 'Call / message',
      buttonSubtitleCart: 'Shopping cart',
      buttonSubtitleCta: 'Call to action',
      buttonSubtitleMessage: 'Message',
      buttonSubtitleSubscribe: 'Subscribe',
      buttonSubtitleQrcode: 'QR code',
      buttonSubtitleSearch: 'Product search',
      buttonDisabledHint: 'Hidden · disabled',
      addText: '+ Add text',
      addLabel: '+ Add label',
      subtitleName: 'Customize your name appearance',
      subtitleShortBio: 'Customize your short bio appearance',
      shortBioSize: 'Short Bio size',
      subtitleShortBioSize: 'You can change short bio size',
      subtitleLocation: 'Set the city/country to navigate visitors to a specific place',
      headerCoverWarningMessage: 'Your browser does not support the video tag.',
      headerCoverTitle: 'Set cover above the header',
      coverHeight: 'Cover height',
      subtitleCoverHeight: 'You can change cover height',
      coverDarkness: 'Cover darkness',
      subtitleCoverDarkness: 'Drag slider to darken cover image',
      nameSize: 'Name size',
      subtitleNameSize: 'You can change name size',
      positionText: 'Position name',
      subtitlePositionName: 'Drag slider to set name position',
      positionContent: 'Position content',
      subtitlePositionContent: 'Set position for bio, link, location',
      coverText: 'Text on cover',
      subtitleCoverText: 'Add text to your cover',
      position: 'Position',
      subtitlePosition: 'Drag slider to set button position',
      buttonCover: 'Button on cover',
      subtitleButtonCover: 'Add a button to your cover by choosing an action',
      subtitleFollow: 'Follow button allows users to follow your news',
      buttonOpacity: 'Drag slider to change button opacity',
      subtitleCart: 'Cart icon to deliver a shopping experience',
      subtitleDirect: 'Quick button to navigate visitor to messengers',
      subtitleCTAButton: '(call to action) button that motivates user to click',
      subtitleSocialLinks: 'Give your social networks a visual look',
      chooseSocialLink: 'Choose social link',
      alignSocialLink: 'Social links align',
      enterYourSocialLink: 'Enter your social link',
      blockShadow: 'Block shadow',
      activeButtonPosition: 'Active button position',
      gradientColor: 'Gradient color',
      bottomGradient: 'Bottom gradient',
      autoGradient: 'Auto',
      customGradient: 'Custom',
      transparentGradient: 'Transparent',
      gradientPositionLabel: 'Shadow position',
      gradientPositionPhoto: 'Under photo',
      gradientPositionHeader: 'Lower in header',
      uploadLogo: 'Upload Logo',
      customBackground: 'Custom background',
      headingLabel: 'Heading Label',
      customizeLabel: 'Customize your heading label appearance',
      labelText: 'Label Text',
      enterLabelText: 'Enter text for the heading label',
      bottomBadge: 'Bottom tint',
      addTint: 'Add tint',
      bottomBadgeText: 'Text (optional)',
      bottomBadgePreset: 'Preset',
      bottomBadgeShape: 'Shape',
      bottomBadgeSize: 'Height',
      bottomBadgeAction: 'Action',
      bottomBadgeBgColor: 'Background color',
      bottomBadgeTextColor: 'Text color',
      bottomBadgeGradientFrom: 'Gradient from',
      bottomBadgeGradientTo: 'Gradient to',
      bottomBadgeGradientAngle: 'Gradient angle',
    },
  },
  billingHistory: {
    title: 'Billing history',
    invoices: 'Invoices',
    messageText: 'You have no payment history yet.',
  },
  migrate: {
    title: 'Do you have LinkTree or Taplink?',
    text: 'Paste link and migrate to UniLink in just one click!',
    button: 'Migrate',
  },
  pages: {
    title: 'Pages',
    addPage: 'Add page',
    addNewPage: 'Add new page',
    deleteTitle: 'Are you sure you want to delete this page?',
    managePage: 'Manage Tabs',
    empty: `This page don't have any block yet.`,
    dragAndDrop: 'Drag and drop your other tabs to reorder them',
    pageNavigation: 'Page navigation settings',
    goToDesign: 'Go to Design settings',
    viewArchive: 'View archive',
    archivedBlocks: 'Archived blocks',
    noArchivedBlocks: `Keep your page clean and focused by archiving blocks you're not currently using.`,
    archiveAllUnpublished: 'Archive all unpublished blocks',
    restore: 'Restore',
    permanentDelete: 'Delete permanently',
  },
  analytics: {
    lifeTimeAnalytics: 'Lifetime Analytics',
    impressions: 'Impressions',
    impressionsText: 'Performance of the impressions stats for the chosen period',
    clicks: 'Clicks',
    clicksText: 'Performance of "click" events for the chosen period',
    signUps: 'Sign-Ups',
    signUpsText: 'Performance of "close" events for the chosen period',
    totalInteractions: 'Total Interactions',
    totalInteractionsText: 'Total clicks and form sign-ups for the chosen period',
    engagementRate: 'Engagement Rate',
    engagementRateText: 'Share of profile views that led to an interaction',
    visitor: 'Visitor Sources',
    country: 'Country',
    countries: 'Countries',
    linkClicks: 'Link clicks',
    content: 'Content',
    views: 'Views',
    links: 'Links',
    products: 'Products',
    blocks: 'Blocks',
    pages: 'Pages',
    clicksLower: 'clicks',
    of: 'of',
    noContentData: 'No data for the chosen period yet',
  },
  aiInsights: {
    title: 'AI Insights',
    generate: 'Analyze my profile',
    description: 'Get AI-powered recommendations to improve your profile performance.',
    analyzing: 'Analyzing your profile...',
    refresh: 'Refresh',
    action: 'Action',
  },
  post: {
    subscriptionTypePlaceholder: `Available for 'type' subscription and above`,
    postButtonText: 'Post',
    newPostPlaceholder: 'What is on your mind',
    free: 'Free',
    pro: 'Pro',
    premium: 'Premium',
    noPost: `You don't have posts yet`,
    editPost: 'Edit post',
  },
  preview: {
    buy: 'Buy',
    connect: 'Connect',
  },
  activeButton: {
    initialText: 'Website',
    inputPlaceholder: 'Search actions...',
    existing: 'Existing',
    redirect: 'Redirect',
    scroll: 'Scroll',
    title: 'Active Button',
    modalTitle: 'Button action',
    modalSubtitle: 'What happens when visitors tap this button',
    subtitle: 'Button that motivates the user to take an action',
    onYourPage: 'On your page',
    cancel: 'Cancel',
    saveAction: 'Save action',
    onTapHint: 'On tap',
    next: 'Next',
    save: 'Save',
    opensALinkFromLinksBlock: 'Opens a link from Links block',
    url: 'URL',
    opensAWebsite: 'Opens a website',
    openInApp: 'Open in App',
    addAction: 'Add Action',
    actionTitle: 'Action',
    actionCaption: 'Edit action type',
    chooseOption: 'Choose an option',
    tellPeople: 'Tell people how to engage with the action button',
    urlRedirect: 'URL Redirect',
    customUrl: 'Custom URL',
    customUrlText: 'Opens a website',
    links: 'Links',
    linksText: 'Opens a link from Links block',
    downloadDocument: 'Download Document',
    sendEmail: 'Send Email',
    opensEmailClient: 'Opens email client',
    phoneCall: 'Phone Call',
    initiatesPhoneCall: 'Initiates phone call',
    whatsapp: 'WhatsApp',
    opensWhatsAppChat: 'Opens a WhatsApp chat',
    instagramDm: 'Instagram DM',
    opensInstagramDirect: 'Opens an Instagram direct message',
    messenger: 'FB Messenger',
    opensFacebookMessenger: 'Opens Facebook Messenger',
    addToCalendar: 'Add to calendar',
    addsEventToCalendar: 'Adds an event to the visitor calendar',
    navigateToLocation: 'Navigate to a location',
    opensDirectionsInMaps: 'Opens directions in Maps',
    shareLink: 'Share a link',
    opensTheShareSheet: 'Opens the share sheet',
    navigation: 'Navigation',
    openPage: 'Open Page',
    opensInternalPage: 'Opens internal page',
    openPageText: 'Opens internal page',
    openProduct: 'Open Product',
    openProductText: 'Opens product page from Store',
    openBlog: 'Open Blog',
    opensBlogPageFromStore: 'Opens blog page from Store',
    openBlock: 'Open Block',
    opensContentBlock: 'Opens content block',
    openItem: 'Open Item',
    opensItemPageFromStore: 'Opens item page from Store',
    showNewModal: 'Show New Modal',
    displayContentInModalWindow: 'Display content in modal window',
    showProduct: 'Show Product',
    displayProductInModalWindow: 'Display product in modal window',
    showBlog: 'Show Blog',
    scrollToBlock: 'Scroll to Block',
    scrollToBlockText: 'Scroll to the specified page block',
    scrollToItem: 'Scroll to Item',
    action: 'Action',
    showBlock: 'Show Block',
    showBlockText: 'Content block from Store',
    showItem: 'Show Item',
    showItemText: 'Opens item page from Store',
    linksCaption: 'Links',
    linksTooltip: 'Choose a link from links block',
    pagesCaption: 'Pages',
    pagesTooltip: 'Choose a page from pages',
    productsCaption: 'Products',
    productsTooltip: 'Choose a product from list',
    blocksCaption: 'Blocks',
    blocksTooltip: 'Choose a block from list',
    itemsCaption: 'Items',
    itemsTooltip: 'Choose an item from list',
    showProductText: 'Display the product within a modal window on the page',
    more: 'Show more',
    less: 'Show less',
    showNewModalTitle: 'New Modal Data',
    uploadDocumentTitle: 'Click to upload or drag and drop',
    uploadProgressTitle: 'Uploading...',
    haveNoModal: `You don't have modal`,
    haveModal: 'You have selected modal',
    openNewModalHandler: 'Create new modal',
    linkGroupSubTitle: 'Select a block',
    linkItemSubTitle: 'Select a link',
    urlItemSubTitle: 'Website URL',
    openInAppItemSubTitle: 'App URL',
    sendEmailItemSubTitle: 'Email Address',
    phoneCallItemSubTitle: 'Phone Number',
    openPageGroupSubTitle: 'Select Page',
    openPageItemSubTitle: 'Select Page',
    openProductGroupSubTitle: 'Select Product Type',
    openProductItemSubTitle: 'Select Product',
    openBlogGroupSubTitle: 'Select Blog Channel',
    openBlogItemSubTitle: 'Select Blog Article',
    openBlockGroupSubTitle: 'Select Page',
    openBlockItemSubTitle: 'Select Block',
    openItemGroupSubTitle: 'Select Block',
    openItemItemSubTitle: 'Select Item',
    showProductGroupSubTitle: 'Select Product Type',
    showProductItemSubTitle: 'Select Product',
    showBlogGroupSubTitle: 'Select Blog Channel',
    showBlogItemSubTitle: 'Select Blog Article',
    showBlockGroupSubTitle: 'Select Page',
    showBlockItemSubTitle: 'Select Block',
    showItemGroupSubTitle: 'Select Block',
    showItemItemSubTitle: 'Select Item',
    scrollToBlockGroupSubTitle: 'Select Page',
    scrollToBlockItemSubTitle: 'Select Block',
    scrollToItemGroupSubTitle: 'Select Block',
    scrollToItemItemSubTitle: 'Select Item',
    linkGroupPlaceholder: 'Choose a block...',
    linkItemPlaceholder: 'Choose a link...',
    openPageItemPlaceholder: 'Choose a page...',
    openProductGroupPlaceholder: 'Choose a product type...',
    openProductItemPlaceholder: 'Choose a product...',
    showProductGroupPlaceholder: 'Choose a product group...',
    showProductItemPlaceholder: 'Choose a product...',
    openBlogGroupPlaceholder: 'Choose a blog channel...',
    openBlogItemPlaceholder: 'Choose a blog article...',
    openBlockGroupPlaceholder: 'Choose a page...',
    openBlockItemPlaceholder: 'Choose a block...',
    openItemGroupPlaceholder: 'Choose a page and block...',
    openItemItemPlaceholder: 'Choose an item...',
    showBlogGroupPlaceholder: 'Choose a blog group...',
    showBlogItemPlaceholder: 'Choose a blog post...',
    showBlockGroupPlaceholder: 'Choose a page...',
    showBlockItemPlaceholder: 'Choose a block...',
    showItemGroupPlaceholder: 'Choose a page and block...',
    showItemItemPlaceholder: 'Choose an item...',
    scrollToBlockGroupPlaceholder: 'Choose a page...',
    scrollToBlockItemPlaceholder: 'Choose a block...',
    scrollToItemGroupPlaceholder: 'Choose a page and block...',
    scrollToItemItemPlaceholder: 'Choose an item...',
    linkReadable: 'Link',
    urlReadable: 'Url',
    openInAppReadable: 'Open in App',
    downloadDocumentReadable: 'Download Document',
    sendEmailReadable: 'Send Email',
    phoneCallReadable: 'Phone Call',
    openPageReadable: 'Open Page',
    openProductReadable: 'Open Product',
    showNewModalReadable: 'Show New Modal',
    showProductReadable: 'Show Product',
    openBlogReadable: 'Open Blog',
    openBlockReadable: 'Open Block',
    openItemReadable: 'Open Item',
    showBlogReadable: 'Show Blog',
    showBlockReadable: 'Show Block',
    showItemReadable: 'Show Item',
    scrollToBlockReadable: 'Scroll to Block',
    scrollToItemReadable: 'Scroll to Item',
  },
  design: {
    textColorHint: 'The colour of this block’s content. The heading has its own colour below.',
    tabs: 'Tabs',
    imageView: 'Image view',
    preview: 'Preview',
    undo: 'Undo',
    redo: 'Redo',
    undoTooltip: 'Undo design change (Ctrl+Z)',
    redoTooltip: 'Redo design change (Ctrl+Shift+Z)',
    buttonOpacity: 'Button opacity',
    buttonBorder: 'Button border',
    buttonShadow: 'Button shadow',
    itemView: 'Item view',
    itemViewTooltip: 'Choose item view',
    itemLayout: 'Item layout',
    itemLayoutTooltip: 'Choose item layout',
    top: 'Top',
    center: 'Center',
    bottom: 'Bottom',
    bottomLeft: 'Bottom Left',
    bottomHorizontal: 'Bottom Horizontal',
    under: 'Under',
    title: 'Title',
    titleButton: 'Title & Button',
    displayOptions: 'Display options',
    displayOptionsTooltip: 'Choose display options',
    landscape: 'Landscape',
    square: 'Square',
    portrait: 'Portrait',
    desktopMode: 'Desktop mode',
    mobile: 'Compact',
    desktop: 'Wide',
    responsive: 'Responsive',
    custom: 'Custom',
    templates: 'Templates',
    chooseTemplates: 'Choose your templates',
    viewAll: 'View all',
    previousTheme: 'Please note that the previous theme will be permanently erased.',
    useThisTemplate: 'Use this template',
    notSupportedVideo: 'Your browser does not support the video tag.',
    photosBy: 'Photos by',
    animationBy: 'Animation by',
    searchTheSame: 'Search the same term again for different results.',
    addImage: 'Add an image',
    addVideo: 'Add an video',
    orSelectFrom: 'or select from',
    noImagesYet: 'No images yet',
    noVideosYet: 'No videos yet',
    videoBy: 'Video by',
    hamburgerMenu: 'Hamburger menu',
    menuContent: 'Menu content',
    menuShowContacts: 'Show contacts',
    menuShowAddress: 'Show address',
    menuAddress: 'Address',
    menuAddressCaption: 'Taken from the Contacts block if empty',
    menuShowCta: 'Show button',
    menuCtaText: 'Button text',
    menuCtaCaption: 'Taken from the header button if empty',
    menuCtaUrl: 'Button link',
    menuShowSocials: 'Show social links',
    tabsOnTop: 'Tabs on top',
    tabsOnBottom: 'Tabs on bottom',
    borderType: 'Border type',
    subTitle: 'Choose shape, border type, shadow etc.',
    icon: 'Icon',
    iconTooltip: 'Choose right icon to your button',
    background: 'Background',
    color: 'Color',
    backgroundOpacity: 'Background opacity',
    backgroundOpacityTooltip: 'Drag slider to set background opacity',
    gradient: 'Gradient',
    color1: 'Color 1',
    color2: 'Color 2',
    direction: 'Direction',
    directionTooltip: 'Drag slider to set direction of a gradient',
    offset: 'Offset',
    offsetTooltip: 'Drag slider to set offset of a gradient',
    minHeight: 'Minimum height',
    minHeightTooltip: 'Drag the slider to change the minimum height of the button',
    align: 'Align',
    alignTooltip: 'Change button position',
    insert: 'Insert URL',
    upload: 'Upload video',
    search: 'Search video',
    layout: 'Layout',
    layoutTooltip: 'Choose the layout you want',
    view: 'View',
    viewTooltip: 'Choose the view you want',
    media: 'Media',
    mediaTooltip: 'Choose the media you want',
    none: 'None',
    small: 'Small',
    medium: 'Medium',
    large: 'Large',
    round: 'Round',
    feed: 'Feed',
    slider: 'Slider',
    text: 'Text',
    colorTooltip: 'Choose colors',
    button: 'Button',
    buttonTooltip: 'Choose button colors',
    chooseEmoji: 'Choose emoji',
    changeEmoji: 'Change your emoji',
    quantum: 'Quantum',
    emoji: 'Emoji',
    warp: 'Warp',
  },
  components: {
    blockTemplates: {
      viewAll: 'View all {count} templates',
      search: 'Search template',
      selected: 'Selected',
      cancel: 'Cancel',
      applyTemplate: 'Apply template',
      title: 'Templates',
      empty: 'No templates match your search',
      preview: 'Preview',
      apply: 'Use this template',
    },
    quickAdd: {
      addLink: 'Add link',
      addVideo: 'Add video',
      addProduct: 'Add product',
      addPost: 'Add post',
      addArticle: 'Add article',
      addPhoto: 'Add photo',
      addMusic: 'Add music',
      addFiles: 'Add files',
      addStory: 'Add story',
      createCustomStory: 'Create custom story',
      selectStoryGroup: 'Select existing story group',
      storyGroupsTitle: 'Your story groups',
      noStoryGroups: 'No story groups yet. Create one in Embed Tools → Stories.',
      useOwnStories: 'Use my own stories',
    },
    emoji: {
      search: 'Search',
      clear: 'Clear',
      notfound: 'No Emoji Found',
      skintext: 'Choose your default skin tone',
      categories: {
        search: 'Search Results',
        recent: 'Frequently Used',
        smileys: 'Smileys & Emotion',
        people: 'People & Body',
        nature: 'Animals & Nature',
        foods: 'Food & Drink',
        activity: 'Activity',
        places: 'Travel & Places',
        objects: 'Objects',
        symbols: 'Symbols',
        flags: 'Flags',
        custom: 'Custom',
      },
      categorieslabel: 'Emoji Categories',
      skintones: {
        1: 'Default Skin Tone',
        2: 'Light Skin Tone',
        3: 'Medium-Light Skin Tone',
        4: 'Medium Skin Tone',
        5: 'Medium-Dark Skin Tone',
        6: 'Dark Skin Tone',
      },
    },
    blogPreviewModal: {
      title: 'Blog Preview',
      notify: 'Notify subscribers',
    },
    standAloneModal: {
      title: 'Link Preview',
      save: 'Save',
      chooseLayout: 'Choose a layout for your link',
      linkSettings: 'Link Settings',
      linkSettingsSubtitle: 'Redirect, appearance',
      whenVisitorsClicks: 'When a visitor clicks this link:',
      redirect: 'Redirect',
      redirectText: 'Send visitors directly to the URL',
      highlight: 'Highlight',
      highlightText: 'Send visitors to your UniLink and highlight',
      standalone: 'Standalone',
      standaloneText: 'Make your YouTube link stand out and have the content play right on your',
      cover: 'Cover',
      imageTab: 'Image',
      videoTab: 'Video',
      uploadImage: 'Upload image',
      whenVisitors: 'When a visitor selects the shared link:',
      compact: 'Compact view',
      fullView: 'Full view',
      videoSound: 'Play video with sound',
    },
    instagramModal: {
      title: 'Send automatic Instagram DMs',
      subtitle: 'Send this link via direct message when someone comments on your IG post or Reel',
      promo: `Choose which IG you'd like to send from`,
      connect: 'Connect Instagram account',
      added: 'Instagram account added',
      addNew: 'Add new automation',
      igContent: 'IG content',
      trigger: 'Trigger',
      dmContent: 'DM',
      linkDestination: 'Link Destination',
      buttonTitle: 'Button title',
      buttonTitleTooltip: 'Enter button title',
      directMessage: 'Direct message',
      directMessageTooltip: 'Enter direct message',
      selectPosts: 'Select the post or Reel that will trigger your automatic DM.',
      onePost: 'One specific post or Reel',
      allPosts: 'All posts or Reels',
      triggerText: 'When comments include this, your DM will send.',
      addMessage: 'Add a message to send automatically with your link.',
      clickLink: 'When someone clicks the link in your DM:',
      anyComment: 'Any comment',
      storiesAndDms: 'Stories & DMs',
      anyMessage: 'Any message',
      specificKeywords: 'Comments with specific keywords',
      sendLink: 'Send them to your UniLink and highlight ',
      skipLink: 'Skip UniLink and send them straight',
      keywordsTitle: 'Comments with specific keywords',
      keywordsText: 'Your DMs will be sent when comments include or exclude\nspecific keywords (not case-sensitive):',
      keywordsPlaceholder: 'Type a keyword',
      keywordsExclude: 'Exclude keywords',
      keywordsExcludeText: 'Must exclude any of these',
      replyComment: 'Reply comment',
      replyCommentTooltip: 'Enter reply comment',
    },
    blockEditProduct: {
      productPreview: 'Thumbnail',
      productDetails: 'Details',
      checkout: 'Checkout',
      settings: 'Settings',
      design: 'Design',
    },
    editMenuItems: {
      overview: 'Overview',
      analytics: 'Analytics',
    },
    botToken: {
      bot: 'Bot',
      botTooltip: 'Enter token of your bot',
      connect: 'Connect',
      token: 'Token',
    },
    rewards: {
      title: 'Title',
      titleTooltip: 'Enter title for response',
      text: 'Text',
      textTooltip: 'Enter text for response',
      link: 'Link',
      linkTooltip: 'Enter link for response',
      code: 'Code',
      codeTooltip: 'Enter code for response',
      files: 'Files',
      filesTooltip: 'Enter files for response',
      removeReward: 'Are you sure you want to remove this response?',
    },
    addRewardModal: {
      addReward: 'Add Response',
      textTitle: 'Text',
      textText: 'Give access to instruction or any text with Rich Editor',
      fileTitle: 'Files',
      fileText: 'Give access to files and collect contact details',
      linkTitle: 'Link',
      linkText: 'Give access to exclusive content and collect contact details',
      codeTitle: 'Code',
      codeText: 'Give access to exclusive promotions and collect contact details',
    },
    blockEmpty: {
      isNotAdded: `isn't added`,
      itSeems: 'It seems like your',
      itemsNot: `items aren't added yet. Add your videos now`,
      add: 'Add',
    },
    blockList: {
      add: 'Add',
      item: 'item',
    },
    submitAction: {
      action: 'Action (after submitting)',
      actionTooltip: 'Choose an action after submitting',
      upload: 'Upload attachments',
      none: 'None',
      page: 'Show Confirmation Page',
      email: 'Send Confirmation Email',
      redirect: 'Redirect to URL',
    },
    blockEditItem: {
      content: 'Content',
      preview: 'Preview',
      settings: 'Settings',
    },
    domainButton: {
      customizeDomain: 'Customize your domain.',
      upgradeToLink: 'Upgrade to Link in Bio Pro and use a custom domain.',
    },
    coverText: {
      text: 'Text',
      textTooltip: 'Enter text to your cover',
      description: 'Description',
      descriptionTooltip: 'Enter description to your cover',
      textColor: 'Text color',
    },
    itemModal: {
      edit: 'Edit',
      addNew: 'Add new',
      item: 'item',
      update: 'Update',
      add: 'Add',
    },
    productSheet: {
      openFullEditor: 'Open full editor',
      copyLink: 'Copy link',
      active: 'Active',
      notActive: 'Not active',
      statistics: 'Statistics',
      clicks: 'Clicks',
      sales: 'Sales',
      revenue: 'Revenue',
      onlyName: 'Only the name is required',
      name: 'Name',
      required: 'Required',
      price: 'Price',
      optional: 'Optional',
      free: 'Free',
      appearance: 'Appearance',
      cover: 'Cover',
      coverNote: 'Square, from 600×600. Can be added later.',
      description: 'Description',
      descriptionPlaceholder: 'One line about what is inside',
      remove: 'Remove',
      photo: 'Photo',
      enterName: 'Enter a name',
      adding: 'Adding…',
    },
    viewDesign: {
      compact: 'Compact',
      card: 'Card',
      button: 'Button',
      list: 'List',
      hero: 'Hero',
      featured: 'Featured',
    },
    moveItemModal: {
      title: 'Move item to another page',
      cancel: 'Cancel',
      move: 'Move',
      page: 'Page',
      pageTooltip: 'Choose a page for moving item',
      blocks: 'Blocks',
      blocksTooltip: 'Choose a block for moving item',
      emptyBlocks: 'There are no required blocks on this page.',
    },
    limitModal: {
      title: 'Limit reached',
      text1: `You have reached your site's limit.`,
      text2: 'Please contact us to upgrade your plan.',
      close: 'Close',
    },
    cropPicture: {
      title: 'Crop your image',
      cancel: 'Cancel',
      save: 'Save',
    },
    uploadFile: {
      uploadProductImage: 'Upload product image',
      coverImage: 'Cover image',
      uploadImages: 'You can only upload images here',
    },
    userMediaLibrary: {
      addImage: 'Add an image',
      uploadImage: 'Upload image',
      orSelectFrom: 'or upload',
      orSelectLink: 'or paste link',
      myMedia: 'My Media',
      stockImages: 'Stock Images',
      gifs: 'GIFs',
      icons: 'Icons',
      noImagesYet: 'No images yet',
      loadMore: 'Load more',
    },
    itemMenu: {
      active: 'Active',
      willBeAvailable: 'The item will be available at:',
      save: 'Save',
      copied: 'Copied',
      copyLink: 'Copy link',
      delete: 'Delete',
    },
    itemDesign: {
      linkColor: 'Link color',
      gradient: 'Gradient',
      background: 'Background',
      backgroundOpacity: 'Background opacity',
      backgroundOpacityTooltip: 'Drag slider to set background opacity',
      backgroundDarkness: 'Background darkness',
      backgroundDarknessTooltip: 'Drag slider to set background darkness',
      text: 'Text',
      color1: 'Color 1',
      color2: 'Color 2',
      direction: 'Direction',
      directionTooltip: 'Drag slider to set direction of a gradient',
      offset: 'Offset',
      offsetTooltip: 'Drag slider to set offset of a gradient',
      linkHeight: 'Link height',
      linkHeightTooltip: 'Drag the slider to change the height of the button',
      icon: 'Icon',
      iconTooltip: 'Choose icon to your button',
      imageShape: 'Image Shape',
      imageShapeTooltip: 'Choose image shape to your link',
    },
    menu: {
      linkInBio: 'Link in bio',
      home: 'Home',
      overview: 'Overview',
      linkInBioApps: 'Link in Bio',
      posts: 'Posts',
      audience: 'Audience',
      orders: 'Orders',
      marketing: 'Marketing',
      tools: 'Tools',
      emailMarketing: 'Email Marketing',
      socialPlanner: 'Social Planner',
      shortLinks: 'Short Links',
      businessCards: 'Business cards',
      emailSignatures: 'Email Signatures',
      virtualBackgrounds: 'Virtual Backgrounds',
      recentProfiles: 'Recent Profiles',
      standalonePage: 'Standalone Page',
      soloApps: 'App in Bio',
      bots: 'Bots',
      smartReply: 'Instagram Reply',
      analytics: 'Analytics',
      settings: 'Settings',
      shop: 'Products',
      publish: 'Publish',
      studio: 'Studio',
      blog: 'Blog',
      qrCodes: 'QR Codes',
      singlePages: 'Apps',
      forms: 'Forms',
      form: 'Forms',
      automations: 'Automations',
      community: 'Community',
      messages: 'Inbox',
      agents: 'Agents',
      developer: 'Developer',
      apps: 'Apps',
    },
    notificationsBlockSetting: {
      title: 'Notifications',
      setUp: 'Set up',
      notifications: 'notifications',
      connect: 'Connect',
      telegramText: 'Receive telegram notification when someone makes',
      change: 'change',
      email: 'Email',
      emailText: 'Receive an email when someone makes',
      webhook: 'Webhook',
      webhookTooltip: 'Add webhook',
      activate: 'Activate',
      webhookText: 'Send event to 3d party website when someone makes',
      webhookURL: 'Webhook URL (POST request)',
      error: 'Enter correct link',
      save: 'Save',
    },
    navigation: {
      content: 'Content',
      pages: 'Pages',
      posts: 'Posts',
      shop: 'Store',
      blog: 'Blog',
      design: 'Design',
      analytics: 'Analytics',
      settings: 'Settings',
      apps: 'Apps',
      store: 'Store',
    },
    headerSettings: {
      design: 'Design',
      analytics: 'Analytics',
      settings: 'Settings',
      editTabs: 'Edit Tabs',
    },
    unlockModal: {
      title: 'Unlock Pro Features',
      text: 'Get more from your link-in-bio. Just $5/month — unlock everything Pro has to offer:',
      checkBoxTitle1: 'More Blocks:',
      checkBoxText1: 'Add forms, stores, countdowns & media players',
      checkBoxTitle2: 'Advanced Analytics:',
      checkBoxText2: 'Track clicks, views & audience insights',
      checkBoxTitle3: 'Custom Domain:',
      checkBoxText3: 'Use your own domain for a professional look',
      checkBoxTitle4: 'Built-In Store:',
      checkBoxText4: 'Sell products and manage orders with ease',
      checkBoxTitle5: 'SEO Tools:',
      checkBoxText5: 'Rank higher with meta tags, UTM & custom slugs',
      checkBoxTitle6: 'Integrations:',
      checkBoxText6: 'Sync with Mailchimp, Zapier & other tools',
      checkBoxTitle7: 'Email Marketing:',
      checkBoxText7: 'Collect leads & send automated campaigns',
      checkBoxTitle8: 'Priority Support:',
      checkBoxText8: 'Get faster help whenever you need it',
      upgradeToPro: 'Upgrade to Pro',
      viewAllPlans: 'View all plans',
    },
    profileSwitcher: {
      title: 'All Profiles',
      button: 'Add a new profile',
    },
    account: {
      signOut: 'Sign out',
      createNew: 'Create a new Link in Bio',
      tryPro: 'Try Pro now!',
      tryProText: 'Get advanced customization and deeper audience insights to get more visitors!',
    },
    accountSettings: {
      title: 'Account settings',
    },
    billingHistory: {
      title: 'Billing history',
    },
    pages: {
      home: 'Home',
      newPage: 'New Page',
      managePages: 'Manage Pages',
    },
    blockItem: {
      actionRequired: 'action required',
      hidden: 'Hidden · nobody sees it',
    },
    blockContent: {
      untitled: 'Untitled',
      clickToRename: 'Click to rename subtitle',
      saving: 'saving',
      saved: 'saved',
      deleteTitle: 'Are you sure you want to delete this block?',
      cancel: 'Cancel',
      yes: 'Yes',
    },
    addButtonModal: {
      title: 'Add an action button',
      close: 'Close',
      added: 'Added',
      add: 'Add',
      messageTitle: 'Message',
      messageText: 'Message button allows users contact you via messenger',
      subscribeTitle: 'Subscribe',
      subscribeText: 'Subscribe button allows users subscribe to you email or messenger list',
      ctaTitle: 'CTA button',
      ctaText: 'CTA is a prompt on a website that tells the user to take specified action',
      cartTitle: 'Cart',
      cartText: 'Display a shopping cart icon to indicate that visitors can make purchases on your website',
      contactTitle: 'Contact',
      contactText: 'Enable visitors to quickly access your contact information',
      qrcodeTitle: 'QR Code',
      qrcodeText: 'Display a QR code so visitors can quickly scan and share your page',
      languageTitle: 'Language',
      languageText: 'Allow visitors to switch the language of your page',
      searchTitle: 'Search',
      searchText: 'Let visitors search your shop products right from the header',
    },
    inputMask: {
      copyLink: 'Copy link',
    },
    videoLibrary: {
      addVideo: 'Add video',
      myVideos: 'My Videos',
      stockVideos: 'Stock Videos',
      pasteUrl: 'Paste URL',
      uploadVideo: 'Upload Video',
    },
    createBlockModal: {
      searchTitle: 'Pick a block to add to your page',
      title: 'Add to UniLink',
      contentTitle: 'Content',
      contentText: 'Create and manage your page',
      growTitle: 'Leads',
      growText: 'Collect leads and boost engagement',
      monetizeTitle: 'Monetize',
      monetizeText: 'Sell products, content and services',
      monetizationTitle: 'Make and collect money',
      monetizationText: 'Sell products, services and collect tips',
      socialTitle: 'Social media content',
      socialText: 'Share social media content on your UniLink',
      toolsTitle: 'Growth tools',
      toolsText: 'Grow, manage, and connect with your audience',
      search: 'Search',
      all: 'All',
      allCategories: 'All categories',
      content: 'Content',
      monetization: 'Monetization',
      social: 'Social',
      tools: 'Tools',
      header: 'Header',
      headerText: 'Add a profile picture and bio',
      link: 'Links',
      linkText: 'Select link layout',
      text: 'Text',
      textText: 'Select text layout',
      videos: 'Videos',
      videosText: 'Select video type',
      image: 'Image',
      imageText: 'Add image blocks',
      music: 'Music',
      musicText: 'Select music type',
      socialFeeds: 'Social Feeds',
      socialFeedsText: 'Select social feed type',
      moreContent: 'More',
      moreContentText: 'Add more content blocks',
      dataCollect: 'Data Collect',
      dataCollectText: 'Select data collect type',
      form: 'Form',
      formText: 'Select form type',
      conversionTools: 'Engagement tools',
      conversionToolsText: 'Add conversion blocks',
      products: 'Products',
      productsText: 'Add product blocks',
      donation: 'Tips & Donations',
      tipsAndDonations: 'Tips & Donations',
      tipsDonationsText: 'Tips and donation blocks',
      event: 'Event',
      eventText: 'Select event type',
      quickAdd: 'All blocks',
      quickAddText: 'Add any block',
      templatesView: 'Templates',
      templatesEmptyTitle: 'No templates yet',
      templatesZoom: 'Enlarge',
      templatesStartFrom: 'Start your {block} block from',
      templatesBlank: 'Blank block',
      templatesBlankText: 'Start from default styles',
      templatesNotFound: 'No templates found',
    },
    addBlockModal: {
      title: 'Add to UniLink',
      dragToAdd: 'Drag to add',
      contentTitle: 'Share basic content',
      contentText: 'Share content directly on your UniLink',
      monetizationTitle: 'Make and collect money',
      monetizationText: 'Sell products, services and collect tips',
      socialTitle: 'Social media content',
      socialText: 'Share social media content on your UniLink',
      toolsTitle: 'Growth tools',
      toolsText: 'Grow, manage, and connect with your audience',
      search: 'Search',
      searchPlaceholder: 'Search content...',
      all: 'All',
      allCategories: 'All categories',
      content: 'Content',
      monetization: 'Monetization',
      social: 'Social',
      tools: 'Tools',
      suggestTitle: 'Suggest your block',
      suggestText: `Missing a block? Tell us what you'd like to see`,
      suggestModalTitle: 'Suggest a block',
      suggestModalSubtitle: 'Describe the block you wish UniLink had. We read every idea.',
      suggestPlaceholder: 'e.g. A booking block with Google Calendar sync...',
      suggestSubmit: 'Send suggestion',
      suggestSending: 'Sending...',
      suggestSuccessTitle: 'Suggestion sent!',
      suggestSuccess: 'Thanks! We read every idea and use them to shape the roadmap.',
      suggestError: 'Could not send. Please try again.',
    },
    tabNavigation: {
      tabView: 'Tab view',
      tabViewTooltip: 'Select tab view for navigation',
      colors: 'Colors',
      colorsTooltip: 'Choose colors of posts and buttons',
      tabs: 'Tabs',
      tabsTooltip: 'Choose tabs that shows in website navigation',
      content: 'Content',
      posts: 'Posts',
      store: 'Store',
      shop: 'Store',
      tabsSettings: 'Tabs navigation settings',
    },
    hideLogo: {
      text: 'Show UniLink logo in the footer of your page.',
      text2: 'Show UniLink logo in the footer of your page.',
    },
    palettePreview: {
      custom: 'Custom Background Color',
      hexColor: 'Hex color',
      hexColorTooltip: 'Enter hex color of your preview',
    },
    backgroundVideo: {
      insert: 'Insert URL',
      upload: 'Upload video',
      search: 'Search video',
    },
    periodDropdown: {
      today: 'Today',
      yesterday: 'Yesterday',
      last7days: 'Last 7 days',
      last30days: 'Last 30 days',
      allTime: 'All time',
      custom: 'Custom',
    },
    subsections: {
      content: 'Content',
      design: 'Desing',
      settings: 'Settings',
    },
    wrapperSettings: {
      lock: 'Update to PRO Plan',
    },
    shareModal: {
      addSocials: 'Add to Socials',
      shareTo: 'Share to',
      qrCode: 'QR code',
      customizeUrl: 'Customize URL',
      goToMy: 'Go to my',
      print: 'You can print your unique qr code on',
      cards: 'business cards and flyers',
      download: 'Download',
      copy: 'Copy',
      previewMobile: 'Preview on mobile',
      scanMobilePreview: 'Scan QR code on your mobile device to preview your website',
      types: {
        socials: 'socials',
        shareTo: 'share',
        qrCode: 'QR',
        title: 'Share your UniLink',
        titleSocials: 'Add UniLink to your socials',
        titleShareTo: 'Share to...',
        titleQRCode: 'QR Code',
        titlePreviewMobile: 'Preview on Mobile',
      },
      socialList: {
        instagramText: 'Add your UniLink to your Instagram profile. Simply copy your UniLink URL, go to Edit Profile, and paste it into the Website field.',
        facebookText:
          'Add your UniLink to your Facebook profile. Simply copy your UniLink URL, go to the About page on your profile, click on Contact and basic info, then click on + Add a website, paste your UniLink URL into the Website address field, and click Save.',
        tikTokText:
          'Add your UniLink to your Facebook profile. Simply copy your UniLink URL, go to the About page on your profile, click on Contact and basic info, then click on + Add a website, paste your UniLink URL into the Website address field, and click Save.',
        twitchText:
          'Add your UniLink to your Twitch channel. Simply copy your UniLink URL, go your Twitch channel, click About, then click Edit about & links settings, scroll down to Social Links, add UniLink in the first text field, and paste your UniLink URL into the second text field, then click Add.',
        youTubeText:
          'Add your UniLink to your YouTube channel. Simply copy your UniLink URL, go to your YouTube channel, click on Customize Channel, then click on Basic info, and under Links, add a link title and paste your UniLink URL into the URL field, then click Publish.',
        linkedInText:
          'Add your UniLink to your LinkedIn profile. Simply copy your UniLink URL, go your LinkedIn profile, click on pencil icon, scroll down to Contact info, paste your UniLink URL into the Website URL field, then click Apply.',
        pinterestText:
          'Add your UniLink to your Pinterest profile. Simply copy your UniLink URL, go your Pinterest settings, paste your UniLink URL into the Website URL field, then click Save.',
        twitterText:
          'Add your UniLink to your Twitter profile. Simply copy your UniLink URL, go to your profile, click on Edit Profile, and paste your UniLink URL into the Website field.',
      },
      share: {
        shareFacebook: 'Share on Facebook',
        shareLinkedIn: 'Share on LinkedIn',
        shareTwitter: 'Share on Twitter',
        shareWhatsApp: 'Share via WhatsApp',
        shareMessenger: 'Share via Messenger',
        shareEmail: 'Share via Email',
      },
    },
  },
  popupMenu: {
    edit: 'Edit page',
    openInNewTab: 'Open in new tab',
    copyLink: 'Copy URL',
    delete: 'Delete',
    showThumbnail: 'Show page thumbnails in dashboard',
    manageTabs: 'Manage Tabs',
  },
  tabsDashboard: {
    labelAddNewTab: 'New Tab',
  },
  blocks: {
    card: {
      blockTitle: 'Card',
      blockText: 'One card that combines an image or video, a title and text, extra sections (text, gallery, map, countdown) and any number of action buttons',
      blockShortText: 'Media, text and buttons',
      media: 'Image or video',
      image: 'Image',
      video: 'Video',
      videoUrl: 'Video URL',
      title: 'Content title',
      description: 'Content',
      sections: 'Sections',
      sectionsHint: 'Add text, images, a map or a countdown below the main content.',
      addSection: 'Add new section',
      sectionTitle: 'Section title',
      buttons: 'Buttons',
      buttonsHint: 'Add a call to action — a link, a call, WhatsApp and more.',
      addButton: 'Add New Button',
      caption: 'Caption',
      images: 'Images',
      address: 'Address',
      name: 'Name',
      role: 'Role',
      phone: 'Phone',
      email: 'Email',
      photo: 'Photo',
      review: 'Review',
      label: 'Label',
      endsAt: 'Ends at',
      text: 'Text',
      badge: 'Badge',
      eyebrow: 'Label above the title',
      meta: 'Second line',
      price: 'Price',
      duration: 'Duration',
      gallery: 'Pictures',
      galleryHint: 'This template shows several pictures side by side.',
      addPicture: 'Add picture',
      note: 'Notice under the card',
      noteLinkText: 'Notice link',
      poster: 'Video cover',
      alt: 'Image description',
      altHint: 'Read out by screen readers',
      columns: 'Columns',
      templates: {
        plain: 'Text only',
        plainCaption: 'A title, some text and the actions. The layout switch below chooses where a picture goes.',
        duo: 'Two actions',
        duoCaption: 'A badge, the text, then two buttons — the second one quiet.',
        mediaTop: 'Media on top',
        mediaTopCaption: 'One picture across the top of a framed card.',
        mediaSide: 'Media beside text',
        mediaSideCaption: 'A square thumbnail next to the text, with the actions underneath.',
        mediaPair: 'Media pair',
        mediaPairCaption: 'Two pictures side by side — before and after.',
        mediaCarousel: 'Media carousel',
        mediaCarouselCaption: 'A row of pictures the visitor swipes through.',
        overlay: 'Full-bleed overlay',
        overlayCaption: 'The picture fills the card, with the title and one action over it.',
        video: 'Video card',
        videoCaption: 'A still with a play badge and the clip length.',
        actions: 'Action stack',
        actionsCaption: 'A small identity row, then every action as its own full-width row.',
        dark: 'Dark card',
        darkCaption: 'A dark frame with a price beside the button.',
        banner: 'Compact banner',
        bannerCaption: 'One low row for a feed, plus a notice that needs a link rather than a button.',
      },
      defaults: {
        badge: 'New',
        eyebrow: 'Limited run',
      },
    },
    header: {
      blockTitle: 'Header',
      blockText: 'Customize your profile picture, add a short bio, and update your social icons',
      blockShortText: 'Customize your profile',
      layout: 'Layout',
      layoutTooltip: 'Create the header layout you want',
      backdropPhoto: 'Full-screen photo',
      backdropPhotoTooltip: 'A photo shown full-screen behind your whole page. Optional — leave empty to reuse your profile photo.',
      layoutAlign: 'Layout align',
      layoutAlignTooltip: 'Align text',
      bottomButtonsSettings: 'Bottom buttons',
      bottomButtonsLayout: 'Layout',
      bottomButtonsRow: 'Side by side',
      bottomButtonsColumn: 'Stacked',
      profilePicture: 'Profile picture',
      profilePictureTooltip: 'Change your profile picture',
      cropMismatch: 'This photo is cropped for a different layout.',
      adjustCrop: 'Adjust crop',
      photoShapeLabel: 'Photo shape',
      photoShapeTooltip: 'Choose whether this layout shows the square photo or a vertical crop.',
      photoShapeSquare: 'Square',
      photoShapeVertical: 'Vertical',
      coverShape: 'Cover shape',
      coverShapeTooltip: 'Choose the bottom edge of the cover — straight, curved down or curved up.',
      coverShapeStraight: 'Straight',
      coverShapeArcDown: 'Arc down',
      coverShapeArcUp: 'Arc up',
      avatarOffsetLabel: 'Avatar position',
      avatarOffsetTooltip: 'Nudge the avatar up or down against the cover edge.',
      photoStyleProTitle: 'Unlock advanced photo styles',
      photoStyleProDesc: 'No background and Text behind are PRO features.',
      photoShapeCustom: 'Custom',
      sliderStyleLabel: 'Slider style',
      sliderStyleTooltip: 'Swipe shows one photo at a time; Gallery shows a thumbnail row — tap a thumb to swap the main photo.',
      sliderStyleSwipe: 'Swipe',
      sliderStyleGallery: 'Gallery',
      photoPositionLabel: 'Photo position',
      photoPositionHint: 'Vertical framing',
      verticalCropHint: 'This layout shows an original photo. Pick the vertical area you want to display.',
      verticalCropReady: 'Fine-tune the vertical area shown in this layout.',
      pickVerticalArea: 'Pick vertical area',
      pictureSize: 'Picture size',
      pictureSizeTooltip: 'You can change picture size',
      pictureHeight: 'Picture height',
      pictureHeightCaption: 'You can change picture height',
      photoStyle: 'Photo style',
      photoStyleTooltip: 'Show the photo as-is, with its background removed, or place text behind the subject.',
      avatarModeOriginal: 'Original',
      avatarModeCutout: 'No background',
      avatarModeLayered: 'With background',
      photoStyleProcessing: 'Removing background…',
      photoStyleTapToGenerate: 'Tap to remove background',
      overlayText: 'Text',
      overlayTextPlaceholder: 'Your name (default)',
      overlayColor: 'Text color',
      overlaySize: 'Size',
      overlayY: 'Vertical position',
      overlayEffect: 'Animation',
      overlayEffectNone: 'None',
      overlayEffectShimmer: 'Shimmer',
      overlayEffectGlow: 'Glow',
      overlayEffectGradient: 'Gradient',
      overlayEffectSparkle: 'Sparkle',
      overlayUsesName: 'On this layout the text is your profile name — it appears behind you. Edit it in the “Name” section.',
      cutoutGenerate: 'Generate cutout',
      cutoutRegenerate: 'Regenerate',
      cutoutUpload: 'Upload',
      cutoutOr: 'or',
      cutoutGenerating: 'Generating...',
      cutoutUploading: 'Uploading...',
      cutoutVideoHint: 'Background removal works only with image photos, not video.',
      cutoutTimeout: 'Background removal is taking too long. Please try again.',
      preview: 'Preview',
      badge: 'Badge',
      badgeTooltip: 'Add a verified badge to header',
      profileBadges: 'Badges',
      profileBadgesTooltip: 'Pick up to 3 badges to show next to your name',
      profileBadgesProLockHint: 'Upgrade to PRO to use this badge',
      profileBadgesAdd: 'Add badges',
      profileBadgesManage: 'Manage badges',
      widget: 'Widget',
      widgetCaption: "Feature one block's key action as a card in your header (layouts 3-7).",
      widgetAdd: 'Add widget',
      widgetModalTitle: 'Add a header widget',
      widgetModalSubtitle: "Lift one block's key action into your header. Pick from the blocks you already have.",
      widgetNeedsBlock: 'Add this block first',
      profileBadgesModalTitle: 'Add badges to your profile',
      profileBadgesModalSubtitle: 'Showcase your achievements and recognitions.',
      profileBadgesCustomCta: 'Upload your own badge',
      profileBadgesCustomDesc: 'Your custom badge',
      profileBadgesCustomName: 'Badge name',
      profileBadgesCustomChoose: 'Choose image',
      profileBadgesCustomChange: 'Change image',
      profileBadgesCustomUploading: 'Uploading…',
      profileBadgesCustomAdd: 'Add badge',
      tags: 'Tags',
      tagsTooltip: 'Show category tags under your name (up to 5)',
      tagsAdd: 'Add tags',
      addTags: '+ Add tags',
      tagsEdit: 'Edit tags',
      tagsCustomPlaceholder: 'Add custom tag',
      tagsCustomAdd: 'Add',
      tagsSuggested: 'Suggested categories',
      tagsSelected: 'Selected',
      tagsEmpty: 'No tags yet — pick from suggestions or add your own',
      tagsLimit: 'Max 5 tags',
      visibility: 'Visibility',
      visibilityTooltip: 'Show or hide profile picture',
      cover: 'Cover',
      coverTooltip: 'Add image or video to header cover',
      addCover: 'Add cover',
      image: 'Image',
      video: 'Video',
      positionCover: 'Text and button position',
      positionCoverTooltip: 'Drag slider to change position',
      buttons: 'Buttons',
      block: 'Block',
      videoProcessing: 'Video processing',
      vibe: 'Vibe',
      vibeTooltip: 'Add your vibe',
      stories: 'Stories',
      storiesTooltip: 'Add your stories',
      addStory: 'Add story',
      storiesSubtitle: 'Add image or video to your stories',
      subscribeMethod: 'Subscribe method',
      subscribeMethodTooltip: 'Choose your subscribe method',
      subscribeLink: 'Subscribe link',
      subscribeLinkTooltip: 'Copy your subscribe link',
      minWidth: 'Minimum width',
      addVCard: 'Add vCard',
      vCard: 'vCard',
      vCardTooltip: 'You can add info about yourself',
      buttonInline: 'Button inline header',
      buttonInsideContact: 'Button inside Contact button',
      showSaveContact: 'Display save contact',
      options: 'Options',
      showBusinessCard: 'Show business card',
      showBusinessCardCaption: 'Adds a “Save contact” button here.',
      editBusinessCard: 'Edit card',
      editContactDetails: 'Edit contact details on Business cards',
      needAddContact: 'You need to add Contact button',
      socialGap: 'Gap',
      socialGapCaption: 'You can change the gap',
      socialSize: 'Size',
      socialSizeCaption: 'You can change the size',
      icons: 'Icons',
      iconsTooltip: 'Add icon to button',
      ribbonLabel: 'Decorative ribbon',
      ribbonLabelTooltip: 'Add a color bar below the header hero',
      addTint: 'Add ribbon',
      ribbonTitle: 'Ribbon',
      ribbonText: 'Ribbon text',
      ribbonTextPlaceholder: 'e.g. 20% off until the end of the month',
      ribbonColor: 'Ribbon color',
      ribbonTheme: 'Style',
      ribbonThemes: {
        none: 'No decor',
        birthday: 'Birthday',
        newyear: 'New Year',
        valentine: 'Valentine',
        halloween: 'Halloween',
        summer: 'Summer',
      },
      ribbonEffect: 'Effect',
      ribbonEffects: {
        none: 'None',
        gradient: 'Gradient',
        shimmer: 'Shimmer',
        lights: 'String lights',
        reel: 'Reel',
      },
      ribbonReelMotion: 'Reel motion',
      ribbonReelMotions: {
        settle: 'Spin & stop',
        loop: 'Endless',
      },
      ribbonReelPause: 'Pause between spins',
      ribbonReelHeight: 'Strip height',
      ribbonReelFontSize: 'Text size',
      ribbonReelSpacing: 'Letter spacing',
      ribbonReelFont: 'Font',
      ribbonReelFill: 'Fill strip (giant letters)',
      ribbonPosition: 'Position',
      ribbonPositions: {
        bottom: 'Below header',
        underPhoto: 'Under photo',
      },
      ribbonRemove: 'Remove ribbon',
      statusBadges: 'Activity',
      statusBadgesTooltip: 'Show real-time activity on your page',
      addStatus: 'Add activity',
      statusDisabledHint: 'Hidden · disabled',
      followersTitle: 'Followers',
      followersCounter: 'Followers counter',
      followersTooltip: 'Display combined follower count from your connected social accounts',
    },
    text: {
      blockTitle: 'Text',
      blockText: 'General text block to write anything you want. You can format your text with WYSIWYG editor',
      blockShortText: 'General text block',
      title: 'Title',
      titleText: 'Customize your title size',
      orderOfElements: 'Order of elements',
      orderOfElementsTooltip: 'Drag slider to change order of elements',
      changeOrder: 'Change order',
      text: 'Text',
      content: 'Content',
      image: 'Image',
      button: 'Button',
      addButtons: 'Add more buttons',
      renameTabHint: 'Rename tab',
      addElement: 'Add element',
      showFullText: 'show in full',
      displayedContent: 'Displayed content',
      displayedContentTooltip: 'Show or hide content',
      buttonLayout: 'Button layout',
      buttonLayoutTooltip: 'Choose vertical or horizontal button arrangement',
    },
    apps: {
      blockTitle: 'Apps',
      blockText: 'Showcase a grid of your Instant Pages / apps, linked from your bio',
      blockShortText: 'Showcase your apps',
    },
    discount: {
      blockTitle: 'Discount',
      blockText: 'Promote a discount offer as a sticky bar, popup, banner, floating pill or full-screen — with copywriting, promo code and display triggers',
      blockShortText: 'Promote a discount offer',
    },
    community: {
      blockTitle: 'Community',
      blockText: 'Run a paid or free community from your page',
      blockShortText: 'Run your community',
    },
    shoutout: {
      blockTitle: 'Shoutout',
      blockText: 'Sell personal video or audio shoutouts to your audience',
      blockShortText: 'Sell personal shoutouts',
    },
    'video-feedback': {
      blockTitle: 'Video feedback',
      blockText: 'Collect video reviews from your customers',
      blockShortText: 'Collect video reviews',
    },
    'audio-inbox': {
      blockTitle: 'Audio inbox',
      blockText: 'Let visitors send you paid voice messages',
      blockShortText: 'Paid voice messages',
    },
    timeline: {
      blockTitle: 'Timeline',
      blockText: 'Display a vertical timeline with events. Each event can have date/time, title, description, and optional image',
      blockShortText: 'Display events timeline',
      editItem: 'Edit event',
      title: 'Title',
      titlePlaceholder: 'Event title',
      subtitle: 'Subtitle',
      subtitlePlaceholder: 'Role or affiliation (optional)',
      description: 'Description',
      descriptionPlaceholder: 'Event description (optional)',
      startTime: 'Start time',
      endTime: 'End time',
      startDate: 'Start date',
      endDate: 'End date',
      showEndDate: 'Show end date',
      showEndDateTooltip: 'Turn off for ongoing events (e.g. "working here since 2023")',
      includeTime: 'Include time',
      includeTimeTooltip: 'If off, only the date will be shown without time',
      image: 'Image',
      imagePlaceholder: 'Upload avatar or icon',
      imageUploadFailed: 'Image could not be uploaded. Use My Media or paste link.',
      untitled: 'Untitled',
      listLayout: 'List layout',
      lineColor: 'Line color',
    },
    trust: {
      blockTitle: 'Trust',
      blockShortText: 'Share your partnerships',
      blockText: 'Place all your connections in one place.',
      titleText: 'Customize your title size',
      orderOfElements: 'Order of elements',
      orderOfElementsTooltip: 'Drag slider to change order of elements',
      changeOrder: 'Change order',
      text: 'Text',
      content: 'Content',
      image: 'Image',
      button: 'Button',
      displayedContent: 'Displayed content',
      displayedContentTooltip: 'Show or hide content',
      enterTrustLink: 'Enter Partner`s URL',
      enterTrustLinkTooltip: 'Paste Partner`s URL',
      enterPartnerName: 'Enter partner name',
      enterPartnerUrl: 'https://www.yourPartner.com/',
      enterDescription: 'Enter description (optional)',
      partnerLogo: 'Partner Logo',
      uploadPartnerLogo: `Upload your partner's logo`,
      imageColor: 'Image color',
      imageColorTooltip: 'Show partner logos in their original colors or as black & white',
      imageColorOriginal: 'Original',
      imageColorGrayscale: 'Black & white',
    },
    wall: {
      blockTitle: 'Wall',
      blockShortText: 'Collect messages from visitors',
      blockText: 'Display a public wall where visitors can leave messages and interact with your content',
    },
    'live-stream': {
      blockTitle: 'Live Stream',
      blockShortText: 'Go live on your page',
      blockText: 'Stream live to your audience — natively via our platform, or embed YouTube / Twitch',
    },
    workout: {
      blockTitle: 'Workout',
      blockShortText: 'Share & sell workouts',
      blockText: 'Post a structured workout — exercises with sets, reps and demo videos. Sell it or share for free',
      templates: {
        sessionCard: 'Session card',
        sessionCardCaption: 'Cover, name and one line of meta, over a single start button',
        exerciseList: 'Exercise list',
        exerciseListCaption: 'Every exercise with its thumbnail, sets and load',
        setTracker: 'Set tracker',
        setTrackerCaption: 'One row per set — logged, current, still to come',
        restTimer: 'Rest timer',
        restTimerCaption: 'A big countdown between sets, and what comes next',
        weekPlan: 'Week plan',
        weekPlanCaption: 'The days of the week, with today ready to start',
        videoExercise: 'Video exercise',
        videoExerciseCaption: 'A tall form video with the cues written underneath',
        progress: 'Progress',
        progressCaption: 'Sessions this month as bars, plus two totals',
        circuit: 'Circuit',
        circuitCaption: 'Rounds of work and rest, with the running exercise lit up',
        sessionDone: 'Session done',
        sessionDoneCaption: 'What was just finished, the streak, and a place to log how it felt',
      },
      defaults: {
        mon: 'Mon',
        tue: 'Tue',
        wed: 'Wed',
        thu: 'Thu',
        fullBody: 'Full body',
        legsAndCore: 'Legs and core',
        upperBody: 'Upper body',
        restDay: 'Rest',
      },
    },
    videoFeedback: {
      blockTitle: 'Video Feedback',
      blockShortText: 'Collect video testimonials',
      blockText: 'Collect short video testimonials and feedback from your audience',
    },
    'premium-inbox': {
      blockTitle: 'Premium Inbox',
      blockShortText: 'Paid messages from fans',
      blockText: 'Let fans send you paid messages and requests directly to your premium inbox',
    },
    'order-form': {
      blockTitle: 'Order Form',
      blockShortText: 'Collect orders from your page',
      blockText: 'Collect orders directly from your page with a customizable order form',
    },
    link: {
      blockTitle: 'Links',
      blockText: 'Drive traffic to your website, blog, online store, or any other web pages',
      blockShortText: 'Drive traffic to website',
      addLink: 'Add link',
      addNewLink: 'Add new link',
      restrictedTitle: '{platform} links are a PRO feature',
      restrictedText: 'Adding {platform} links is available on the PRO plan. Upgrade your plan to add this link to your page.',
      upgradeToPro: 'Upgrade to PRO',
      showMore: 'Show more',
      showLess: 'Show less',
      viewArchive: 'View archive',
      archivedLinks: 'Archived links',
      noArchivedLinks: `Keep your link admin clean and focused by archiving links you're not currently using.`,
      archiveAllUnpublished: 'Archive all unpublished links',
      addFormExisting: 'Add from existing links',
      addYourLink: 'Add your link to the group',
      add: 'Add',
      otherTypes: 'Action type',
      link: 'Link',
      navigate: 'Navigate',
      navigateTo: 'Navigate to',
      scrollBlock: 'Scroll to',
      copyText: 'Copy Text',
      navigatePage: 'Page',
      navigateProduct: 'Product',
      navigateBlock: 'Block',
      modal: 'Modal',
      showModal: 'Show Modal',
      modalBlock: 'Show Block',
      modalItem: 'Show Item',
      modalCustom: 'Custom',
      document: 'Document',
      privat24: 'Privat24',
      phone: 'Phone Call',
      viber: 'Open Viber',
      skype: 'Open Skype',
      email: 'Send Email',
      discount: 'Discount',
      smartLink: 'Smart Link',
      mobileApp: 'Deep Link',
      enterURL: 'Enter URL',
      enterPrivat: 'Enter your card of Private Bank',
      enterPhone: 'Enter phone number',
      enterViber: 'Enter viber number',
      enterSkype: 'Enter skype',
      enterEmail: 'Enter email',
      enterTitle: 'Enter title',
      enterCopyText: 'Enter text to copy',
      enterPromoCode: 'Enter promo code',
      group: 'Create Group',
      content: 'Content',
      links: 'Links',
      heading: 'Heading',
      settings: 'Settings',
      thumbnail: 'Thumbnail',
      typeTooltip: '  Click will open this link',
      title: 'Title',
      titleTooltip: 'Name of your link',
      description: 'Description',
      descriptionTooltip: 'Optional description of link features, types, color, sizes, etc.',
      label: 'Label',
      labelTooltip: 'Add label name',
      button: 'Button',
      buttonTooltip: 'Add button name',
      buttonText: 'Button text',
      buttonTextTooltip: 'Name of your button',
      buttonUrl: 'Button URL',
      buttonUrlTooltip: 'Enter of button URL',
      addLinkToGroup: 'Add link to group',
      removeFromGroup: 'Remove from group',
      deletePermanently: 'Delete Permanently',
      image: 'Image',
      buttonBg: 'Button bg',
      postPreview: 'Post Preview',
      separatorType: 'Separator type',
      separatorTypeTooltip: 'Add separator type to your button',
      section: 'Section',
      sectionTooltip: 'Section of link',
      descriptionSeparator: 'Description',
      descriptionSeparatorTooltip: 'Optional description of section',
      sectionText: 'Section text',
      linkInstant: 'Link instant forwarding',
      spotlight: 'Spotlight the link',
      addEffect: 'Add special effect',
      countdown: 'Countdown',
      countdownTimer: 'Countdown timer',
      countdownText: 'Add a live countdown to when your link becomes clickable',
      chooseDate: 'Choose date',
      chooseDateTooltip: 'Choose date for your link',
      chooseAction: 'Choose action',
      chooseActionTooltip: 'Choose action for your link',
      addCountdown: 'Add countdown for link',
      scheduler: 'Scheduler',
      schedule: 'Schedule',
      scheduleText: 'Choose a date and time in the future for your link to activate',
      activateOn: 'Activate on',
      activateOnTooltip: 'Choose date',
      deactivateOn: 'Deactivate on',
      deactivateOnTooltip: 'Choose date',
      addSchedule: 'Add schedule for',
      scheduleError: 'End date cannot be earlier than start date and start date cannot be in the past.',
      scheduleErrorPast: 'Activation date cannot be in the past.',
      scheduleErrorPastDeactivate: 'Deactivation date cannot be in the past.',
      scheduleErrorOrder: 'Deactivation date must be after activation date.',
      activatesIn: 'Activates in',
      deactivatesIn: 'Deactivates in',
      lock: 'Lock',
      lockText: 'Visitors can only access this link by fulfilling one of the criteria.',
      lockCode: 'Code',
      lockCodeTitle: 'Code to unlock this link',
      lockCodeText: 'Visitors need to enter 4 digit code to unlock this link',
      lockSubscribe: 'Subscribe',
      lockSubscribeTitle: 'Visitors must subscribe to your UniLink to unlock the link.',
      lockSubscribeText: 'Lock has been configured successfully.',
      lockPayment: 'Payment',
      lockPaymentText: 'Lock has been configured successfully.',
      price: 'Price',
      priceTooltip: 'Add price of your product',
      lockAge: 'Date of birth (Age)',
      lockAgeTitle: 'Set minimum age',
      lockAgeText: 'Visitors need to be over a certain age to unlock the link with their date of birth',
      lockAgeAlert: 'Lock has been configured successfully.',
      lockSensitive: 'Sensitive content',
      lockSensitiveText: 'Visitors must acknowledge that this link may contain content that is not appropriate for all audiences.',
      makeLink: 'Make link payable',
      addLock: 'Add lock for link',
      save: 'Save',
      clear: 'Clear',
      buttonColor: 'Button color',
      labelColor: 'Label color',
      background: 'Background',
      imageHeight: 'Image height',
      imageHeightTooltip: 'Drag slider to change height of image',
      buttonMinimum: 'Minimum height',
      buttonMinimumTooltip: 'Drag slider to change height of button',
      textPosition: 'Text position',
      textPositionTooltip: 'Choose vertical position of text',
      preview: 'preview',
      defaultDesign: 'Default design',
      defaultDesignTooltip: 'Set up default design for links',
      defaultDesignTitle: 'Please note that this design will be applied to all links.',
      defaultDesignText: 'You can change the default link design',
      changeDefault: 'Change default',
      applyDefault: 'Apply default',
      scheduled: 'Scheduled',
      scheduledVisible: 'Scheduled link is now visible',
      scheduledHidden: 'Scheduled link is now hidden',
      linkClickable: 'Link clickable in',
      linkDisable: 'Link disable in',
      lockedBy: 'Locked by',
      items: 'Items',
      doNotAnyLinks: `You don't have any links yet`,
      sublinks: 'Sublinks',
      layout: 'Layout',
      layoutTooltip: 'Choose the sublinks layout you want',
      hideGroupLink: 'Hide group link',
      rules: 'Rules',
      rulesText: 'Change the visibility of this link based on who is visiting your page.',
      rulesEmpty: 'No conditions yet. Add a condition to control who sees this link.',
      rulesAddCondition: 'Add condition',
      rulesActive: 'Visibility rules',
      rulesIf: 'If',
      rulesThen: 'Then',
      ruleTypeLocation: 'Location',
      ruleTypeDevice: 'Device',
      ruleTypeTime: 'Day & time',
      ruleOperatorIs: 'is',
      ruleOperatorIsNot: 'is not',
      ruleActionHide: 'Hide link',
      ruleActionShow: 'Show link',
      ruleSelectLocations: 'Select locations',
      ruleSearchLocations: 'Search countries…',
      ruleFrom: 'From',
      ruleTo: 'To',
      ruleAnyTime: 'Any',
    },
    'data-collect': {
      blockTitle: 'Data collect',
      blockText: 'Collect emails or phone numbers from your visitors',
      blockShortText: 'Collect emails',
      maxSize: 'You can add maximum 3 channels',
      customTerms: 'Custom T&Cs',
      customTermsTooltip: 'Add custom T&Cs to your form',
      termsConditions: 'Terms and Conditions',
      text: 'Text',
      subscribe: 'Subscribe',
      title: 'Title',
      titleTooltip: 'Enter title for terms and conditions',
      titleResultTooltip: 'Enter title for your submitting',
      url: 'URL',
      urlTooltip: 'Enter URL',
      editItem: 'Edit item',
      placeholder: 'Placeholder',
      placeholderTooltip: 'Enter placeholder text',
      button: 'Button',
      buttonTooltip: 'Text that will motivate visitor to enter email (10% off discount, subscribe now, download file etc.)',
      successMessage: 'Success message',
      successMessageTooltip: 'Success message of your subscribes',
      botURL: 'Bot URL (optional)',
      botURLTooltip: 'Enter URL of your bot',
      botToken: 'Bot Token',
      botTokenTooltip: 'Enter token of your bot',
      rewards: 'Responses',
      rewardsTooltip: 'Add responses of your subscribes',
      addReward: 'Add response',
      thankYou: 'Thank you message',
      email: {
        none: 'None',
        display: 'Show Response instantly',
        send: 'Send Response to Email',
        redirect: 'Redirect to URL',
      },
      phone: {
        none: 'None',
        display: 'Show Response instantly',
        send: 'Send Response to Phone',
        redirect: 'Redirect to URL',
      },
      telegram: {
        none: 'None',
        display: 'Show Response instantly',
        send: 'Send Response in Telegram bot',
        redirect: 'Redirect to URL',
      },
      whatsapp: {
        none: 'None',
        display: 'Show Response instantly',
        send: 'Send Response in WhatsApp bot',
        redirect: 'Redirect to URL',
      },
      instagram: {
        none: 'None',
        display: 'Show Response instantly',
        send: 'Send Response in Instagram bot',
        redirect: 'Redirect to URL',
      },
      messenger: {
        none: 'None',
        display: 'Show Response instantly',
        send: 'Send Response in Messenger bot',
        redirect: 'Redirect to URL',
      },
      viber: {
        none: 'None',
        display: 'Show Response instantly',
        send: 'Send Response in Viber bot',
        redirect: 'Redirect to URL',
      },
      connect: 'Connect',
      toChangeReward: 'To change response type you should remove the current one',
      remove: 'Remove',
      viewTypes: 'View Types',
    },
    form: {
      blockTitle: 'Form',
      blockText: 'Allows you to capture information and data from your audience',
      blockShortText: 'Capture information',
      fields: 'Fields',
      fieldsTooltip: 'Add fields to the form',
      addCustomField: 'Add custom field',
      addItem: 'Add item',
      editItem: 'Edit item',
      type: 'Type',
      typeTooltip: 'Choose type of field',
      string: 'Short answer',
      textarea: 'Long answer',
      dropdown: 'Dropdown',
      radio: 'Radio',
      checkbox: 'Checkbox',
      date: 'Date',
      time: 'Time',
      country: 'Country',
      file: 'File upload',
      rating: 'Rating',
      submissionsClosed: 'Stop accepting submissions',
      submissionsClosedTooltip: 'The form is replaced by a short notice. Answers already collected stay where they are.',
      closedTitle: 'Closed title',
      closedText: 'Closed message',
      templates: {
        contact: 'Contact form',
        contactCaption: 'A sentence, the fields, one button — the form people expect',
        steps: 'Multi-step',
        stepsCaption: 'Two questions per screen with a progress bar. A long form stops looking long',
        upload: 'File upload',
        uploadCaption: 'A dropzone first — for artwork, briefs and documents',
        schedule: 'Day and time',
        scheduleCaption: 'Pick a day and a slot, then leave a name',
        rating: 'Rating and feedback',
        ratingCaption: 'Stars, a few topics to tap, one comment box',
        card: 'Classic',
        cardCaption: 'The plain form: fields stacked on the page, button underneath',
        button: 'Popup button',
        buttonCaption: 'One button on the page; the form opens in a popup',
      },
      fieldName: 'Field Name',
      fieldNameTooltip: 'Enter field name',
      name: 'Name',
      placeholder: 'Placeholder',
      placeholderTooltip: 'Enter placeholder text',
      required: 'Required',
      requiredTooltip: 'Check if field is required',
      value: 'Value',
      enterTitle: 'Enter the title',
      addValue: 'Add value',
      delete: 'Delete',
      update: 'Update',
      add: 'Add',
      confirmationPage: 'Confirmation action',
      confirmationPageSubtitle: 'Choose result action after submitting form',
      successMessage: 'Success message',
      successMessageTooltip: 'Success message after submitting form',
      thankYou: 'Thank you message',
      submit: 'Submit',
    },
    contact: {
      blockTitle: 'Contacts',
      blockText: 'Contacts allows users to communicate with you directly. Add your phone, email, messenger, or location',
      blockShortText: 'Сommunicate with users',
      addNewContact: 'Add new contact',
      newContact: 'New contact',
      friendlyName: 'Friendly name',
      templates: {
        card: 'Messenger buttons',
        cardCaption: 'The classic block — one full-width button per channel',
        chips: 'Messengers',
        chipsCaption: 'Compact pills, two per row. Fastest way to be written to',
        person: 'Contact card',
        personCaption: 'One person with a photo, direct lines and a save-contact button',
        team: 'Team',
        teamCaption: 'Several people, each with their own messengers',
        place: 'Contacts + map',
        placeCaption: 'For an offline business: address, opening line, route',
        bar: 'Minimal bar',
        barCaption: 'A single strip with your name and channel icons',
        form: 'Contacts + form',
        formCaption: 'Messengers for quick questions, a form for longer ones',
        hours: 'Hours + phone',
        hoursCaption: 'When you work and how to call you right now',
        departments: 'Departments',
        departmentsCaption: 'Different channels for different requests',
        bio: 'Business card',
        bioCaption: 'A narrow card with a photo and stacked buttons',
        button: 'Popup button',
        buttonCaption: 'One button that opens the list of channels',
        floating: 'Floating widget',
        floatingCaption: 'A sticky stack in the corner of the page',

        layout: 'Layout',
        layoutCaption: 'How the items of this template are arranged',
        floatingStyle: 'Widget style',
        floatingStyleCaption: 'Named rows say what each button does; icons take less of the page',
        icons: 'Icons only',
        labels: 'With names',
        grid: 'Two per row',
        column: 'One per row',

        people: 'People',
        personSection: 'Person',
        personEmpty: 'Unnamed',
        addPerson: 'Add person',
        allChannels: 'All channels',
        personName: 'Name',
        personNameCaption: 'Shown as the heading of the card',
        personRole: 'Role',
        personRoleCaption: 'Job title or what this person handles',
        personPhone: 'Phone',
        personPhoneCaption: 'Shown as a line, not as a button',
        personEmail: 'Email',
        personEmailCaption: 'Shown as a line, not as a button',

        channels: 'Channels',
        channelsCaption: 'Which of the block’s channels belong here. Select none to show all of them',
        noChannels: 'Add a contact above first — then you can assign channels here.',

        vcard: 'Save-contact button',
        vcardText: 'Button text',
        vcardTextCaption: 'Downloads a contact card with the name, phone, email and links',

        department: 'Department',
        departmentEmpty: 'Untitled',
        addDepartment: 'Add department',
        departmentTitle: 'Title',
        departmentTitleCaption: 'Sales, Support, Partnerships…',
        departmentDescription: 'Description',
        departmentDescriptionCaption: 'What this department answers — one line',
        departmentMailText: 'Mail button',
        departmentMailTextCaption: 'Shown only when this department has no messenger of its own. Leave empty to label the button with the address itself',

        placeTitle: 'Place name',
        placeTitleCaption: 'Studio, office or shop name',
        placeAddress: 'Address',
        placeAddressCaption: 'Street and city',
        placeNote: 'Address note',
        placeNoteCaption: 'Floor, entrance, landmark',
        placeOpening: 'Opening line',
        placeOpeningCaption: 'One line, e.g. Mon–Fri 9:00–20:00 · Sat 10:00–16:00',
        placeMapUrl: 'Map link',
        placeMapUrlCaption: 'Opens when the map or the route button is tapped',
        placeRoute: 'Route button',
        placeRouteCaption: 'Leave empty to hide the button',
        placeMapImage: 'Map image',
        placeMapImageCaption: 'A screenshot of the map — no third-party embed loads on your page',

        phone: 'Phone',
        phoneLabel: 'Caption',
        phoneLabelCaption: 'Small line above the number',
        phoneNumber: 'Number',
        phoneNumberCaption: 'Shown large and dialled on tap',
        phoneCall: 'Call button',
        phoneCallCaption: 'Leave empty to hide the button',
        phoneCallback: 'Callback button',
        phoneCallbackCaption: 'Leave empty to hide the button',
        phoneCallbackUrl: 'Callback link',
        phoneCallbackUrlCaption: 'Where the callback button leads',

        hoursTitle: 'Heading',
        hoursTitleCaption: 'Shown above the schedule',
        hoursStatus: 'Status label',
        hoursStatusCaption: 'A caption you write, e.g. Open now. Leave empty to hide it',
        hoursDay: 'Day',
        hoursValue: 'Hours',
        hoursClosed: 'Closed',
        addHoursRow: 'Add row',

        formHint: 'Requests land in your CRM and are emailed to you — the same place Form block submissions go.',
        formTitle: 'Heading',
        formTitleCaption: 'Shown above the messengers',
        formDescription: 'Description',
        formDescriptionCaption: 'One or two lines about when to use the form',
        formNameLabel: 'Name field',
        formContactLabel: 'Contact field',
        formMessageLabel: 'Message field',
        formSubmitLabel: 'Submit button',
        formFieldCaption: 'Leave empty to hide the field',
        formNamePlaceholder: 'Name hint',
        formContactPlaceholder: 'Contact hint',
        formMessagePlaceholder: 'Message hint',
        formPlaceholderCaption: 'Greyed-out example inside the field, e.g. +380 67 123 45 67. Leave empty for a bare field',
        formSubmitCaption: 'Text of the submit button',
        formSuccessLabel: 'Thank-you text',
        formSuccessCaption: 'Replaces the form after a request is sent',
        formErrorLabel: 'Error text',
        formErrorCaption: 'Shown when the request could not be sent',
        replyTimes: 'Reply times',
        replyTimesCaption: 'Small note next to the channel, e.g. ~5 min',

        brand: 'Bar content',
        brandName: 'Name',
        brandNameCaption: 'Your name or the business name',
        brandLine: 'Second line',
        brandLineCaption: 'Email, phone or a short line',
        brandLine2: 'Third line',
        brandLine2Caption: 'The second detail line — an email above and a phone below reads better than both on one line',
        brandBackground: 'Bar background',
        brandTextColor: 'Bar text',

        floatingTeaser: 'Teaser',
        floatingTeaserCaption: 'Bubble next to the button, e.g. Questions? Write to us. Leave empty to hide it',
      },
      defaults: {
        saveContact: 'Save contact',
        route: 'Get directions',
        callUs: 'Call us',
        call: 'Call',
        hoursTitle: 'Opening hours',
        openNow: 'Open now',
        hoursRows: ['Mon — Fri', 'Saturday', 'Sunday'],
        formTitle: 'Get in touch',
        formName: 'Name',
        formContact: 'Phone or email',
        formMessage: 'Message',
        formSubmit: 'Send request',
        formSuccess: 'Thank you! We will get back to you shortly.',
        formError: 'Something went wrong. Please try a messenger above.',
        mailText: 'Write',
        formNamePlaceholder: 'Olena',
        formContactPlaceholder: '+380 67 123 45 67',
        formMessagePlaceholder: 'Briefly about the task',
      },
    },
    faq: {
      blockTitle: 'FAQ',
      blockText: 'Frequently Asked Questions — used to refer to a list of answers to typical questions that users might ask',
      blockShortText: 'Frequently Questions',
      addNewItem: 'Add new item',
      editItem: 'Edit item',
      title: 'Title',
      titleTooltip: 'Enter title',
      description: 'Description',
      descriptionTooltip: 'Enter description',
      update: 'Update',
      add: 'Add',
      howToFind: 'How to find us',
      view: 'View',
      viewTooltip: 'Choose how the FAQ items are displayed',
      feed: 'Feed',
      slider: 'Slider',
      emptyTitle: `You don't have any items yet`,
      emptyText: 'Add your first question to fill this block.',
      category: 'Category',
      categoryTooltip: 'Optional. Groups this question under a chip in the "Categories" and "Search" templates',
      categoryPlaceholder: 'e.g. Delivery',
      templates: {
        accordion: 'Accordion',
        accordionCaption: 'The classic block — one question per row, the answer opens on tap',
        categories: 'Categories',
        categoriesCaption: 'Chips split the questions by category. Set a category on each question',
        search: 'Search',
        searchCaption: 'Help centre: a search field over every answer plus the categories as topics',
        aside: 'Heading aside',
        asideCaption: 'Heading, text and its buttons on the left, the questions on the right',
        cards: 'Cards',
        cardsCaption: 'Every answer open at once, in a card grid. Best for short answers',
        numbered: 'Numbered',
        numberedCaption: 'Numbered questions with every answer open — nothing is hidden behind a tap, so crawlers and printouts get the full text',
      },
    },
    ama: {
      blockTitle: 'Ask Me Anything',
      blockShortText: 'Answer questions from fans',
      blockText: 'Let your audience ask questions and answer them right on your page',
      templates: {
        form: 'Form',
        formCaption: 'The classic layout — a question field, a name and a submit button',
        inbox: 'Inbox card',
        inboxCaption: 'Your photo and handle above a colourful card the question is typed straight into',
        bubble: 'Chat',
        bubbleCaption: 'Your line, then the question as the reply being written',
        minimal: 'Minimal',
        minimalCaption: 'One field and one button, nothing else',
        askBox: 'Ask box',
        askBoxCaption: 'Your photo and how many you have answered, above the question field',
        answeredFeed: 'Answered feed',
        answeredFeedCaption: 'The answers are the block — each question with your reply under it',
        popular: 'Popular questions',
        popularCaption: 'Ranked by how many people asked the same thing',
        live: 'Live session',
        liveCaption: 'A dark card saying you are answering right now, until the time you set',
        photo: 'Question with photo',
        photoCaption: 'Answers that show the photo the asker attached',
        categories: 'Categories',
        categoriesCaption: 'Chips split the answers by topic. Set a category on each question',
        paidQueue: 'Paid to skip queue',
        paidQueueCaption: 'Ask free and wait, or pay to jump the queue. Needs a price set',
        thread: 'Thread with replies',
        threadCaption: 'Your answer plus the replies that followed, as a conversation',
        closed: 'Closed for now',
        closedCaption: 'Takes no new questions — says when they reopen, past answers stay readable',
      },
      gradients: {
        title: 'Card colour',
      },
      prompts: {
        title: 'Suggested questions',
        hint: 'These sit in the field, so a visitor with nothing particular to ask still has something to send. The dice on your page swaps one for the next. Leave the list empty to show a plain placeholder.',
        placeholder: 'e.g. what song is stuck in your head?',
        add: 'Add question',
        remove: 'Remove',
        anonymityTitle: 'Who can ask',
        anonymityHint: 'Anonymous hides the name field entirely and says so on the page — that promise is what makes people write.',
        modeOptional: 'Name optional',
        modeAnonymous: 'Anonymous only',
        modeNamed: 'Name required',
        socialProofTitle: 'Show how many asked',
        socialProofHint: 'A real count under the button, once at least five questions have come in.',
        cardTitle: 'Card headline',
        cardTitleHint: 'The line printed inside the card, next to your photo.',
        cardTitlePlaceholder: 'send me anonymous messages!',
        liveTitle: 'Live notice',
        liveHint:
          'The card says you are answering right now, so say until when. Turn the template off when the session ends — a "LIVE" pill with nobody behind it costs more than it earns.',
        liveLabelPlaceholder: 'LIVE',
        liveNotePlaceholder: 'answering until 21:00',
        queueTitle: 'Queue copy',
        queueHint: 'Two buttons need a reason: say how long the free queue takes and what paying changes. The price itself comes from the Price field above.',
        queueNotePlaceholder: 'Free questions get answered on Thursdays. Paid ones jump to the front.',
        freeButtonPlaceholder: 'Ask free',
        paidButtonPlaceholder: 'today',
        closedTitle: 'Closed notice',
        closedHint: 'Shown instead of the question field. Say when questions reopen — a block that just says "closed" reads as broken.',
        closedTextPlaceholder: 'We answer once a week, properly, instead of badly every day.',
      },
      defaults: {
        prompts: ['send me anonymous messages!', 'what should I post next?', 'what song is stuck in your head?', 'what do you actually think of me?', 'best advice you ever got?'],
        cardTitleInbox: 'send me anonymous messages!',
        cardTitleBubble: 'Ask me anything!',
        cardTitleAskBox: 'Ask us anything',
        cardTitleLive: 'Ask now and get an answer tonight',
        liveLabel: 'LIVE',
        liveNote: 'answering until 21:00',
        cardTitleQueue: 'Need an answer today?',
        queueNote: 'Free questions get answered on Thursdays. Paid ones jump to the front.',
        freeButtonText: 'Ask free',
        paidButtonText: 'today',
        cardTitleClosed: 'Questions open on Thursday',
        closedText: 'We answer once a week, properly, instead of badly every day. Read the past answers meanwhile.',
      },
    },
    poll: {
      blockTitle: 'Poll',
      blockShortText: 'Let visitors vote',
      blockText: 'Ask a question and let your visitors vote on the options',
      templates: {
        classic: 'Classic',
        classicCaption: 'The options in a list, then bars with the counts once results are shown',
        duel: 'Two options',
        duelCaption: 'This or that — two big buttons side by side. Best with exactly two options',
        image: 'Image poll',
        imageCaption: 'The pictures are the options. Add an image to each one',
        scale: 'Rating scale',
        scaleCaption: 'A 1–10 row instead of options. Name the two ends in the description, separated by a comma',
        checklist: 'Multiple choice',
        checklistCaption: 'Checkboxes — pick as many as you like. Turns multiple selection on',
        live: 'Live poll',
        liveCaption: 'A dark card that says voting is happening now. The description sits next to the LIVE pill',
        suggest: 'Ranked options',
        suggestCaption: 'The options ordered by how many votes each has, most-wanted first',
        closed: 'Closed poll',
        closedCaption: 'Voting is over — shows the winner and its share. Closes the poll',
      },
    },
    quiz: {
      blockTitle: 'Quiz',
      blockShortText: 'Test your visitors',
      blockText: 'Ask a question with a correct answer and let visitors test their knowledge',
      correctAnswer: 'Correct answer',
    },
    voting: {
      blockTitle: 'Voting',
      blockShortText: 'Private vote',
      blockText: 'Run a vote — results stay private until each visitor casts their own vote',
    },
    feature: {
      templates: {
        icons: 'Icon list',
        iconsCaption: 'An icon, a title and a line of explanation per row',
        cards: 'Cards with photos',
        cardsCaption: 'A photo above each item — for things worth showing',
        checklist: 'Checklist',
        checklistCaption: 'Ticked one-liners: what is included',
        stats: 'Numbers',
        statsCaption: 'Big figures with a caption under each',
        media: 'Photo and text',
        mediaCaption: 'A picture over a real paragraph, per item',
        steps: 'Steps',
        stepsCaption: 'Numbered stages — how it works',
        single: 'One statement',
        singleCaption: 'A single claim with room around it',
        iconGrid: 'Icon grid',
        iconGridCaption: 'Short icon-and-label pairs, two per row',
        scroll: 'Scrolling cards',
        scrollCaption: 'A horizontal rail, each card with its own link',

        intro: 'Intro',
        title: 'Title',
        titleCaption: 'Heading above the items',
        introText: 'Intro text',
        introTextCaption: 'A line under the heading',
        rowIcons: 'Row icons',
        rowIconsHint: 'The icon shown beside each row.',
        icon: 'Icon',
        iconCaption: 'The badge above the statement',
        eyebrowCaption: 'The small line above the statement',
        rowNone: 'No icon',
        rowLabel: 'Row label',
        rowLabelCaption: 'A small line above each title',
        cta: 'Button',
        ctaText: 'Button text',
        ctaTextCaption: 'Leave empty to hide the button',
        ctaUrl: 'Button link',
        ctaUrlCaption: 'Where the button goes',
        rowLink: 'Card link',
        rowLinkText: 'Link text',
        rowLinkUrl: 'Link address',
      },
      blockTitle: 'Features',
      blockText: 'Text section with image to tell your users why your business is the best',
      blockShortText: 'Tell your users why',
      title: 'Title',
      titleTooltip: 'Change title of item',
      description: 'Description',
      descriptionTooltip: 'Change description of item',
    },
    highlight: {
      blockTitle: 'Highlights',
      blockText: 'Highlight most important links with thumbnails (up to 3)',
      blockShortText: 'Highlight most important',
      title: 'Title',
      titleTooltip: 'Change title of item',
      url: 'URL',
      urlTooltip: 'Change URL of item',
      modeLink: 'Link',
      modeStory: 'Story',
      coverPhoto: 'Photo',
      coverIcon: 'Icon',
      templates: {
        scroll: 'Scroll row',
        scrollCaption: 'The original block — round covers that wrap into rows, and scroll once there are more than three',
        story: 'Stories',
        storyCaption: 'Larger covers in the gradient ring, so a visitor reads them as stories to tap',
        square: 'Square covers',
        squareCaption: 'Square covers in a row that scrolls — reads as a shelf rather than a story tray',
        tall: 'Tall cards',
        tallCaption: 'Portrait cards with the name printed over the picture. Best when the cover is the point',
        icon: 'Icon covers',
        iconCaption: 'A grid of marks instead of photos — for when there are no pictures yet',
        grid: 'Grid',
        gridCaption: 'Every highlight at once on a four-column grid, for a set too long to scroll',
      },
    },
    banner: {
      blockTitle: 'Banner',
      blockText: 'Feature image, video or your latest product to make it stand out. You can add CTA button to guide users towards your goal conversion',
      blockShortText: 'Feature image, video',
      height: 'Height',
      heightTooltip: 'Change height for banner',
      badge: 'Badge',
      badgeTooltip: 'The small line printed above the title on this template',
      badgePlaceholder: 'Just printed',
      templates: {
        classic: 'Classic',
        classicCaption: 'The original banner — the words floating in the middle of the picture, sized by the aspect setting',
        coverTop: 'Cover, upper title',
        coverTopCaption: 'A small line above the headline, everything centred. Best when the banner names who you are',
        coverTitle: 'Cover, title only',
        coverTitleCaption: 'One word set large and letter-spaced, with a line under it. No buttons, nothing else',
        coverLeft: 'Cover, left aligned',
        coverLeftCaption: 'The words in the bottom corner and two buttons side by side, the way a landing page opens',
        coverCenter: 'Cover, centred buttons',
        coverCenterCaption: 'Everything centred, the buttons stacked as pills. The most direct of the six',
        coverVideo: 'Cover, video',
        coverVideoCaption: 'For a banner playing a video — a state pill, a sound control and one button',
        coverBadge: 'Cover, badge and CTA',
        coverBadgeCaption: 'A shorter frame: a white pill saying what is new, a headline and one button',
      },
    },
    slider: {
      blockTitle: 'Slider',
      blockText: 'Image carousel that allows you to showcase your images content and add different features',
      blockShortText: 'Image carousel',
      image: 'Image',
      imageTooltip: 'Image of your gallery',
      videoMedia: 'Video',
      videoMediaTooltip: 'MP4, WebM or MOV. Leave empty to show an image on this slide instead',
      addText: 'Add text',
      title: 'Title',
      titleTooltip: 'Title of your slide',
      titleSize: 'Title size',
      titleSizeTooltip: 'Choose size for better reading',
      description: 'Description',
      descriptionTooltip: 'Description of your slide',
      textColor: 'Text color',
      addButton: 'Add button',
      url: 'URL',
      urlTooltip: 'URL of your image',
      button: 'Button',
      buttonTooltip: 'Title of your button',
      buttonText: 'Button text',
      buttonColor: 'Button color',
      height: 'Height',
      heightTooltip: 'Change height for slides',
      view: 'View',
      viewTooltip: 'Choose view for slider',
      auto: 'Auto',
      square: 'Square',
      rectangle: 'Rectangle',
      single: 'Single',
      multi: 'Multi',
      templates: {
        multi: 'Multi',
        multiCaption: 'The original strip of cards, the next one showing at the edge',
        single: 'Single',
        singleCaption: 'The original one-at-a-time slider with the dots under it',
        showcase: 'Showcase',
        showcaseCaption: 'The original showcase — a big index, a counter and a thumbnail strip',
        full: 'Full-bleed with dots',
        fullCaption: 'One picture edge to edge, the dots the only chrome. For photographs that need no caption',
        peek: 'Peek next slide',
        peekCaption: 'The next slide showing at the edge, so the swipe is obvious before anyone tries it',
        caption: 'Slide with caption',
        captionCaption: "The picture in a card with the slide's own title and description printed under it",
        thumbs: 'With thumbnails',
        thumbsCaption: 'A strip under the picture, so a long set can be jumped through rather than swiped',
        counter: 'Counter and arrows',
        counterCaption: 'The count in words and two arrows — for a set worth stepping through deliberately',
        auto: 'Auto-play bars',
        autoCaption: 'Stories bars: the slider advances on its own and says how far through it is',
        compare: 'Before and after',
        compareCaption: 'The first two slides stacked with a line to drag across them. Their titles are the labels',
        video: 'Video slides',
        videoCaption: 'For slides that are video files — sound the visitor turns on, and the elapsed time',
        shop: 'Shoppable slides',
        shopCaption: "The slide's title, description and button read as name, price and action",
        shopName: 'Product name',
        shopNameTooltip: 'Name of the product on this slide',
        shopPrice: 'Price',
        shopPriceTooltip: 'Printed under the name on the slide card',
        compareLabel: 'Label',
        compareLabelTooltip: 'Printed on the image — the first slide is "before", the second is "after"',
      },
    },
    gallery: {
      blockTitle: 'Gallery',
      blockText: 'Image carousel that allows you to showcase your images content',
      blockShortText: 'Image carousel',
      image: 'Image',
      imageTooltip: 'Image of your gallery item',
      layout: 'Layout',
      layoutTooltip: 'Choose layout for gallery',
      feed: 'Feed',
      slider: 'Slider',
      animated: 'Animated',
      photos: 'photos',
      all: 'All',
      openGallery: 'Open the gallery',
      templates: {
        classic: 'Classic gallery',
        classicCaption: 'The original block — feed, slider or animated, each with its own layouts',
        hero: 'One photo',
        heroCaption: 'A single photo, big, with its caption under it. For the shot that carries the page',
        evenGrid: 'Even grid',
        evenGridCaption: 'Two columns of portrait frames — every photo gets the same room',
        mosaic: 'Mosaic of three',
        mosaicCaption: 'A tall frame beside two stacked ones, so the first photo leads',
        gridSix: 'Grid of six',
        gridSixCaption: 'Square tiles in two columns with the photo count in the corner',
        dense: 'Dense grid',
        denseCaption: 'Three columns and a tight gap, for when the archive matters more than one frame',
        carousel: 'Swipe carousel',
        carouselCaption: 'A swipe row with the caption of whatever is centred under it',
        mixed: 'Mixed heights',
        mixedCaption: 'Two columns whose frames alternate tall and short, so the rows never line up',
        rows: 'Rows of three and two',
        rowsCaption: 'Rows alternate three, one and two — the wide frame in the middle carries the best shot',
        filtered: 'Filtered portfolio',
        filteredCaption: 'Filter chips above the grid, each photo with its caption. Best for a portfolio',
        more: 'More overlay',
        moreCaption: 'Three photos and a tile counting the rest, for a big set that should not take over the page',
        captions: 'Captions',
        captionsCaption: 'One line per photo. Leave a photo empty and it shows without a caption',
        captionsEmpty: 'Add a photo above and its caption field appears here',
        captionPlaceholder: 'What is in this photo',
        filtersTitle: 'Title',
        filtersTitleCaption: 'The line above the chips, e.g. "Portfolio"',
        filtersAll: 'First chip text',
        filtersAllCaption: 'The chip that shows everything. Defaults to "All"',
        filtersChips: 'Filters',
        filtersChipsCaption: 'One chip per group, e.g. Posters, Covers, Packaging',
        filtersChipTitle: 'Posters, Covers…',
        addFilterChip: 'Add a filter',
        filtersAssign: 'Which filter each photo belongs to',
        filtersAssignCaption: 'A photo left on the first chip only shows when no filter is picked',
        moreCount: 'Tile text',
        moreCountCaption: 'The word under the "+N", e.g. "photos"',
        moreButton: 'Button text',
        moreButtonCaption: 'The button that opens the rest of the photos',
        headline: 'Panel title',
        headlineCaption: 'The bold line above the photos, e.g. "Recent work". Leave empty to show only the photo count',
        bylines: 'Second line',
        bylinesCaption: 'The muted line under the caption, e.g. "Photo by Marko, June"',
        bylinePlaceholder: 'Photo by …',
        footer: 'Footer row',
        footerText: 'Footer text',
        footerTextCaption: 'The line under the three photos. Leave empty to show only the action',
        footerAction: 'Action text',
        footerActionCaption: 'The link on the right of the footer row, e.g. "Open". Opens the first photo',
      },
      defaults: {
        photos: 'photos',
        all: 'All',
        openGallery: 'Open the gallery',
        filtersTitle: 'Portfolio',
        filtersChips: ['Posters', 'Covers', 'Packaging'],
      },
    },
    blog: {
      templates: {
        hero: 'Single article',
        heroCaption: 'One post with its cover — for an announcement, not an archive',
        list: 'Article list',
        listCaption: 'Title-and-date rows with a small thumbnail',
        cards: 'Stacked cards',
        cardsCaption: 'Full-width cards with a cover on each',
        rail: 'Scrolling feed',
        railCaption: 'A horizontal rail with category chips above it',
        archive: 'Compact archive',
        archiveCaption: 'Dates and titles only, grouped by month',
        mixed: 'Lead and two',
        mixedCaption: 'A lead article with two smaller ones beside it',

        intro: 'Intro',
        title: 'Title',
        titleCaption: 'Heading above the articles',
        introText: 'Intro text',
        introTextCaption: 'A line under the heading',
        categories: 'Categories',
        categoriesHint: 'The filter chips. Leave empty to use the categories the articles already carry.',
        linkSection: 'Link',
        moreText: 'Link text',
        moreTextCaption: 'e.g. "All articles" — leave empty to hide it',
        moreUrl: 'Link',
        author: 'Author',
        authorName: 'Author name',
        authorImage: 'Author photo',
        addCategory: 'Add category',
        categoryPlaceholder: 'e.g. Guides',
        category: 'Category',
        categoryCaption: 'Shown above the title and used by the filter chips',
      },
      blockTitle: 'Blog',
      blockText: 'Create blog of your posts',
      blockShortText: 'Create blog',
      writeYourStory: 'Write your story',
      shortDescription: 'Short description',
      shortDescriptionTooltip: 'Optional description for your blog',
      description: 'Description',
    },
    map: {
      blockTitle: 'Map',
      blockText: 'Add Google map to help users navigate to your local business',
      blockShortText: 'Add Google map',
      buttonText: 'Button text',
      buttonTextTooltip: 'The button appears when the second view is selected',
      text: 'Text',
      addAddress: 'Add another address',
      address: 'Address',
      addressTooltip: 'Paste the address from google maps for example',
      googleMap: 'Google map (embed code)',
      googleMapTooltip: 'Paste the embed code from google maps',
      howToFind: 'How to find embed code',
      incorrectCode: 'Incorrect embed code.',
      moreInfo: 'More information',
      code: 'Code',
      addressSettings: 'Address settings',
      addressContent: 'Add URL, title and button text or icon',
      title: 'Title',
      titleTooltip: 'The name of your address',
      url: 'URL',
      urlTooltip: 'Paste the address URL from google maps for example',
      directionText: 'Direction text',
      directionTextTooltip: 'Call to action text for your users',
      templates: {
        classic: 'Classic',
        classicCaption: 'The original block — the map with the address card under it, or a button that opens the map',
        mapOnly: 'Map only',
        mapOnlyCaption: 'Just the map and the address under it. Best for a single location',
        overlay: 'Map with card',
        overlayCaption: 'The map fills the block and the address floats over it on a card with the route button',
        points: 'Multiple points',
        pointsCaption: 'Every address as a numbered row — picking one moves the map above the list',
        details: 'Map and details',
        detailsCaption: 'The address spelled out under the map, with Route and Copy as full-width buttons',
        fullscreen: 'Full-screen map',
        fullscreenCaption: 'The map takes the whole block, the current address sits on a sheet at the bottom',
        tabs: 'City tabs',
        tabsCaption: 'Addresses as chips above the map. Best for a business with a few branches',
        directions: 'How to get here',
        directionsCaption: 'The map with the approach spelled out — metro, car, the landmark to look for',
        delivery: 'Delivery area',
        deliveryCaption: 'Where you deliver, with the time and price of each zone',
        compact: 'Compact row',
        compactCaption: 'The address in one row with a thumbnail map — for a page that leads with something else',
        directionsTitle: 'Title',
        directionsTitleCaption: 'The line above the ways of getting here, e.g. "How to find us"',
        directionsNote: 'Subtitle',
        directionsNoteCaption: 'Optional. A short line under the title — the entrance, the floor',
        directionsRows: 'Ways to get here',
        directionsRowsCaption: 'One row per way: pick an icon, name it, then describe it',
        directionsRowTitle: 'Metro, Car, Landmark…',
        directionsRowText: 'How to get here this way',
        addDirectionsRow: 'Add a way',
        deliveryTitle: 'Title',
        deliveryTitleCaption: 'The line above the zones, e.g. "Where we deliver"',
        deliveryNote: 'Subtitle',
        deliveryNoteCaption: 'Optional. Delivery hours or a condition',
        deliveryZones: 'Zones',
        deliveryZonesCaption: 'One row per zone: its name, how long it takes and what it costs',
        deliveryZoneTitle: 'Zone, e.g. Centre, up to 3 km',
        deliveryZoneTime: '30–40 min',
        deliveryZonePrice: 'Free',
        addDeliveryZone: 'Add a zone',
        contactPhone: 'Phone',
        contactPhoneCaption: 'Shown as a Call button. Without it the second button copies the address',
        contactCall: 'Call button text',
        contactCallCaption: 'Defaults to "Call"',
        contactStatus: 'Status',
        contactStatusCaption: 'Optional. A short line with a dot, e.g. "Open until 8pm"',
        contact: 'Phone and status',
        contactStatusColor: 'Status colour',
        detailsHours: 'Opening hours',
        detailsHoursCaption: 'The row with the clock, e.g. "Mon–Fri 9:00–20:00 · Sat 10:00–16:00"',
        detailsNote: 'Under the address',
        detailsNoteCaption: 'Optional. The floor, the entrance — the part a map pin cannot show',
        detailsRows: 'Extra rows',
        detailsRowsCaption: 'One row per thing worth knowing: parking, the entrance, what is nearby',
        detailsRowText: 'Free parking in the yard',
        addDetailsRow: 'Add a row',
        deliveryAddressLabel: 'Address field hint',
        deliveryAddressLabelCaption: 'What the "am I in range?" field says before the visitor types, e.g. "Your street and number"',
        deliveryZoneColor: 'Zone colour',
        pointsTitle: 'Title above the list',
        pointsTitleCaption: 'Optional, e.g. "Our locations"',
        pointHours: 'Opening hours per location',
        pointHoursCaption: 'Shown beside each address, e.g. "until 20:00". Leave empty to hide',
        pointHoursPlaceholder: 'until 20:00',
      },
      defaults: {
        directionsTitle: 'How to find us',
        directionsRows: [
          { icon: 'metro', title: 'Metro' },
          { icon: 'car', title: 'By car' },
          { icon: 'landmark', title: 'Landmark' },
        ],
        deliveryTitle: 'Where we deliver',
        deliveryZone: 'Centre',
        call: 'Call',
      },
    },
    footer: {
      templates: {
        minimal: 'Minimal',
        minimalCaption: 'The mark, the social row and the legal line. Closes the page without a second menu',
        columns: 'Two link columns',
        columnsCaption: 'Links grouped under labels, two columns wide. For a handful of real sections',
        accordion: 'Accordion menu',
        accordionCaption: 'Collapsible groups on a dark panel. For more sections than a footer can list flat',
        subscribe: 'Footer with subscribe',
        subscribeCaption: 'An email field over the nav chips. For a footer that collects addresses',
        contacts: 'Contact footer',
        contactsCaption: 'Phone, email and address as tappable rows, with the messengers under them',
        shop: 'Large shop footer',
        shopCaption: 'Shipping promise, link columns, app badges and payment marks',
        cta: 'Call to action',
        ctaCaption: 'A filled panel with a headline and two actions. The page’s closing argument',
        sticky: 'Footer with action bar',
        stickyCaption: 'A plain footer with a call, a chat shortcut and the main button under it',
        locale: 'Language and currency',
        localeCaption: 'Language, currency and shipping country over the store’s help links',
      },
      // Content-tab editor copy, read by Footer/utils/templates.js getFooterSectionLabels.
      sections: {
        groups: 'Link groups',
        groupsHint: 'Each group is one labelled column of links.',
        groupTitle: 'Group title',
        addGroup: '+ Add group',
        addLink: '+ Add link',
        linkLabel: 'Label',
        linkUrl: 'URL',
        subscribe: 'Subscribe band',
        subscribeTitle: 'Title',
        subscribeText: 'Text',
        subscribeButton: 'Button text',
        subscribePlaceholder: 'Field placeholder',
        subscribeNote: 'Small print under the field',
        subscribeDone: 'Confirmation text',
        apps: 'App badges',
        appLabel: 'Badge label',
        appImage: 'Badge image URL',
        appUrl: 'Store link',
        addApp: '+ Add badge',
        locale: 'Language and currency',
        localeLanguages: 'Languages',
        languageCode: 'Code',
        languageLabel: 'Label',
        addLanguage: '+ Add language',
        currency: 'Currency',
        country: 'Shipping country',
        cta: 'Call to action',
        ctaTitle: 'Headline',
        ctaText: 'Text',
        ctaButton: 'Button text',
        ctaButtonUrl: 'Button link',
        ctaPhone: 'Phone',
        ctaChatUrl: 'Chat link',
        contacts: 'Contact rows',
        contactsHint: 'A row with no value is not shown on the page.',
        contactValue: 'Text shown',
        contactHref: 'Link (tel:, mailto: or a URL)',
        addContact: '+ Add row',
        hours: 'Opening hours',
        hoursPlaceholder: 'e.g. Mon–Fri, 9:00–18:00',
        promise: 'Shipping promise',
        promisePlaceholder: 'e.g. Free delivery on orders over $50',
        legal: 'Legal line',
        legalHint: 'Left empty, the last text row of the footer is used.',
        legalText: 'Copyright line',
        legalLinks: 'Policy links',
        remove: 'Remove',
      },
      defaults: {
        groups: [
          { title: 'Services', links: ['Design', 'Development', 'Branding'] },
          { title: 'Company', links: ['About', 'Cases', 'Careers'] },
        ],
        subscribeTitle: 'One letter a month',
        subscribeText: 'Cases, process and a little behind the scenes. No spam.',
        subscribeButton: 'Subscribe',
        ctaTitle: 'Tell us about your project',
        ctaText: 'We reply within an hour on working days.',
        ctaButton: 'Write to us',
        languages: [
          { code: 'uk', label: 'Ukr' },
          { code: 'en', label: 'Eng' },
          { code: 'pl', label: 'Pl' },
        ],
        currency: '₴ Hryvnia',
        country: 'Ukraine',
        contacts: [
          { icon: 'phone', value: '+38 044 123 45 67' },
          { icon: 'mail', value: 'hi@studio.ua' },
          { icon: 'pin', value: '22 Khoryva St, Kyiv' },
        ],
      },
      blockTitle: 'Footer',
      blockText: 'Section of content at the very bottom of a page. You can add contact information, social media icons, and an email sign-up form',
      blockShortText: 'Section of bottom content',
      addBlock: 'Add block',
      blockType: 'Block type',
      blockTypeTooltip: 'Choose block type',
      addBlockTitle: 'Block title',
      addBlockTitleTooltip: 'Choose title of block',
      faq: 'FAQ',
      'data-collect': 'Data Collect',
      contact: 'Contact',
      pages: 'Pages',
      payments: 'Payments',
      social: 'Social',
      cancel: 'Cancel',
      add: 'Add',
      None: 'None',
      text: 'Text',
      link: 'Links',
      image: 'Image',
      divider: 'Divider',
      linkViewLabel: 'Layout',
      linkViewTooltip: 'How the links are arranged',
      linkViewSingle: 'Stacked',
      linkViewRow: 'In a row',
      linkItemsLabel: 'Links',
      linkItemsTooltip: 'Add up to 5 links (e.g. Privacy Policy, Terms)',
      linkLabelPlaceholder: 'Label',
      linkUrlPlaceholder: 'URL',
      linkAddMore: '+ Add link',
      alignLabel: 'Alignment',
      alignTooltip: 'Horizontal alignment',
      alignLeft: 'Left',
      alignCenter: 'Center',
      alignRight: 'Right',
      imageLabel: 'Image',
      imageTooltip: 'Upload a logo or image',
      imageLinkLabel: 'Link (optional)',
      imageLinkTooltip: 'Make the image clickable',
      dividerLabel: 'Divider type',
      dividerTooltip: 'A line or an empty space',
      dividerLine: 'Line',
      dividerSpace: 'Space',
      picker: {
        subtitle: 'Pick an element to add to your footer',
        configureSubtitle: 'Configure and add it to your footer',
        back: 'Back',
        saveButton: 'Save',
        availableTitle: 'Available to add',
        addedTitle: 'Already added',
        addedLabel: 'Added',
        addButton: 'Add block',
        linkTitle: 'Links',
        linkSub: 'Buttons to any URL',
        socialTitle: 'Social',
        socialSub: 'Icons for your social profiles',
        textTitle: 'Text',
        textSub: 'A heading or paragraph',
        pagesTitle: 'Pages',
        pagesSub: 'Link to nested sub-pages',
        paymentsTitle: 'Payments',
        paymentsSub: 'Accepted payment methods',
        imageTitle: 'Image',
        imageSub: 'A logo or picture',
        dividerTitle: 'Divider',
        dividerSub: 'A line or spacing',
        faqTitle: 'FAQ',
        faqSub: 'Frequently asked questions',
        dataCollectTitle: 'Data Collect',
        dataCollectSub: 'Email sign-up form',
        contactTitle: 'Contact',
        contactSub: 'Contact details',
        importMode: 'Import from block',
        manualMode: 'Add manually',
        noContactsToImport: 'No contacts to import — add them manually.',
        noSocialsToImport: 'No social icons to import — add them manually.',
        manualItemsLabel: 'Items',
        manualItemsTooltip: 'Pick a type and enter its value.',
        contactValuePlaceholder: '@username / email / phone',
        socialUrlPlaceholder: 'https://...',
        addMore: '+ Add more',
      },
      faqText: 'You can edit frequently asked questions in FAQ block. You can navigate to it by clicking this',
      socialText: 'You can edit social icons in Header block. You can navigate to it by clicking this',
      dataCollectText: 'You can edit data-collect in Data Collect block. You can navigate to it by clicking this',
      contactText: 'You can edit contact in Contact block. You can navigate to it by clicking this',
      contactDesign: {
        editSource: 'Edit the contacts themselves in the Contact block —',
        variantLabel: 'Style',
        variantList: 'List',
        variantButton: 'Button',
        shapeLabel: 'Shape',
        shape_square: 'Square',
        shape_rounded: 'Rounded',
        shape_pill: 'Pill',
        widthLabel: 'Width',
        widthFull: 'Full',
        widthHalf: 'Half',
        widthHalfStacked: 'Half column',
        borderLabel: 'Border',
        borderOn: 'On',
        borderOff: 'Off',
        borderColorLabel: 'Border color',
      },
      pagesText: 'You can add new pages on Website',
      paymentsText: 'Payments methods will be displayed',
      showOnAllpages: 'Show on all pages',
      layout: 'Layout',
      splitImage: 'Side image',
      footerText: 'The Footer from the Home page is currently enabled.',
      editSocialIcons: 'You can edit social icons in Header section. You can navigate to it by clicking this',
      editSubscribe: 'You can edit subscribe in Subscribe section. You can navigate to it by clicking this',
      editContacts: 'You can edit contacts in Contacts section. You can navigate to it by clicking this',
      editFrequently: 'You can edit frequently asked questions in FAQ section. You can navigate to it by clicking this',
    },
    'chat-ai': {
      blockTitle: 'Live Chat',
      blockShortText: 'Chat with AI',
      blockText: 'Chat with AI',
      suggestionsTitle: 'Suggestions',
      suggestionsSubtitle: 'Quick prompts',
      templates: {
        askBar: { title: 'Ask bar', caption: 'An input bar with a strip of suggested prompts.' },
        topicCards: { title: 'Topic cards', caption: 'Prompts stacked as full-width cards above the input.' },
        conversation: { title: 'Conversation', caption: 'One wide button; the chat opens when a visitor taps it.' },
        bubble: { title: 'Bubble and panel', caption: 'A floating button that opens the chat in a panel.' },

        // `persona` stays a plain string: ChatTemplateContent renders `labels.persona` directly as
        // the section heading, so a `{ title, caption }` object here would be passed to React as a
        // child and throw. Once that component reads a separate key, the nested pair can land —
        // 'Persona card' / 'Introduces the assistant with a photo, a name and a description.'
        persona: 'Persona',
        launcher: 'Button',
        launcherHint: 'The block is one button until a visitor taps it. Say what they get — the chat opens in place.',
        launcherLabel: 'Button text',
        launcherLabelCaption: 'Left empty, the button reads “Start the conversation”.',
        launcherIcon: 'Icon',
        launcherIconCaption: 'The glyph beside the button text.',
        personaHint: 'Who the visitor is about to talk to. Every field is optional — anything you leave empty is left off the card.',
        personaAvatar: 'Photo URL',
        personaAvatarCaption: 'A square image reads best; it is cropped to a circle.',
        personaName: 'Name',
        personaNameCaption: 'What the assistant is called.',
        personaStatus: 'Status line',
        personaStatusCaption: 'The short line under the name, beside the green dot.',
        personaDescription: 'Description',
        personaDescriptionCaption: 'A sentence or two on what it can answer.',
        personaPrimary: 'Main button text',
        personaPrimaryCaption: 'Opens the chat. Left empty, it reads “Start a chat”.',
        personaSecondary: 'Second button text',
        personaSecondaryCaption: 'Optional. Leave empty to show one button.',
        personaSecondaryUrl: 'Second button link',
        personaSecondaryUrlCaption: 'Where the second button goes.',
      },
      viewLabel: 'View',
      viewInline: 'Inline',
      viewBubble: 'Floating Bubble',
      viewFixed: 'Fixed',
      welcomeTitle: 'Welcome Message',
      welcomeSubtitle: 'Greeting when user opens chat',
      welcomeEnableLabel: 'Enable welcome message',
      welcomePlaceholder: 'Hi! How can I help you today?',
      behaviourTitle: 'Assistant behaviour',
      behaviourSubtitle: 'Instructions and where the chat appears',
      systemPromptLabel: 'Instructions',
      systemPromptCaption: 'Tell the assistant who it is and what it should stick to. Left empty, it answers from your sources alone.',
      systemPromptPlaceholder: 'You are the studio’s assistant. Answer only from the price list and the pages above…',
      showOnAllPagesLabel: 'Show on every page',
      showOnAllPagesCaption: 'The chat follows the visitor instead of living only on the page it was added to.',
      saving: 'saving…',
      suggestionShown: 'Shown',
      suggestionHidden: 'Hidden',
      statusPending: 'Pending',
      statusProcessing: 'Processing...',
      statusReady: 'Ready',
      statusFailed: 'Failed',
      retry: 'Retry',
      sourceText: 'Text',
      sourceFile: 'File',
      sourceUrl: 'Web page',
    },
    custom: {
      blockTitle: 'Custom',
      blockShortText: 'AI-powered block',
      blockText: 'Describe a mini interactive app and AI will generate it for you',
    },
    shop: {
      blockTitle: 'Shop',
      blockText: 'Add your product list',
      blockShortText: 'Add your products',
      view: 'View',
      cardLayout: 'Card layout',
      cardLayoutTooltip: 'Showcase renders each product as a detailed sales card, one per row',
      standardCards: 'Standard',
      showcaseCards: 'Showcase',
      products: 'Products',
      categories: 'Categories',
      featured: 'Featured',
      shoppingCart: 'Shopping cart',
      shoppingCartNote: 'The cart button appears once a visitor adds a product',
      cartIconDisabledHint: 'Turn the shopping cart on to use this',
    },
    digital: {
      blockTitle: 'Digital products',
      blockText: 'Sell a Digital Download: PDFs, Spreadsheets, Templates, Exclusive',
      blockShortText: 'Sell a Digital',
    },
    podcast: {
      templates: {
        latest: 'Latest episode',
        latestCaption: 'The newest episode and one button to start it',
        player: 'Player',
        playerCaption: 'A scrubber, back 15, forward 30 and a speed control',
        list: 'Episode list',
        listCaption: 'Play, number, title, length — the plain feed',
        resume: 'Continue listening',
        resumeCaption: 'Where this visitor stopped, kept in their own browser',
        bestOf: 'Best of',
        bestOfCaption: 'Three episodes to start with, in the order you arranged them',
        cover: 'Show cover',
        coverCaption: 'Artwork, what the show is about, and the apps it is on',
        subscribe: 'Subscribe row',
        subscribeCaption: 'One line and the directories — no artwork, no episodes',
        trailer: 'Trailer',
        trailerCaption: 'The two-minute answer to "is this show for me"',
        guest: 'Guest episode',
        guestCaption: 'An interview sold on who is in it, with the picture full width',
        guests: 'Guest line-up',
        guestsCaption: 'The faces who have been on the show, as a grid',
        hosts: 'Meet the hosts',
        hostsCaption: 'Who makes the show, read from the episodes’ author field',
        chapters: 'Chapters and notes',
        chaptersCaption: 'Timestamped lines from the notes — tapping one seeks the player',
        transcript: 'Transcript',
        transcriptCaption: 'The episode in writing, every line a seek',
        clip: 'Shareable clip',
        clipCaption: 'One sentence pulled big, with a share button under it',
        video: 'Video podcast',
        videoCaption: 'The still, and the choice between watching and listening',
        seasons: 'Seasons',
        seasonsCaption: 'Your shows as chips, that show’s episodes below',
        topics: 'Topic filter',
        topicsCaption: 'Episodes filtered by the category their show is filed under',
        showCards: 'Show cards',
        showCardsCaption: 'Every show as a card, scrolling sideways',
        ask: 'Listener question',
        askCaption: 'A prompt, an example question and where the answers go',
        ratings: 'Ratings',
        ratingsCaption: 'Your score and one review worth quoting',
        support: 'Support the show',
        supportCaption: 'What supporters get, and where they sign up',
        classic: 'Listen Now',
        classicCaption: 'The original block — the feed with a Shows tab',
        showcase: 'Showcase',
        showcaseCaption: 'The editorial view: a large card and a rail of covers',
      },
      copy: {
        askTitle: 'Listener question',
        askHint: 'The prompt, one example question, and where the answers go — a form, a mail address, a voice inbox.',
        ratingTitle: 'Ratings',
        ratingHint: 'Your score and one review worth quoting. The block prints what you type — it does not fetch it from Apple or Spotify.',
        supportTitle: 'Support the show',
        supportHint: 'What supporters get, and where they sign up. The button goes to whatever already takes the payments.',
        title: 'Title',
        text: 'Text',
        question: 'Example question',
        url: 'Button link',
        buttonText: 'Button text',
        voiceUrl: 'Voice message link',
        value: 'Score',
        count: 'Where from',
        quote: 'Review',
        author: 'Who said it',
        tiers: 'Tiers',
        tierName: 'Name',
        tierPerk: 'What they get',
        tierPrice: 'Price',
        addTier: '+ Add tier',
        removeTier: 'Remove tier',
      },
      blockTitle: 'Podcasts',
      blockText: 'Promote your podcasts',
      blockShortText: 'Promote your podcasts',
    },
    'page-list': {
      blockTitle: 'Page list',
      blockText: 'Create your list pages',
      description: 'Description',
      blockShortText: 'Create your list pages',
      addNewPageItem: 'Add page link',
    },
    appointment: {
      blockTitle: 'Appointments',
      blockText: 'Let visitors book time on your calendar',
      blockShortText: 'Let visitors book',
    },
    service: {
      modal: {
        title: 'Add new service',
        subtitle: 'Enter the essentials — add the rest on the service page',
        thumbnail: 'Thumbnail (optional)',
        thumbnailTooltip: 'Upload a cover photo',
        label: 'Label (optional)',
        labelTooltip: 'Highlight this service with a badge',
        titleField: 'Title',
        titleTooltip: 'Add a title for your service',
        titlePlaceholder: 'e.g. Family photo session — 1 hour',
        cancel: 'Cancel',
        submit: 'Add',
      },
      blockTitle: 'Services',
      blockText: 'You will receive an email notification when a request is submitted to you',
      blockShortText: 'Receive an email',
    },
    requests: {
      blockTitle: 'Services',
      blockText: 'You will receive an email notification when a request is submitted to you',
      blockShortText: 'Receive an email',
    },
    tips: {
      blockTitle: 'Tips',
      blockText: 'UniLink makes supporting fun and easy. In just a couple of taps, your fans can make the payment and leave a message',
      blockShortText: 'Makes supporting fun',
    },
    tip: {
      blockTitle: 'Tips',
      blockText: 'UniLink makes supporting fun and easy. In just a couple of taps, your fans can make the payment and leave a message',
      blockShortText: 'Makes supporting fun',
    },
    donation: {
      blockTitle: 'Donations',
      blockText: 'UniLink makes supporting fun and easy. In just a couple of taps, your fans can make the payment and leave a message',
      blockShortText: 'Makes supporting fun',
    },
    crowdfunding: {
      blockTitle: 'Crowdfunding',
      blockText: 'Run a goal-based fundraiser with progress & supporters',
      blockShortText: 'Goal-based fundraiser',
    },
    course: {
      blockTitle: 'Course or Tutorial',
      blockText: 'Let visitors book time on your calendar',
      blockShortText: 'Let visitors book',
    },
    event: {
      blockTitle: 'Events or Tickets',
      blockText: 'Let audience visit your events',
      blockShortText: 'Let audience visit',
    },
    menu: {
      blockTitle: 'Menu',
      blockText: 'Create a unique menu with prices',
      blockShortText: 'Create unique menu',
    },
    recipe: {
      blockTitle: 'Recipe',
      blockText: 'Share a recipe with ingredients, steps, and photos',
      blockShortText: 'Share a recipe',
    },
    booking: {
      blockTitle: 'Booking',
      blockText: 'Let visitors book your spaces',
      blockShortText: 'Let visitors book',
      name: 'Name',
      nameCaption: 'Enter the name of the space',
      description: 'Description',
      descriptionCaption: 'Short description for this space',
      rentalType: 'Rental type',
      rentalTypeCaption: 'For example: apartment, car, office',
      duration: 'Duration',
      durationCaption: 'For example: per day, per week, per month',
      price: 'Price',
      priceCaption: 'Base price for this space',
      oldPrice: 'Old price',
      oldPriceCaption: 'Optional previous price',
      rating: 'Rating',
      ratingCaption: 'Average rating (optional)',
      label: 'Label',
      labelCaption: 'Short badge like HOT or NEW',
      image: 'Image',
      imageCaption: 'Upload a cover image for this space',
      location: 'Location',
      locationCaption: 'City, area or address',
      capacity: 'Capacity (guests)',
      capacityCaption: 'Maximum number of guests',
      rooms: 'Rooms & area',
      roomsCaption: 'Bedrooms, bathrooms and area',
      bedrooms: 'Bedrooms',
      bathrooms: 'Bathrooms',
      areaSqM: 'Area (m²)',
      minStay: 'Minimum stay (days)',
      minStayCaption: 'Minimum number of days for booking',
      requiresDeposit: 'Requires deposit',
      depositAmount: 'Deposit amount',
      depositAmountCaption: 'Upfront deposit to confirm booking',
      noSmoking: 'No smoking',
      noPets: 'No pets',
      amenitiesWifi: 'Wi‑Fi',
      amenitiesParking: 'Parking',
      amenitiesKitchen: 'Kitchen',
      amenitiesHeating: 'Heating',
      amenitiesAC: 'Air conditioning',
      amenitiesPool: 'Pool',
      amenitiesSauna: 'Sauna',
      amenitiesRestrooms: 'Restrooms',
      validationNameRequired: 'Name is required',
      validationPriceRequired: 'Price must be a non‑negative number',
      validationDepositRequired: 'Deposit amount is required when deposit is enabled',
      validationCapacityNumber: 'Capacity must be a non‑negative number',
      validationOldPriceNumber: 'Old price must be a non‑negative number',
      brand: 'Brand',
      brandCaption: 'Car brand, e.g. Tesla',
      model: 'Model',
      modelCaption: 'Car model, e.g. Model 3',
      year: 'Year',
      yearCaption: 'Year of manufacture',
      color: 'Color',
      colorCaption: 'Exterior color, e.g. black',
      fuelType: 'Fuel type',
      fuelTypeCaption: 'Gasoline, diesel, electric, hybrid etc.',
      transmission: 'Transmission',
      transmissionCaption: 'Automatic or manual',
      seatCount: 'Seat count',
      seatCountCaption: 'Number of seats in the car',
      edit: 'Edit item',
      add: 'Add item',
    },
    membership: {
      blockTitle: 'Membership',
      blockText: 'Create a free or paid subscription to your content',
      blockShortText: 'Create subscription',
    },
    pricing: {
      blockTitle: 'Pricing',
      blockText: 'Create unique menu with prices',
      blockShortText: 'Create unique menu',
      name: 'Name',
      nameTooltip: 'Enter name of your product',
      pricingPlanName: 'Pricing plan name',
      pricingPlanNameTooltip: 'Enter name of your pricing plan name',
      description: 'Description',
      descriptionTooltip: 'Enter description of your product',
      pricingPlanDescriptionTooltip: 'Enter description of your pricing plan',
      priceValue: 'Price value',
      priceUnit: 'Price unit',
      label: 'Label',
      labelTooltip: 'Enter label of your pricing plan',
      orderButtonText: 'Order button text',
      orderButtonTextDescriptionTooltip: 'Enter order button text of your pricing plan',
      orderButtonLink: 'Order button link',
      orderButtonLinkDescriptionTooltip: 'Enter order button link of your pricing plan',
      subtitle: 'Subtitle',
      subtitleTooltip: 'Enter subtitle of your product',
      price: 'Price',
      priceTooltip: 'Enter price of your product',
      pricingTiers: 'Pricing tiers',
      pricingTiersTooltip: 'Enter pricing tiers of your product',
      addPriceValue: 'Add more price',
      group: 'Group',
      groupTooltip: 'Choose group of your product',
      image: 'Image',
      imageTooltip: 'Upload image for your product',
      unit: 'Price unit',
      unitTooltip: 'Enter unit of your price',
      addUnitTitle: 'Price units',
      addPriceUnitValue: 'Add more price unit',
      addUnitButtonText: 'Save',
      button: 'Button',
      buttonTooltip: 'Add button for your product',
      buttonAddText: '+ Add button',
      buttonModalTextField: 'Button text',
      buttonModalTextFieldTooltip: 'Enter button text',
      buttonModalURLField: 'Button URL',
      buttonModalURLFieldTooltip: 'Enter button URL',
      buttonModalTitle: 'Add button',
      groups: {
        title: 'Groups',
        subtitle: 'Add, edit and delete groups',
        groups: 'Groups',
        groupsTooltip: 'Add, edit and delete groups',
        addNewGroup: 'Add new group',
        newGroup: 'New group',
        titleGroup: 'Title',
        titleGroupTooltip: 'Enter title of your group',
        descriptionGroup: 'Description',
        descriptionGroupTooltip: 'Enter description of your group',
      },
    },
    menuBlock: {
      title: 'Menu',
      subtitle: 'Create a menu with items and prices',
      add: 'Add new item',
      edit: 'Edit item',
      name: 'Name',
      nameCaption: 'Enter the item name',
      description: 'Description',
      descriptionCaption: 'Enter a short description',
      ingredients: 'Ingredients',
      ingredientsCaption: 'List ingredients or composition',
      price: 'Price',
      priceCaption: 'Enter the price',
      weight: 'Weight (g)',
      weightCaption: 'Enter the weight in grams',
      calories: 'Calories (kcal)',
      caloriesCaption: 'Enter calories in kcal',
      label: 'Label',
      labelCaption: 'Enter label text',
      labelColor: 'Label color',
      labelColorCaption: 'Choose a label background color',
      image: 'Image',
      imageCaption: 'Upload an image for your item',
      available: 'Available for ordering',
      visible: 'Visible on page',
    },
    nft: {
      blockTitle: 'NFT',
      blockText: 'Display an NFT from OpenSea platform or your personal wallet',
      blockShortText: 'Display an NFT',
    },
    wallet: {
      wallet: 'Wallet',
      blockTitle: 'Bank/Crypto Wallet',
      blockText: 'Display your Credit Card or Bitcoin wallet to make it easier for your users to copy it to transfer funds',
      blockShortText: 'Display your wallets',
      title: 'Title',
      titleTooltip: 'Title of your wallet',
      walletNumber: 'Wallet number',
      walletNumberTooltip: 'Paste your wallet number',
      icon: 'Icon',
      iconTooltip: 'Set icon for your wallet',
      card: 'Card',
      bank: 'Bank',
      crypto: 'Crypto',
      transfer: 'Transfer',
      paymentLink: 'Payment link',
      cardNumber: 'Card number',
      cardNumberTooltip: 'Paste your card number',
      cardHolder: 'Card holder',
      cardHolderTooltip: 'Enter your card holder',
      bankAccountDetails: 'Bank account details',
      bankAccountDetailsTooltip: 'Enter your bank account details',
      walletAddress: 'Wallet address',
      walletAddressTooltip: 'Enter your wallet address',
      network: 'Network',
      networkTooltip: 'Enter your network',
      publicKey: 'Public key',
      publicKeyTooltip: 'Enter your public key',
      providerName: 'Provider name',
      providerNameTooltip: 'Enter your provider name',
      link: 'Link',
      linkTooltip: 'Enter your link',
      serviceName: 'Service name',
      serviceNameTooltip: 'Enter your service name',
      email: 'Email',
      emailTooltip: 'Enter your email',
      phone: 'Phone',
      phoneTooltip: 'Enter your phone',
      username: 'Username',
      usernameTooltip: 'Enter your username',
      fullName: 'Full name',
      fullNameTooltip: 'Enter your full name',
      referenceNumber: 'Reference number',
      referenceNumberTooltip: 'Enter your reference number',
      country: 'Country',
      countryTooltip: 'Enter your country',
      transferProvider: 'Transfer provider',
      transferProviderTooltip: 'Enter your transfer provider',
      cryptoCurrency: 'Crypto Currency',
      cryptoCurrencyTooltip: 'Enter your crypto currency',
    },
    instagram: {
      blockTitle: 'Instagram',
      blockText: 'Feature your best Instagram media and video or sell your products with a shoppable Instagram feed',
      blockShortText: 'Your best Instagram media',
      blockConnectTitle: `Instagram isn't connected`,
      blockConnectText: `It seems like your Instagram products aren't imported yet. Connect your account now`,
      blockConnectButton: 'Add Instagram',
      emptyList: 'You have no Instagram media yet.',
      addInstagramUsername: 'Add instagram username',
      username: 'Username',
      downloadTakes: 'Download takes up to 2 minutes',
      displayPost: 'Display post on your website',
      view: 'View',
      redirect: 'URL Redirect',
      text: 'Text & Button',
      actionType: 'Action type',
      url: 'URL',
      openInNewTab: 'Open in new tab',
      delete: 'Delete',
      cancel: 'Cancel',
      save: 'Save',
      editMedia: 'Edit Media',
      title: 'Title',
      automation: 'Automation',
      automationText: 'Automate your account with Autopilot features',
      autopilot: 'Autopilot',
      autopilotTooltip: 'Upload a post with the sample caption and your product tags/ links will be automatically generated',
      switchTitle: 'Automatically detect title, price, links',
      sampleCaption: 'Sample caption: #49.99 #NiceDress https://google.com',
      integrations: 'Integrations',
      integrationsText: 'Add Instagram to your website',
      connectInstagram: 'Connect Instagram',
      connectInstagramText: 'Connect your Instagram account to display your choice of posts or reels.',
      selectAccount: 'Select account',
      connectNewInstagram: 'Connect a new Instagram account',
      continue: 'Continue',
      disconnectInstagram: 'Disconnect Instagram',
      addTag: 'Add tag',
      tagClickHint: 'Click on the image to place the tag',
      tagPositionSet: 'Position set. Fill in the details below.',
      tagTypeLink: 'Link',
      tagTypeProduct: 'Product',
      tagLabel: 'Label',
      tagSelectProduct: 'Select product',
    },
    tiktok: {
      blockTitle: 'TikTok',
      blockText: 'Feature your best TikTok video or sell your products with a shoppable TikTok feed',
      blockShortText: 'Your best TikTok video',
      addTikTok: 'Add TikTok account',
      individualVideo: 'Individual video',
      videoCollection: 'Video collection',
      add: 'Add',
      blockConnectTitle: `TikTok isn't connected`,
      blockConnectText: `It seems like your TikTok products aren't imported yet. Connect your account now`,
      blockConnectButton: 'Connect TikTok',
      enterUsername: 'Enter username',
      enterVideo: 'Enter a TikTok video URL',
      emptyList: 'You have no TikTok media yet.',
      editMedia: 'Edit Media',
      addTikTokVideo: 'Add TikTok video',
      displayPost: 'Display post on your website',
      delete: 'Delete',
      cancel: 'Cancel',
      save: 'Save',
      integrations: 'Integrations',
      integrationsText: 'Add TikTok to your website',
      connectTikTok: 'Connect TikTok',
      disconnectTikTok: 'Disconnect TikTok',
      individualText: `You can't connect TitTok account to this type of block ('individual').`,
      individualText2: 'Please, add single TikTok video instead.',
    },
    youtube: {
      blockTitle: 'YouTube',
      blockText: 'Feature a YouTube video or stream on your page. Tag products on YouTube video',
      blockShortText: 'Feature a YouTube video',
      enterYouTubeLink: 'Enter YouTube URL',
      enterYouTubeLinkTooltip: 'Paste YouTube URL',
    },
    overview: {
      blockTitle: 'Overview',
      blockText: 'Show whether you are open right now, your hours, address and key facts',
      blockShortText: 'Hours, address and status',
      templates: {
        rows: 'Info rows',
        rowsCaption: 'Your own rows — hours, address, phone, site — as tappable lines',
        status: 'Status now',
        statusCaption: 'Open or closed in large type, with a route button',
        week: 'Week hours',
        weekCaption: 'The whole week, today highlighted',
        actions: 'Status and actions',
        actionsCaption: 'Your name and state, with a scrolling row of buttons',
        rating: 'Rating header',
        ratingCaption: 'Cover photo, rating and state — the place at a glance',
        about: 'About and status',
        aboutCaption: 'A paragraph about the place, with hours and address under it',
        popular: 'Popular times',
        popularCaption: 'A busy-hours chart you fill in yourself',
        facts: 'Facts grid',
        factsCaption: 'Four short facts — booking, payment, parking — in a grid',
        now: 'Dark now card',
        nowCaption: 'A dark card leading with how much of today is left',
        map: 'With map',
        mapCaption: 'A map picture over the address, with copy and route buttons',
        locations: 'Two locations',
        locationsCaption: 'Two places behind a switch, each with its own hours',
        strip: 'Compact strip',
        stripCaption: 'One-line rows for under a hero or above a form',

        // Content tab
        general: 'General',
        blockTitle: 'Title',
        blockTitleCaption: 'Heading shown above the rows',
        blockNote: 'Note',
        blockNoteCaption: 'Small print under the rows',

        schedule: 'Opening hours',
        mode_hours: 'By hours',
        mode_always: 'Open 24 hours',
        mode_appointment: 'By appointment',
        mode_temporarily: 'Temporarily closed',
        mode_permanently: 'Permanently closed',
        closedDay: 'Closed',
        scheduleNote: 'Note about the hours',
        scheduleNoteCaption: 'Holidays, last orders — shown under the week',
        statusNote: 'Details',
        statusNoteCaption: 'Shown beside the status, e.g. "Back on 3 September"',

        business: 'Business',
        businessName: 'Name',
        businessNameCaption: 'The name shown on the card',
        businessCategory: 'Category',
        businessCategoryCaption: 'What kind of place this is, e.g. "Coffee bar"',
        businessCover: 'Cover photo',
        businessCoverCaption: 'Image URL shown at the top of the card',

        ratingSection: 'Rating',
        ratingHint: 'Your own number — nothing is calculated from UniLink data.',
        ratingValue: 'Rating',
        ratingValueCaption: 'From 0 to 5, e.g. 4.6',
        ratingCount: 'Reviews',
        ratingCountCaption: 'How many reviews the rating is based on',

        aboutSection: 'About',
        aboutTitle: 'Title',
        aboutTitleCaption: 'Heading above the paragraph',
        aboutText: 'Text',
        aboutTextCaption: 'A few sentences about the place',
        aboutButton: 'Button text',
        aboutButtonCaption: 'Leave empty to hide the button',
        aboutButtonUrl: 'Button link',
        aboutButtonUrlCaption: 'Where the button goes',

        nowSection: 'Now card',
        nowEyebrow: 'Small label',
        nowEyebrowCaption: 'Above the headline, e.g. "Open right now"',
        nowHeadline: 'Headline',
        nowHeadlineCaption: 'The large line, e.g. "Four more hours today"',
        nowText: 'Text',
        nowTextCaption: 'A sentence under the headline',
        nowBackground: 'Background colour',
        nowBackgroundCaption: 'Hex colour of the dark card, e.g. #14161A',

        popularSection: 'Popular times',
        popularHint: 'Your own estimate per hour, 0–100. Empty hours are not drawn.',
        popularTitle: 'Title',
        popularTitleCaption: 'Heading above the chart',
        popularLive: 'Live line',
        popularLiveCaption: 'Shown on today only, e.g. "Live · 15:00"',
        popularLiveNote: 'Live note',
        popularLiveNoteCaption: 'e.g. "Busier than usual, about a 10 minute wait"',

        factsSection: 'Facts',
        factLabel: 'Label',
        factValue: 'Value',
        addFact: 'Add fact',

        actionsSection: 'Buttons',
        actionsHint: 'The first button is filled, the rest are quiet. Empty links are hidden.',
        actionText: 'Text',
        actionValue: 'Link, phone or email',
        addAction: 'Add button',

        locationsSection: 'Locations',
        locationsHint: 'Two locations fit the switch. Each keeps its own hours.',
        location: 'Location',
        locationName: 'Name',
        locationAddress: 'Address',
        locationPhone: 'Phone',
        locationHours: 'Hours summary',

        stripSection: 'Strips',
        stripActionText: 'Link text on the status strip',
        stripActionTextCaption: 'Leave empty to hide the link',
        stripActionUrl: 'Link on the status strip',
        stripActionUrlCaption: 'Where that link goes',
        stripText: 'Text',
        stripLinkText: 'Link text',
        stripLinkUrl: 'Link',
        addStrip: 'Add strip',

        place: 'Place',
        placeAddress: 'Address',
        placeAddressCaption: 'Used for the route button when no link is set',
        placeNote: 'Address note',
        placeNoteCaption: 'e.g. "Courtyard entrance, second door"',
        placePhone: 'Phone',
        placePhoneCaption: 'Shown as a call button',
        placeMapUrl: 'Route link',
        placeMapUrlCaption: 'Leave empty to search the address on Google Maps',
        placeMapImage: 'Map picture',
        placeMapImageCaption: 'Image URL shown above the address',
        placeDirections: 'Route button text',
        placeDirectionsCaption: 'Leave empty for "Directions"',
        placeToday: "Today's hours",
        placeTodayCaption: 'The small line under the status, e.g. "Wednesday, 10:00 – 19:00"',
        placeTimezone: 'Timezone note',
        placeTimezoneCaption: 'e.g. "All times in Kyiv time, GMT+3"',

        remove: 'Remove',
        save: 'Save',
        addRow: 'Add row',
        editRow: 'Edit row',
        rowIcon: 'Icon',
        rowTitle: 'Title',
        rowSubtitle: 'Subtitle',
        rowLink: 'Link (optional)',

        scheduleTimezone: 'Timezone',
        scheduleTimezoneCaption: 'The timezone the hours above are written in. Visitors abroad see the status on this clock, not theirs.',
        scheduleTimezoneAuto: "Visitor's own timezone",

        factsButtonText: 'Button text',
        factsButtonTextCaption: 'Leave empty to hide the button',
        factsButtonUrl: 'Button link',
        factsButtonUrlCaption: 'Where the button goes',

        actionType_link: 'Link',
        actionType_phone: 'Phone',
        actionType_email: 'Email',
      },
      defaults: {
        aboutTitle: 'About us',
        busyHours: 'Busy hours',
        directions: 'Directions',
        factToday: 'Today',
        factBooking: 'Booking',
        factPayment: 'Payment',
        factParking: 'Parking',
        factsButton: 'Plan a visit',
      },
    },
    video: {
      blockTitle: 'Video',
      blockText: 'Feature a video or stream on your page',
      blockShortText: 'Feature a video',
      templates: {
        single: 'Single player',
        singleCaption: 'The video, full width, and nothing else but its length',
        titled: 'Player with title',
        titledCaption: 'The video with a headline and one line under it',
        list: 'Video list',
        listCaption: 'Cover on the left, title on the right — built to be read',
        grid: 'Grid of videos',
        gridCaption: 'A wall of covers, two or three across',
        playlist: 'Playlist',
        playlistCaption: 'One player with the rest of the videos queued under it',
        chapters: 'With chapters',
        chaptersCaption: 'One long video, split into timecodes people can jump to',
        cta: 'Video with a button',
        ctaCaption: 'A video that exists to get one thing clicked',
        locked: 'Locked video',
        lockedCaption: 'A cover, a note and a button out to where the video is sold or gated',
        testimonial: 'Testimonial',
        testimonialCaption: 'A customer on video, with the line worth reading first',
        live: 'Live or upcoming',
        liveCaption: 'A stream running now, or announced with a countdown',
        lesson: 'Lesson with progress',
        lessonCaption: 'A course: the current lesson and the rest of the syllabus',
        transcript: 'With transcript',
        transcriptCaption: 'What was said, written out — tap a line to jump there',
        hero: 'Hero with overlay text',
        heroCaption: 'One video, tall, with the headline written over it',
      },
      settings: {
        layout: 'Layout',
        single: 'Single',
        list: 'List',
        grid: 'Grid',
        carousel: 'Carousel',
        cardSize: 'Card size',
        sizeS: 'S',
        sizeM: 'M',
        sizeL: 'L',
        show: 'Show',
        fieldTitle: 'Title',
        fieldDescription: 'Description',
        fieldDuration: 'Duration',
      },
      tooltips: {
        layout: 'How the videos are arranged. The same videos either way — only the shape changes.',
        cardSize: 'How wide a card is: three across, two across, or one at full width.',
        show: 'What is printed beside each video. Duration is read from the file, so it only appears on uploaded videos.',
      },
      fields: {
        title: 'Title',
        titleCaption: 'Leave empty to use the video’s own title',
        text: 'Description',
        textCaption: 'One line under the title',
        itemTitle: 'Title',
        itemTitleCaption: 'Printed beside the video — in the list, the playlist queue and the lesson syllabus',
        itemCaption: 'Description',
        itemCaptionCaption: 'One line under the title, shown when Description is on',
        buttonText: 'Button text',
        buttonTextCaption: 'The button is hidden until it has both a label and a link',
        buttonLink: 'Button link',
        buttonLinkCaption: 'Where the button goes',
        chapters: 'Chapters',
        chaptersCaption: 'A timecode and what happens at it. Tapping a chapter starts the video there.',
        chapterTitle: 'What happens here',
        addChapter: 'Add chapter',
        cta: 'Call to action',
        locked: 'Locked video',
        lockedBadge: 'Badge over the cover',
        lockedBadgeCaption: 'What the lock says — “Members only”, “Paid”',
        lockedNote: 'Note under the title',
        lockedNoteCaption: 'What the visitor gets and what it costs',
        testimonial: 'Testimonial',
        quote: 'Quote',
        quoteCaption: 'The sentence worth reading before pressing play',
        authorName: 'Name',
        authorNameCaption: 'Who said it',
        authorRole: 'Company or role',
        authorRoleCaption: 'Shown under the name',
        authorPhoto: 'Photo',
        authorPhotoCaption: 'Optional — a small round photo next to the name',
        live: 'Live',
        liveState: 'State',
        liveStateCaption: 'Streaming now, or announced with a countdown to the start',
        liveNow: 'Live now',
        liveUpcoming: 'Upcoming',
        liveLabel: 'Pill text',
        liveLabelCaption: 'The badge in the corner — “LIVE”, “Upcoming”',
        watching: 'Watching now',
        watchingCaption: 'Optional — shown in the corner, e.g. “312 watching”',
        startsAt: 'Starts at',
        startsAtCaption: 'The countdown runs to this moment and disappears once it passes',
        lesson: 'Lesson',
        currentLesson: 'Current lesson',
        currentLessonCaption: 'Which lesson the block opens on',
        lessonEmpty: 'Add videos first — the lessons are the block’s videos.',
        transcript: 'Transcript',
        transcriptLabel: 'Heading',
        transcriptLabelCaption: 'The word above the text — “Transcript”',
        transcriptRows: 'Lines',
        transcriptRowsCaption: 'A timecode and what was said at it. Tapping a line starts the video there.',
        transcriptText: 'What was said',
        addTranscriptRow: 'Add line',
        hero: 'Overlay text',
        eyebrow: 'Label above the headline',
        eyebrowCaption: 'A short word or two — “Studio tour”',
      },
      defaults: {
        ctaButton: 'Book a call',
        lockedBadge: 'Members only',
        lockedButton: 'Unlock',
        liveButton: 'Join the stream',
        transcriptButton: 'Read full transcript',
      },
    },
    short: {
      blockTitle: 'Shorts / Reels',
      blockText: 'Add vertical short-form videos — Shorts, Reels, TikToks',
      blockShortText: 'Add vertical videos',
      templates: {
        single: 'Single reel',
        singleCaption: 'Each clip full width, playing where it stands, with its caption over it',
        row: 'Reel row',
        rowCaption: 'The clips on a sideways swipe, each with its length',
        grid: 'Grid of clips',
        gridCaption: 'Three across — the wall a whole run of shorts reads as',
        actions: 'Reel with actions',
        actionsCaption: 'The reel as the apps draw it: your handle, the caption, controls down the side',
        cover: 'Cover with caption',
        coverCaption: 'A tall cover with the title and a line of context under it — built to be read',
        shop: 'Shoppable reel',
        shopCaption: 'The reel with the thing in it for sale, on a card along the bottom',
        tabs: 'Feed with tabs',
        tabsCaption: 'A filter over the clips, for a profile that posts more than one kind of thing',
        duet: 'Duet pair',
        duetCaption: 'Clips read two at a time: a question and its answer, a before and an after',
        series: 'Series progress',
        seriesCaption: 'A run watched in order, with where the visitor left off and a button back in',
      },
      fields: {
        urlCaption: 'Paste the URL of the video, or upload a file above',
        title: 'Title',
        titleCaption: 'Printed over the clip, and in the full-screen player',
        caption: 'Description',
        captionCaption: 'One line under the title',
        category: 'Tab',
        categoryCaption: 'Which tab this clip belongs to. The tabs are read off the clips, so a new name makes a new tab',
        label: 'Pill',
        labelCaption: 'This clip’s own pill, instead of the pair’s. Leave empty to use the pair’s',
        linkUrl: 'Link',
        linkUrlCaption: 'Where the link button in the action rail goes. Leave empty and it is not drawn',
        linkText: 'Link label',
        linkTextCaption: 'What the link button says to a screen reader',
        productImage: 'Product image',
        productImageCaption: 'The picture on the card over the clip',
        productTitle: 'Product',
        productTitleCaption: 'What is for sale in this clip',
        productPrice: 'Price',
        productPriceCaption: 'Shown after your currency symbol',
        productUrl: 'Product link',
        productUrlCaption: 'Where the button goes. Leave empty and the card shows no button',
        productButton: 'Button',
        productButtonCaption: 'Leave empty for “Buy”',
        duetLeft: 'Left pill',
        duetLeftCaption: 'What the first clip of every pair is. Leave empty for “Asked”',
        duetRight: 'Right pill',
        duetRightCaption: 'What the second clip of every pair is. Leave empty for “Answered”',
        seriesTitle: 'Series title',
        seriesTitleCaption: 'The name of the run — the clips are its episodes',
        seriesButton: 'Button',
        seriesButtonCaption: 'Leave empty for “Resume”',
        tabsAll: 'First tab',
        tabsAllCaption: 'The tab that shows every clip. Leave empty for “All”',
      },
    },
    twitter: {
      blockTitle: 'X (Twitter)',
      blockText: 'Display your Tweets on your UniLink page to grow engagement',
      blockShortText: 'Display your Tweets',
      twitterURL: 'Twitter URL',
      twitterURLTooltip: 'Add URL from Twitter for generate embedded code',
      enterTwitterURL: 'Enter a Twitter URL',
    },
    music: {
      templates: {
        nowPlaying: 'Player',
        nowPlayingCaption: 'A dark card with the cover, a progress bar and transport controls — it walks the block’s tracks',
        compact: 'Compact player',
        compactCaption: 'The same player at a third of the height, for a song that is not the main event',
        tracklist: 'Track list',
        tracklistCaption: 'Numbered rows with the length and a play button — what a record’s back cover says',
        queue: 'Playing queue',
        queueCaption: 'What is playing, then what is next: a small album player with its queue',
        featured: 'Featured track',
        featuredCaption: 'The cover full size, the title over it, one play button',
        waveform: 'Waveform',
        waveformCaption: 'One recording drawn as a waveform that fills as it plays — for a demo or a rough mix',
        mix: 'DJ mix',
        mixCaption: 'A full-bleed photo, the length of the set, and its tracklist behind a button',
        release: 'Release with links',
        releaseCaption: 'The cover, the title and one row per streaming service — the smart-link card',
        streaming: 'Streaming links',
        streamingCaption: 'Just the services, with no cover: sends a visitor to the platform they already use',
        presave: 'Pre-save',
        presaveCaption: 'A record that is not out yet, and the taps that put it in a library on release day',
        shelf: 'Album shelf',
        shelfCaption: 'Every release as a cover, scrolling sideways. Tapping one opens its links',
        playlistCard: 'Playlist card',
        playlistCardCaption: 'A mosaic of what is in the playlist, how long it is, and one button to hear it',
        record: 'Buy the record',
        recordCaption: 'The sleeve, the price, and two buttons — buy it, or hear it first',
        classic: 'Tabs',
        classicCaption: 'The original block: Tracks, Playlists and Releases as tabs with the usual player cards',
        showcase: 'Showcase',
        showcaseCaption: 'The editorial view — large release cards with a rail of the rest underneath',
      },
      blockTitle: 'Music',
      blockText: 'Embed Spotify, SoundCloud song, playlist or upload your own audio file',
      blockShortText: 'Add your music',
      brand: 'Brand',
      brandTooltip: 'Choose type for adding your music',
      url: 'URL',
      embed: 'Embed code',
      custom: 'Custom',
      musicUrl: 'Music URL',
      musicUrlTooltip: 'Enter music URL',
      embedCodeTitle: 'Embed code',
      embedCodeTooltip: 'Paste embed code of your song from chosen music platform',
      audioFile: 'Audio file',
      uploadAudios: 'You can only upload audio here',
      title: 'Title',
      titleTooltip: 'Enter title of your music',
      artist: 'Artist',
      artistTooltip: 'Enter artist of your music',
      audioFileTitle: 'Audio file',
      audioFileTooltip: 'Name of your audio file',
      coverImage: 'Cover image',
      coverImageTooltip: 'Upload image for your music',
    },
    twitch: {
      blockTitle: 'Twitch',
      blockText: 'Embed Twitch video or stream on your page',
      blockShortText: 'Embed Twitch video',
      twitchURL: 'Twitch URL',
      twitchURLTooltip: 'Paste channel url or channel name',
      twitchTV: 'twitch.tv/...',
      displayTwitch: 'Display my Twitch channel',
      displayChat: 'Display both my Twitch channel and chat',
    },
    splash: {
      blockTitle: 'Pop-up',
      blockText: 'Full screen banner with text and button appears before site loading to promote any product or event',
      blockShortText: 'Full screen banner',
    },
    pageList: {
      templates: {
        classic: 'Simple list',
        classicCaption: 'The original block — one page per row with an arrow. Best for up to five pages',
        described: 'List with descriptions',
        describedCaption: 'Numbered rows, each page with a line explaining where it leads',
        icons: 'Icon grid',
        iconsCaption: 'Two columns of tiles with an icon above the name. Best for six pages or more',
        covers: 'Cards with covers',
        coversCaption: 'A picture beside every page — for sections worth showing, not just naming',
        groups: 'Grouped sections',
        groupsCaption: 'A sitemap: pages under the group labels you set on them',
        headline: 'Large rows',
        headlineCaption: 'Oversized rows on a filled panel, for four or five loud destinations',
        tiles: 'Photo tiles',
        tilesCaption: 'Photo tiles two to a row; a lone last tile runs the full width',
        tags: 'Tags',
        tagsCaption: 'Every page as a pill. The compact choice when there are ten or more',
        prevNext: 'Previous and next',
        prevNextCaption: 'The two pages either side of this one, for the foot of a long page',
      },
      items: {
        image: 'Cover',
        imageUpload: 'Upload',
        imageUploading: 'Uploading…',
        noImageHint: 'This layout shows a picture per page — until one is set the row falls back to its icon.',
        icon: 'Icon',
        group: 'Group',
        groupPlaceholder: 'About the studio',
        groupHint: 'Rows sharing a label are drawn under it; rows without one come last.',
      },
    },
    promo: {
      blockTitle: 'Promo bar',
      blockText: 'Highlight that lets you appear promotions',
      blockShortText: 'Highlight your promotions',
    },
    welcome: {
      blockTitle: 'Welcome message',
      blockText: 'Write welcome messages that prompt visitors to start chatting. It pops up on the bottom of the page to welcome visitors and offer assistance',
      blockShortText: 'Write welcome messages',
    },
    review: {
      blockTitle: 'Reviews',
      blockText: 'Reviews help customers to learn more about the product and decide whether it is the right product for them',
      blockShortText: 'Reviews help customers',
      name: 'Name',
      nameTooltip: 'Enter reviewer name',
      comment: 'Comment',
      commentTooltip: 'Enter reviewer comment',
      date: 'Date',
      dateTooltip: 'Enter reviewer date',
      rate: 'Rage',
      rateTooltip: 'Set review rate',
      image: 'Image',
      imageTooltip: 'Upload reviewer image',
    },
    coupon: {
      blockTitle: 'Coupons',
      blockText: 'An online coupon refers to a discount code or number that can be redeemed on a website',
      blockShortText: 'Online coupon refers',
    },
    timer: {
      blockTitle: 'Countdown',
      blockText: 'A countdown timer is a virtual clock on a page that counts down from a certain number or date to indicate the beginning or end of an event or offer',
      blockShortText: 'A countdown timer',
    },
    outfit: {
      blockTitle: 'Outfits',
      blockText: 'Create your own product list',
      blockShortText: 'Create product list',
    },
    spacer: {
      blockTitle: 'Spacer',
      blockText: 'Add some empty vertical space to your page',
      blockShortText: 'Add some empty',
    },
    html: {
      blockTitle: 'Embed',
      blockText: 'You can paste your own HTML code to UniLink page. HTML is a standard markup language for web page creation. It allows iframes, sections, paragraphs, and links.',
      blockShortText: 'Paste your own HTML',
      markupCode: 'Markup code',
      markupCodeTooltip: 'Paste markup code of your HTML',
      strippedWarning: 'Removed for security when displayed:',
    },
    unlock: {
      blockTitle: 'Unlock',
      blockText: 'You can add your unlock content to UniLink page.',
      blockShortText: 'Paste your unlikable file',
    },
    file: {
      blockTitle: 'File',
      blockText: 'This block allows you to upload and share files such as documents, images, or audio. Visitors can easily view or download them directly from your page.',
      blockShortText: 'Upload and share your files.',
      addNewItem: 'Add new file',
      editFile: 'Edit FIle',
      fileName: 'Enter the file name',
      fileDescription: 'File description (optional)',
      coverImage: 'Cover image (optional)',
      templates: {
        classic: 'Classic list',
        classicCaption: 'The original block — a row per file with its icon, weight and access badge',
        list: 'File list',
        listCaption: 'Rows with the format on a plate and a download button on the right',
        single: 'Single download',
        singleCaption: 'One card, one big button. For the block that publishes a single thing',
        cover: 'Cover preview',
        coverCaption: 'The first page as a picture, with the blurb and the button under it',
        folders: 'Folders',
        foldersCaption: 'Files grouped by kind, each folder showing how many and how heavy',
        formats: 'Formats',
        formatsCaption: 'One asset in every format it ships in, as chips people tap',
        versions: 'Versions',
        versionsCaption: 'The current file framed on top, older ones still reachable below',
        gate: 'Email for file',
        gateCaption: 'The download opens after a visitor leaves an email address',
        transfer: 'Big transfer',
        transferCaption: 'A dark card for a heavy handover, with a warning for large files',
      },
    },
    stat: {
      templates: {
        grid: 'Four figures',
        gridCaption: 'Two per row, each with a caption saying what it counts',
        hero: 'One big number',
        heroCaption: 'A single figure filling the block, on the page ink',
        row: 'Row of three',
        rowCaption: 'Three short figures on one line, separated by hairlines',
        change: 'With change',
        changeCaption: 'A figure with how it moved, from each stat’s extra field',
        bars: 'Bar chart',
        barsCaption: 'One column per stat, the tallest in your accent colour',
        progress: 'Progress bars',
        progressCaption: 'A breakdown as filled bars — name, figure, bar',
        photo: 'With photo',
        photoCaption: 'The block’s heading picture over a row of figures',
        live: 'Live counter',
        liveCaption: 'One figure with a pulsing dot beside it',
        source: 'Source note',
        sourceCaption: 'Two figures and a line saying where they came from',
        trend: 'Trend',
        trendCaption: 'The stats as a line over time, newest number on top',
        share: 'Share',
        shareCaption: 'How a whole splits, as a ring with a legend',
        ranked: 'Ranked list',
        rankedCaption: 'A numbered top five with a bar under each row',
        feed: 'Feed',
        feedCaption: 'The original block — stat tiles that wrap into rows',
        slider: 'Slider',
        sliderCaption: 'The same tiles on a rail the visitor swipes',
      },
      blockTitle: 'Statistics',
      blockText:
        'This block allows you to display key insights about your page, such as views, visitors, or engagement. It helps you monitor your audience and understand how your page performs.',
      blockShortText: 'Add statistics to your page.',
      addNewItem: 'Add new statistic',
      editItem: 'Edit statistic',
      statName: 'Enter the statistic name',
      statValue: 'Enter the statistic value',
      statDescription: 'Enter the statistic description',
      statProgress: 'Progress bar, % (optional)',
      statLabel: 'Change or source note',
      statLabelTooltip: 'The pill beside the figure in “With change” and “Trend” (“+18%”, “−1.1”), or the line under the figures in “Source note”',
      matchScreenshot: 'Match a screenshot',
      matchScreenshotRunning: 'Reading the design…',
      matchScreenshotSkipped: 'Tile colour and font were left as they are',
      compose: 'Design it',
      composePlaceholder: 'Describe the look — “light and modern”, “bolder”',
      composeHint: 'The palette supplies the colour; text contrast is handled for you',
      composeDone: 'Design updated',
      review: 'Review',
      reviewClean: 'Reviewed — nothing to fix',
      reviewFixed: 'Reviewed and corrected',
      statItemFields: 'Select fields to display.',
      columns: 'Columns',
      subtitleColumns: 'How many stats sit in one row',
      feed: 'Feed',
      slider: 'Slider',
      titleSize: 'Title size',
      subtitleTitleSize: 'You can change title size',
    },
    listing: {
      blockTitle: 'Listing',
      blockText: 'Display property or item listings with images, details, and pricing.',
      blockShortText: 'Add listings to your page.',
    },
    rental: {
      blockTitle: 'Rental',
      blockText: 'List rental properties or items with availability and pricing per period.',
      blockShortText: 'Add rentals to your page.',
    },
    'single-product': {
      blockTitle: 'Single Product',
      blockText: 'Feature a single product with image, description, and buy button.',
      blockShortText: 'Feature a product.',
    },
    team: {
      templates: {
        grid: 'Grid',
        gridCaption: 'Square photos, two per row — the classic arrangement',
        person: 'One person',
        personCaption: 'A portrait, a bio and a contact button — for a studio of one',
        founders: 'Two founders',
        foundersCaption: 'Two people side by side, photo beside the text',
        three: 'A few people',
        threeCaption: 'Rows with a round photo and a line of bio each',
        compact: 'Compact list',
        compactCaption: 'Names and roles only, one per row with a hairline between',
        strip: 'Scrollable strip',
        stripCaption: 'A horizontal rail — keeps the block one screen tall',
        departments: 'By department',
        departmentsCaption: 'People grouped under headings you name',
        hiring: 'We are hiring',
        hiringCaption: 'Your open roles first, the team under them',

        intro: 'Intro',
        title: 'Title',
        titleCaption: 'Heading above the people',
        introText: 'Intro text',
        introTextCaption: 'A line under the heading',
        cta: 'Button',
        ctaText: 'Button text',
        ctaTextCaption: 'Leave empty for "Get in touch"',
        ctaUrl: 'Button link',
        ctaUrlCaption: 'Leave empty to use the person\u2019s own link or email',
        departmentsTitle: 'Departments',
        departmentsHint: 'Name a group, then pick who belongs to it. Anyone you do not file still shows, at the end.',
        departmentName: 'Department name',
        addDepartment: 'Add department',
        hiringTitle: 'Hiring',
        hiringHeading: 'Heading',
        hiringHeadingCaption: 'The line above your open roles',
        hiringText: 'Text',
        showBio: 'Show bio',
        hiringTextCaption: 'A sentence about working with you',
        roleTitle: 'Role',
        roleMeta: 'Details',
        roleMetaCaption: 'e.g. "Kyiv · full time"',
        roleUrl: 'Link',
        addRole: 'Add role',
        remove: 'Remove',
      },
      defaults: {
        getInTouch: 'Get in touch',
      },
      blockTitle: 'Team',
      blockText: 'Introduce your team members with photos, names, roles, and social links.',
      blockShortText: 'Show your team.',
    },
    timetable: {
      blockTitle: 'Timetable',
      blockText: 'Display a weekly schedule with classes, events, or sessions.',
      blockShortText: 'Add a weekly schedule.',
    },
  },
  // Runtime wording for the Overview block's twelve templates — the same namespace previewUI
  // serves on the public page. `{time}`, `{minutes}` and `{day}` are filled by getStatusText.
  overview: {
    open: 'Open',
    closed: 'Closed',
    closingSoon: 'Closing soon',
    openingSoon: 'Opens soon',
    open24: 'Open 24 hours',
    open24Detail: 'Every day, all day',
    byAppointment: 'By appointment',
    byAppointmentDetail: 'Book a slot to visit',
    temporarilyClosed: 'Temporarily closed',
    permanentlyClosed: 'Permanently closed',
    permanentlyClosedDetail: 'This place has shut down',
    hoursUnknown: 'Hours not listed',
    hoursUnknownDetail: 'Call ahead to check',

    closesAt: 'Closes {time}',
    closesInMinutes: 'Closes in {minutes} min',
    opensAt: 'Opens {time}',
    opensInMinutes: 'Opens in {minutes} min · {time}',
    opensTomorrow: 'Opens {time} tomorrow',
    opensOnDay: 'Opens {day} {time}',
    until: 'Until',
    tomorrow: 'Tomorrow',

    directions: 'Directions',
    getDirections: 'Get directions',
    call: 'Call',
    copyAddress: 'Copy address',
    otherLocation: 'Other location',
    busyHours: 'Busy hours',
    popularEmpty: 'No busy hours added yet',

    mon: 'Monday',
    tue: 'Tuesday',
    wed: 'Wednesday',
    thu: 'Thursday',
    fri: 'Friday',
    sat: 'Saturday',
    sun: 'Sunday',
  },
  themeTokens: {
    title: 'Theme style',
    subtitle: 'Typography, corners and spacing',
    typography: 'Typography',
    corners: 'Corners',
    density: 'Density',
    shadow: 'Shadow',
  },
  customFont: {
    title: 'Your own font',
    upload: 'Upload a font file',
    uploading: 'Uploading…',
    uploaded: 'Font uploaded',
    remove: 'Remove',
    namePlaceholder: 'Font name',
    previewText: 'The quick brown fox',
    pickHint: 'Pick it above for any role — it now appears at the top of the list.',
    hint: '.woff2, .woff, .ttf or .otf — up to 2 MB. Make sure you have a licence to use it on the web.',
    proHint: 'Upgrade to Pro to use your own font.',
    invalidType: 'Use a .woff2, .woff, .ttf or .otf file',
    tooLarge: 'Font file must be under 2 MB',
    uploadFailed: 'Upload failed',
  },
  customCss: {
    title: 'Custom CSS',
    subtitle: 'Style your page with your own CSS',
    hint: 'Your CSS applies to your public page. Selectors are scoped to the page, so nothing here affects the editor.',
    stripped: '@import is removed for security. Use the HTML block for scripts.',
    characters: 'characters',
  },
  headingDesign: {
    colors: 'Colours',
    title: 'Heading',
    subtitle: 'Inherits the block text colour',
    hint: 'Leave a colour untouched and it follows the block’s text colour. Set one and it applies to that part only.',
    titleColor: 'Title',
    descriptionColor: 'Description',
    inherited: 'inherited',
    reset: 'Reset',
    custom: 'custom',
  },
  advancedDesign: {
    inherited: 'inherited',
    reset: 'Reset',
    changed: 'changed',
    title: 'Advanced',
    subtitle: 'Fine-tune each part',
    whichPart: 'Which part',
    whichPartCaption: 'Choose which part of the block the settings below apply to',
    slot_title: 'Title',
    slot_description: 'Description',
    slot_label: 'Eyebrow label',
    fontSize: 'Font size',
    fontSizeCaption: 'Size of the text in this part',
    letterSpacing: 'Letter spacing',
    letterSpacingCaption: 'Space between letters',
    fontWeight: 'Weight',
    fontWeightCaption: 'How bold the text is',
    textTransform: 'Case',
    textTransformCaption: 'Normal, all caps or capitalised',
    fontStyle: 'Style',
    fontStyleCaption: 'Upright or italic',
    lineHeight: 'Line height',
    lineHeightCaption: 'Space between lines of text',
    textAlign: 'Align',
    textAlignCaption: 'Which edge the text lines up with',
    color: 'Color',
    colorCaption: 'Overrides the colour this part inherits from the block',
  },
  layoutPicker: {
    title: 'Layout',
    tooltip: 'Choose how items are arranged',
    layout_list: 'List',
    layout_grid: 'Grid',
    layout_cards: 'Cards',
  },
  importDesign: {
    title: 'Import design',
    subtitle: 'Recreate a design from a screenshot',
    upload: 'Upload a screenshot',
    extracting: 'Analyzing…',
    apply: 'Apply to page',
    applying: 'Applying…',
    blocksCount: '+{n} blocks',
    applied: 'Design applied — {n} blocks added',
    refine: 'Refine',
    refining: 'Refining…',
  },
  storyEditor: {
    back: 'Back',
    general: 'General',
    text: 'Text',
    cta: 'CTA',
    media: 'Media',
    items: 'Items',
    addOns: 'Add-ons',
    stickers: 'Stickers',
    layers: 'Layers',

    save: 'Save',
    delete: 'Delete',
    addText: 'Add Text',
    addCta: 'Click me',
    unsavedChanges: 'Unsaved changes',
    leaveConfirm: 'Leave without saving? Your changes will be lost.',

    title: 'Title',
    enterTitle: 'Enter title',
    duration: 'Duration',
    durationHint: 'How long this story stays on screen',
    kenBurns: 'Ken Burns (slow zoom)',

    content: 'Content',
    enterContent: 'Enter content',
    url: 'Url',
    enterUrl: 'Enter url',
    fontSize: 'Font size',
    chooseFontSize: 'Choose font size',
    stylePreset: 'Style preset',
    stylePresetHint: 'Apply a preset look',
    animation: 'Animation',
    animationHint: 'Entrance animation',
    color: 'Color',
    chooseColors: 'Choose colors',

    filter: 'Filter',
    cropImage: 'Crop image',
    nothingToAdd: 'Nothing to add yet',
    noLayers: 'No layers yet',
    bringForward: 'Bring forward',
    sendBackward: 'Send backward',

    responses: 'Responses',
    noResponses: 'No responses yet',
  },
  storyGroups: {
    stories: 'Stories',
    addStoryGroup: '+ Add story group',
    newStory: '+ New Story',
    previewGroup: 'Preview group',
    noStoriesYet: 'No stories yet',
    editGroup: 'Edit Group',
    duplicate: 'Duplicate',
    delete: 'Delete',
    preview: 'Preview',

    name: 'Name',
    content: 'Content',
    views: 'Views',
    behavior: 'Behavior',
    live: 'Live',

    cover: 'Cover',
    groupName: 'Name',
    enterGroupName: 'Enter story name',
    save: 'Save',

    behaviour: 'Behaviour',
    behaviourPermanent: 'Permanent',
    behaviourPermanentHint: 'Always available in the widget',
    behaviourDaily: 'Daily',
    behaviourDailyHint: 'Marked as seen once a day',
    behaviourOnce: 'Once',
    behaviourOnceHint: 'Hidden after a visitor watches it',

    widgets: 'Widgets',
    widgetsHint: 'Which widgets show this group',
    noWidgets: 'No widgets yet',
  },
};
